
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import {
  NavAidsCSVContent,
  NavaidDTOCalculation,
  NavaidModel,
  NavaidSitingToolModel,
  ScreeningAngRestrictions,
} from '../models/navaid';
import { Feature } from 'ol';
import Point from 'ol/geom/Point';
import * as olProj from 'ol/proj';
import {ModalControlService} from './modal-control.service';
import {UiBlockService} from './ui-block.service';
import {CoordinatePoint, CoordinatePointModel,} from '../models/coordinate-point';
import {EndpointsService} from './endpoints.service';
import {ProcedureDTOCalculation, ProcedureModel, WaypointsDTOCalculation} from '../models/procedure';
import LineString from 'ol/geom/LineString';
import * as fileSaver from 'file-saver';
import {MapService} from './map.service';
import {ParentLayers} from '../menu/view-menu/parent-layer';
import {TopLevelLayers} from '../menu/view-menu/top-level-layers';
import {AnnotationModel} from '../models/annotation';
import GeoJSON from 'ol/format/GeoJSON';
import {Layer, VectorLayerDMTR} from 'src/app/menu/view-menu/layer';
import VectorSource from 'ol/source/Vector';
import { CoordenateService } from './coordenate.service';
import { Circle as CircleStyle, Style, Stroke, Text, Fill, Icon, RegularShape } from 'ol/style';
import { ModalConfirmationService } from './modal-confirmation.service';
import Geometry from 'ol/geom/Geometry';
import Circle from 'ol/geom/Circle';
import { AnnotationType, AntennaTypes, FeatureType, NavaidStatus, NavaidTypes, ShapeType, UserLayerTypes } from '../models/EnumTypes';
import * as moment from 'moment';
import { ProcedureCoordinatePointModel } from '../models/procedure-coordinate-point';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CalculationModel } from '../models/calculations';
import { ErrorModel, UserSpaceLimitWarningMessage } from '../models/error';
import { AirSpaceBoundaryModel } from '../models/air-space-boundary';
import { ChannelFreqObject } from '../models/ChannelFreqObject';
import { FreqConversionUtil } from '../models/FreqConversionUtil';
import { TrajectoryModel } from '../models/Trajectory';
import { ProcedureLegModel } from '../models/procedure-leg';
import { clone, cloneDeep } from 'lodash';
import { coordinatePointTransformationOffsetResult } from '../models/coordinatePointTransformationOffsetResult';
import { UtilsService } from './utils.service';
import { CoordPointDuplicationWarningComponent } from '../popup/coord-point-duplication-warning/coord-point-duplication-warning.component';
import { SAAMAirSpace, SAAMRegion, SAAMVertex } from '../models/saamAirSpace';
import Polygon from 'ol/geom/Polygon';
import {ImportFileType} from '../models/ImportFileType';
import * as olExtent from 'ol/extent';

import { VertexType } from '../models/VertexType';
import { VertexTypeSelectionComponent } from '../popup/import/vertex-type-selection/vertex-type-selection.component';
import { AirSpaceBoundaryCoordinatePointModel } from '../models/air-space-boundary-coordinate-point';
import { FligthInspectionCSV } from '../models/flight-inspection';
import { FlightInspectionCSVFields } from '../models/ImportCSV';
import { color } from 'chart.js/helpers';
import { ColorInterval } from '../popup/flight-inspection-style/flight-inspection-style.component';
import { FligthInspectionDataModel } from '../models/FlightInspectionDataModel';
import { DynamicTable } from '../popup/dynamic-table/dynamic-table.component';
import { AeroDataConfigProcessingTool, EDS300Config, FligthInspectionConfig, WietzeToolConfig } from '../models/FligthInspectionConfig';
import { WietzeToolRowInfo } from '../models/WietzeToolRowInfo';
import { UserSettingsService } from './userSettings.service';
import { ColorOfType, LayerVisibility, UserLayer, UserSettings } from '../models/UserSettings';
import { Processingtool } from '../models/processingTool';
import { NavaidTextStyle, coordinatePointsSelectedLayer } from '../menu/view-menu/layersList';
import { ProjectService } from './project.service';
import { FilterModel } from '../models/filter';
import { OrFilter } from '../models/OrFilter';
import { AndFilter } from '../models/AndFilter';
import { CoordinatePointsFilterService } from './coordinate-points-filter.service';
import { icaoccModel } from '../models/icaoccModel';
import { NavaidsFilterService } from './navaids-filter.service';
import { ConfigurationService } from './configuration.service';
import KML from 'ol/format/KML';
import {Coordinate} from 'ol/coordinate';
import {TerrainHeightBulkDTO, TerrainHeightDTO} from '../models/terrainHeightDTO';
import {UserSpaceDTO} from '../models/UserSpaceDTO';
import MultiPolygon from 'ol/geom/MultiPolygon';
import MultiLineString from 'ol/geom/MultiLineString';
import { Source } from 'ol/source';
import {PendingCalculation} from '../models/pendingCalculation';
import {RouteSegmentsService} from './route-segments.service';
import { MultiPoint } from 'ol/geom';

//#region GRIT
import {ReceiverModel} from "../models/grit/grit.receiver-model";
import {InterferenceTestModel} from "../models/grit/grit.interference-test-model";
import {GritApiService} from "./grit/grit.api.service";
import {GritModel} from "../models/grit/grit.model";
import {GritFeature} from "../models/grit/grit.feature";
import {DeviceModel, InterferenceTestDeviceModel} from "../models/grit/grit.device-model";
import {GritFilter} from "../models/grit/grit.filter";
import {TabsService} from "./tabsService";
import {RadarModel} from "../models/grit/grit.radar-model";
import {ConfigurationColorService} from "./configuration-color-service";
import {GritDynamicTableMode, InterferenceTestModelStates} from "../models/grit/grit.enums";
import {SelectFeaturesComponent} from "../popup/grit/select-features/select-features.component";
import {GritUserService} from "./grit/grit.user.service";
import {GritInterferenceTestService} from "./grit/grit.interference-test.service";


//endregion

import { isToRemoveFromDLL } from '../models/RemoveGroundStationsDTO';
import { GroundStationsService } from './ground-stations.service';

import { create, fromBinary, toBinary, toJson } from "@bufbuild/protobuf";
import { CoordPointSchema } from 'src/generatedProto/CoordPoint_pb';
import { CoordPointListSchema } from 'src/generatedProto/CoordPointList_pb';
import { protobufPipe } from '../utils/pipes/protobufPipe';
import { Observable, firstValueFrom, lastValueFrom, of } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class PointsService {
  informationMessage: string;
  informationMessageCoordinatePoints: string;
  informationMessageNavaids: string;
  totalNavaidsInProject: number = 0;
  totalCoordinatePointsInProject: number = 0;
  allCoordinatePointsLoaded: boolean = false;

  // does not include navaids and coordinate points for performance reasons
  selectedFeatures: Array<Feature>;

  //selected navaids and coordinate points are stored here and only their ids are stored.
  selectedNavaids: Set<string>;
  selectedCoordinatePoints: Set<string>;

  procedures: Array<Feature>;
  airspaceBoundaries: Array<Feature>;
  annotations: Map<number, AnnotationModel>;
  navaidsLayers: ParentLayers;
  calculationsLayers: ParentLayers;
  coordinatePointsLayers: ParentLayers;
  airspaceboundariesLayers: ParentLayers;
  trajecttoriesLayers: ParentLayers;
  proceduresLayers: ParentLayers;
  areasLayers: ParentLayers;
  annotationLayers: ParentLayers;
  azimuthToolLayer: ParentLayers;
  rangeRingToolLayer: ParentLayers;
  horizonToolLayer: ParentLayers;
  procedureAnalysisLayer: ParentLayers;
  procedureGraphLayer: ParentLayers;
  dbBoundaryLayer: ParentLayers;
  crossSectionLayer: ParentLayers;
  staticLayer: ParentLayers;
  saamTrafficDensityLayer: ParentLayers;
  flightInspectionLayer: ParentLayers;
  processingToolLayer: ParentLayers;
  userLayers: ParentLayers;
  colorMap = new Map();
  ecacEnpIcaoCodes: icaoccModel[] = [];
  worldIcaoCodes: icaoccModel[] = [];
  showNavaidsIdOnMap = false;
  vectorSource: VectorSource = new VectorSource({

  });

  selectedProcedure: ProcedureModel; // used in performance analysis and vertical profile

  waypointsIndexToFeature: Map<number, Feature> = new Map();
  arpCivilIndexToFeature: Map<number, Feature> = new Map();
  arpMilitarIndexToFeature: Map<number, Feature> = new Map();
  arpMixedIndexToFeature: Map<number, Feature> = new Map();
  rwyThrIndexToFeature: Map<number, Feature> = new Map();
  airspaceVertexIndexToFeature: Map<number, Feature> = new Map();
  fixPointIndexToFeature: Map<number, Feature> = new Map();


  waypointsPublishedIndexToFeature: Map<number, Feature> = new Map();
  arpCivilPublishedIndexToFeature: Map<number, Feature> = new Map();
  arpMilitarPublishedIndexToFeature: Map<number, Feature> = new Map();
  arpMixedPublishedIndexToFeature: Map<number, Feature> = new Map();
  rwyThrPublishedIndexToFeature: Map<number, Feature> = new Map();
  airspaceVertexPublishedIndexToFeature: Map<number, Feature> = new Map();
  fixPointPublishedIndexToFeature: Map<number, Feature> = new Map();

  layerIdToCPIndexSelected: Map<string, number[]> = new Map();


  getAllCPIndexToFeatureMaps(): Map<number, Feature>[] {
    return [this.waypointsIndexToFeature, this.arpCivilIndexToFeature, this.arpMilitarIndexToFeature,
    this.arpMixedIndexToFeature, this.rwyThrIndexToFeature, this.airspaceVertexIndexToFeature, this.fixPointIndexToFeature,
    this.waypointsPublishedIndexToFeature, this.arpCivilPublishedIndexToFeature, this.arpMilitarPublishedIndexToFeature,
    this.arpMixedPublishedIndexToFeature, this.rwyThrPublishedIndexToFeature, this.airspaceVertexPublishedIndexToFeature,
    this.fixPointPublishedIndexToFeature];
  }

  clearIndexToFeatureMaps() {
    this.waypointsIndexToFeature.clear();
    this.arpCivilIndexToFeature.clear();
    this.arpMilitarIndexToFeature.clear();
    this.arpMixedIndexToFeature.clear();
    this.rwyThrIndexToFeature.clear();
    this.airspaceVertexIndexToFeature.clear();
    this.fixPointIndexToFeature.clear();

    this.waypointsPublishedIndexToFeature.clear();
    this.arpCivilPublishedIndexToFeature.clear();
    this.arpMilitarPublishedIndexToFeature.clear();
    this.arpMixedPublishedIndexToFeature.clear();
    this.rwyThrPublishedIndexToFeature.clear();
    this.airspaceVertexPublishedIndexToFeature.clear();
    this.fixPointPublishedIndexToFeature.clear();
  }

  //#region GRIT
  deviceLayer : ParentLayers;
  interferenceTestLayer : ParentLayers;
  radarLayer : ParentLayers;
  tabsService: TabsService;

  interferenceTestService: GritInterferenceTestService
  //endregion

  constructor(
    private http: HttpClient,
    private endpointService: EndpointsService,
    private modalService: ModalControlService,
    private uiBlock: UiBlockService,
    private mapService: MapService,
    public rcsControl: CoordenateService,
    private modalConfirmationService: ModalConfirmationService,
    private utilsService: UtilsService,
    public popupService: BsModalService,
    private modalConfirmation: ModalConfirmationService,
    private userSettingsService: UserSettingsService,
    private projectService: ProjectService,
    private coordinatePointsFilterService: CoordinatePointsFilterService,
    private navaidsFilterService: NavaidsFilterService,
    public configurationService: ConfigurationService,
    public configurationColorService: ConfigurationColorService,
    public routeSegmentsService: RouteSegmentsService,

    //#region GRIT
    private gritAPIService: GritApiService,
    private gritUserService: GritUserService,
    //endregion

    private readonly groundStationsService: GroundStationsService
    ) {

    this.selectedFeatures = [];
    this.selectedNavaids = new Set();
    this.selectedCoordinatePoints = new Set();
    this.procedures = [];
    this.annotations = new Map<number, AnnotationModel>();
    this.colorMap.set('Navaid Location Assessment', [
      new Fill({
        color: 'rgba(117, 115, 107,0.5)', //0 -  first index of array
      }),
      new Fill({
        color: 'rgba(246, 112, 104,0.5)', //1
      }),
      new Fill({
        color: 'rgba(245, 244, 109,0.5)', //2
      }),
      new Fill({
        color: 'rgba(117, 244, 107,0.5)', //3
      }),
      new Fill({
        color: 'rgba(121, 120, 235,0.5)', //4
      }),
    ]);
    this.colorMap.set('Subtended Angles', [
      new Fill({
        color: 'rgba(117, 115, 107,0.5)', //0 -  first index of array
      }),
      new Fill({
        color: 'rgba(245, 214, 206,0.5)', //1
      }),
      new Fill({
        color: 'rgba(246, 112, 104,0.5)', //2
      }),
      new Fill({
        color: 'rgba(245, 244, 109,0.5)', //3
      }),
      new Fill({
        color: 'rgba(121, 120, 235,0.5)', //4
      }),
      new Fill({
        color: 'rgba(217, 103, 218,0.5)', //5
      }),
      new Fill({
        color: 'rgba(117, 244, 107,0.5)', //6
      }),
    ]);

    this.colorMap.set('NSE', [
      new Fill({
        color: 'rgba(0, 255, 0,0.5)', //0 -  first index of array
      }),
      new Fill({
        color: 'rgba(80, 255, 80,0.5)', //1
      }),
      new Fill({
        color: 'rgba(130, 255, 130,0.5)', //2
      }),
      new Fill({
        color: 'rgba(200, 255, 200,0.5)', //3
      }),
      new Fill({
        color: 'rgba(255, 200, 200,0.5)', //4
      }),
      new Fill({
        color: 'rgba(255, 130, 130,0.5)', //5
      }),
      new Fill({
        color: 'rgba(255, 80, 80,0.5)', //6
      }),
      new Fill({
        color: 'rgba(255, 0, 0,0.5)', //7
      }),
      new Fill({
        color: 'rgba(117, 115, 107,0.5)', //8
      }),
    ]);

    this.colorMap.set('Available Pairs', [
      new Fill({
        color: 'rgba(117, 115, 107,0.5)', //0 -  first index of array
      }),
      new Fill({
        color: 'rgba(246, 112, 104,0.5)', //1
      }),
      new Fill({
        color: 'rgba(245, 244, 109,0.5)', //2
      }),
      new Fill({
        color: 'rgba(117, 244, 107,0.5)', //3
      }),
      new Fill({
        color: 'rgba(121, 120, 235,0.5)', //4
      }),
    ]);

    this.colorMap.set('Cumulative Coverage', [
      new Fill({
        color: 'rgba(9, 246, 247, 0.5)', //0 -  first index of array
      }),
      new Fill({
        color: 'rgba(9, 246, 247, 0.5)', //1 -  first index of array
      }),
      new Fill({
        color: 'rgba(0, 12, 249,0.5)', //2
      }),
      new Fill({
        color: 'rgba(241, 14, 15,0.5)', //3
      }),
      new Fill({
        color: 'rgba(255, 128, 64,0.5)', //4
      }),
      new Fill({
        color: 'rgba(255, 0, 255,0.5)', //5
      }),
      new Fill({
        color: 'rgba(0, 255, 255,0.5)', //6
      }),
      new Fill({
        color: 'rgba(0, 128, 0,0.5)', //7
      }),
      new Fill({
        color: 'rgba(255, 128, 255,0.5)', //8
      }),
      new Fill({
        color: 'rgba(255, 0, 128,0.5)', //9
      }),
      new Fill({
        color: 'rgba(128, 0, 255,0.5)', //10
      }),
      new Fill({
        color: 'rgba(229, 0, 0,0.5)', //11
      })
    ]);
  }
  getParentLayer(layerName: string) {
    switch (layerName) {
      case "Navaids": return this.navaidsLayers;
      case "Procedures": return this.proceduresLayers;
      case "Coordinate Points": return this.coordinatePointsLayers;
      case "Trajectories" : return this.trajecttoriesLayers;
      case "Air Space Boundary" : return this.airspaceboundariesLayers;
      case "SAAM Traffic Densities" :return this.saamTrafficDensityLayer;
      case "Route Segments" : return this.routeSegmentsService.routeSegmentLayers;
      //#region GRIT
      //TODO COLOR SETTINGS
      //endregion
      default: return;
    }
  }
  initializeVisibilities(userSettings: UserSettings){
    [this.navaidsLayers,this.proceduresLayers,this.coordinatePointsLayers,this.trajecttoriesLayers,this.airspaceboundariesLayers,this.saamTrafficDensityLayer,
      //#region GRIT
      this.deviceLayer, this.interferenceTestLayer, this.radarLayer,
      //endregion
    ]
    .forEach((parentLayer: ParentLayers) =>{
      let visibilityObject: any = this.userSettingsService.getVisibilityObjectOfLayer(parentLayer.name);
      if(visibilityObject){
        parentLayer.childLayers[0].layers
        .forEach((layer:Layer)=>{
            layer.visible = visibilityObject[layer.id];
            layer.olLayer.setVisible(visibilityObject[layer.id]);

            })
        }
      });
  }

  getNavaid(id: number | string): Observable<NavaidModel> {
    return this.http.get<NavaidModel>(
      this.endpointService.apiUrl + '/' + id,
      this.endpointService.httpOptions
    );
  }

  getNavaidsPartial(extent: [number, number, number, number]): Observable<NavaidModel[]> {
    const params = {
      minX: extent[0].toString(),
      minY: extent[1].toString(),
      maxX: extent[2].toString(),
      maxY: extent[3].toString(),
    }
    return this.http.get<ArrayBuffer>(this.endpointService.endpointPartialNavaids, {
      ...this.endpointService.httpOptions,
      params,
      responseType: "arraybuffer" as "json", // Receive binary data
    }).pipe(protobufPipe<NavaidModel>(NavaidModel));
  }

  getNavaids(): Observable<NavaidModel[]> {
    return this.http.get<ArrayBuffer>(this.endpointService.apiUrl, {
      ...this.endpointService.httpOptions,
      responseType: "arraybuffer" as "json", // Receive binary data
    }).pipe(protobufPipe<NavaidModel>(NavaidModel));
  }

  getNavaidsCount(): Observable<number> {
    return this.http.get<number>(this.endpointService.endpointNavaidsCount,
      this.endpointService.httpOptions
    );
  }

  fetchTotalNavaidsCount(): void {
    this.getNavaidsCount().subscribe((count) => {
      this.totalNavaidsInProject = count;
    });
  }

  getUserSpace(): Observable<{ [key: string]: UserSpaceDTO }> {

    return this.http.get<{ [key: string]: UserSpaceDTO }>(
      this.endpointService.userSpaceAPI,
      this.endpointService.httpOptions
    );
  }

  getAllUserSpaces(): Observable<UserSpaceDTO> {
    return this.http.get<UserSpaceDTO>(
      this.endpointService.userSpaceAPI + '/all',
      this.endpointService.httpOptions
  );
  }

  getCriticalNavaids(): Observable<NavaidModel[]> {
    return this.http.get<NavaidModel[]>(
      this.endpointService.endpointCriticalNavaids,
      this.endpointService.httpOptions
    );
  }

  getAllNavaidsFromLayers(): NavaidModel[] {
    let navaids: NavaidModel[] = [];
    this.navaidsLayers.childLayers[0].layers.forEach(layer => {
      layer.olLayer.getSource().getFeatures().forEach(feat => {
        navaids.push(this.transformFeatureInNavaid(feat));
      });
    });
    return navaids;
  }

  getRNAVNavaidFromLayersByOldUniqueID(navAidId: string, icaoCC: string, navType: string) {
    for (const layer of this.navaidsLayers.childLayers[0].layers) {
      for (const feat of layer.olLayer.getSource().getFeatures()) {
        if (feat.get("navaidid") == navAidId && feat.get("icaocc") == icaoCC && feat.get("navaidtype") == navType && NavaidModel.isRNAV(feat.get("navaidtype"))) {
          return this.transformFeatureInNavaid(feat);
        }
      }
    }
    return null;
  }
  getSelectedNavaids(): NavaidModel[] {
    let navaids: NavaidModel[] = [];
    this.getSelectedFeaturesOfType(FeatureType.Navaid).forEach((feat) => {
      navaids.push(this.transformFeatureInNavaid(feat));
    })
    return navaids;
  }
  getAllProceduresFeaturesFromLayers(): Feature[] {
    let procedures: Feature[] = [];
    this.proceduresLayers.childLayers[0].layers.forEach(layer => {
      layer.olLayer.getSource().getFeatures().forEach(feat => {
        procedures.push(feat);
      });
    });

    return procedures;
  }


  getAllProceduresModelsFromLayers(): ProcedureModel[] {
    let procedures: ProcedureModel[] = [];
    this.proceduresLayers.childLayers[0].layers.forEach(layer => {
      layer.olLayer.getSource().getFeatures().forEach(feat => {
        procedures.push(this.transformFeatureInProcedure(feat));
      });
    });

    return procedures;
  }


  getRNAVNavaids(selectedFeatures?: Feature<Geometry>[]): Feature[] {
    if (!selectedFeatures) {
      selectedFeatures = this.getSelectedFeaturesOfType(FeatureType.Navaid);
    }
    return selectedFeatures.filter((feature) => NavaidModel.isRNAV(feature.getProperties().navaidtype));
  }
  getSelectedNavaidsOfType(navaidtype: string): Feature[] {
    return this.getSelectedFeaturesOfType(FeatureType.Navaid).filter((feature) => feature.get('navaidtype') == navaidtype)
  }
  getRNAVNavaidModels(selectedFeatures?: Feature<Geometry>[]): NavaidModel[] {
    let navaids: NavaidModel[] = [];
    if (!selectedFeatures) {
      selectedFeatures = this.getSelectedFeaturesOfType(FeatureType.Navaid);
    }
    selectedFeatures
      .filter((feature) => NavaidModel.isRNAV(feature.getProperties().navaidtype))
      .forEach((feature) => navaids.push(this.transformFeatureInNavaid(feature)))
    return navaids;
  }
  getNonRNAVNavaidModels(selectedFeatures?: Feature<Geometry>[]): NavaidModel[] {
    let navaids: NavaidModel[] = [];
    if (!selectedFeatures) {
      selectedFeatures = this.getSelectedFeaturesOfType(FeatureType.Navaid);
    }
    selectedFeatures
      .filter((feature) => !NavaidModel.isRNAV(feature.getProperties().navaidtype))
      .forEach((feature) => navaids.push(this.transformFeatureInNavaid(feature)))
    return navaids;
  }

  getAllNavaidsFeaturesFromLayers(): Feature[] {
    let navaids: Feature[] = [];
    this.navaidsLayers.childLayers[0].layers.forEach(layer => {
      layer.olLayer.getSource().getFeatures().forEach(feat => {
        navaids.push(feat);
      });
    });
    return navaids;
  }

  getAllAirSpaceBoundaryFeaturesFromLayers(): Feature[] {
    let airspaceboundaries: Feature[] = [];
    const source = this.airspaceboundariesLayers.childLayers[0].layers
      .find((element) => element.id === 'Air_Space_Boundary')
      .olLayer.getSource();

    source.getFeatures().forEach(feat => {
      airspaceboundaries.push(feat);
    });
    return airspaceboundaries;
  }

  getAllAirSpaceBoundaryModelsFromLayers(): AirSpaceBoundaryModel[] {
    let airspaceboundaries: AirSpaceBoundaryModel[] = [];
    const source = this.airspaceboundariesLayers.childLayers[0].layers
      .find((element) => element.id === 'Air_Space_Boundary')
      .olLayer.getSource();

    source.getFeatures().forEach(feat => {
      airspaceboundaries.push(this.transformFeatureInAirspaceBoundary(feat));
    });
    return airspaceboundaries;
  }

  getNavaidFeatureFromLayersWithOldId(navaidId: string, navaidtype: string, icaocc: string): Feature {
    for (const layer of this.navaidsLayers.childLayers[0].layers) {
      for (const feat of layer.olLayer.getSource().getFeatures()) {
        if (feat.get('navaidid') == navaidId && feat.get('navaidtype') == navaidtype && feat.get('icaocc') == icaocc) {
          return feat;
        }
      }
    }
    return null;
  }

  getNavaidFeatureFromLayers(id: string): Feature {
    for (const layer of this.navaidsLayers.childLayers[0].layers) {
      for (const feat of layer.olLayer.getSource().getFeatures()) {
        if (feat.get('id') == id) {
          return feat;
        }
      }
    }
    return null;
  }

  getProcedureFeatureFromLayers(id: string): Feature {
    for (const layer of this.proceduresLayers.childLayers[0].layers) {
      for (const feat of layer.olLayer.getSource().getFeatures()) {
        if (feat.get('id') == id) {
          return feat;
        }
      }
    }
    return null;
  }

  getAirspaceBoundaryFeatureFromLayers(id: string): Feature {
    for (const layer of this.airspaceboundariesLayers.childLayers[0].layers) {
      for (const feat of layer.olLayer.getSource().getFeatures()) {
        if (feat.get('id') == id) {
          return feat;
        }
      }
    }
    return null;
  }

  getCoordinatePointFeatureFromLayersById(id: string): Feature {
    for (const indexToFeatureMap of this.getAllCPIndexToFeatureMaps()) {
      for (const feat of indexToFeatureMap.values()) {
        if (feat.get("id") == id) {
          return feat;
        }
      }
    }
    return null;
  }

  getCoordinatePointFeatureFromLayersByCoordinate(coordinate: Coordinate, layerId: string, published: boolean): Feature {
    const vectorSource: VectorSource = this.coordinatePointsLayers.childLayers[0].layers
      .find((element) => element.id === layerId)
      .olLayer.getSource();

    if (vectorSource.getFeatures() == null || vectorSource.getFeatures().length == 0) {
      return null;
    }
    const publishedIndex = this.getPublishedIndexForMultiPointVectorSource(vectorSource, published);
    const index = (vectorSource.getFeatures()[publishedIndex].getGeometry() as MultiPoint).getCoordinates()
      .findIndex(c => c[0] == coordinate[0] && c[1] == coordinate[1]);

    return this.getCoordinatePointFeatureMapFromLayer(layerId, published).get(index);
  }

  getCoordinatePointFeatureMapById(id: string): [number, Feature<Geometry>] {
    for (const indexToFeatureMap of this.getAllCPIndexToFeatureMaps()) {
      for (const [index, feat] of indexToFeatureMap.entries()) {
        if (feat.get("id") == id) {
          return [index, feat];
        }
        if (feat.get("uuid") == id) {
          return [index, feat];
        }
      }
    }
    return null;
  }


  getAllCoordinatePointsFeaturesFromLayers(): Feature[] {
    let coordinatePoints: Feature[] = [];
    for (const indexToFeatureMap of this.getAllCPIndexToFeatureMaps()) {
      coordinatePoints.push(...indexToFeatureMap.values());
    }
    return coordinatePoints;
  }


  getCoordinatePointFeatureMapFromLayer(cpLayer: string, published: boolean): Map<number, Feature<Geometry>> {
    switch (cpLayer) {
      case 'waypoint':
        if (published) {
          return this.waypointsPublishedIndexToFeature;
        }
        return this.waypointsIndexToFeature;
      case 'arp_civil':
        if (published) {
          return this.arpCivilPublishedIndexToFeature;
        }
        return this.arpCivilIndexToFeature;
      case 'arp_militar':
        if (published) {
          return this.arpMilitarPublishedIndexToFeature;
        }
        return this.arpMilitarIndexToFeature;
      case 'arp_mixed':
        if (published) {
          return this.arpMixedPublishedIndexToFeature;
        }
        return this.arpMixedIndexToFeature;
      case 'rwy_thr':
        if (published) {
          return this.rwyThrPublishedIndexToFeature;
        }
        return this.rwyThrIndexToFeature;
      case 'airspace_vertex':
        if (published) {
          return this.airspaceVertexPublishedIndexToFeature;
        }
        return this.airspaceVertexIndexToFeature;
      case 'fix_point':
        if (published) {
          return this.fixPointPublishedIndexToFeature;
        }
        return this.fixPointIndexToFeature;
      default: return new Map();
    }
  }

  getAllCalculationFeaturesFromLayer(childLayer: TopLevelLayers): Feature[] {
    let calculations: Feature[] = [];
    childLayer.layers.forEach(layer => {
      layer.olLayer.getSource().getFeatures().forEach(feat => {
        calculations.push(feat);
      });
    });

    return calculations;
  }

  getSelectedCoordinatePoints(): CoordinatePointModel[] {
    const coordPoints: CoordinatePointModel[] = [];
    this.layerIdToCPIndexSelected.forEach((indexes, layerId) => {
      const layerIdArray: [string, boolean] = JSON.parse(layerId);
      const mapIndexToFeature: Map<number, Feature<Geometry>> = this.getCoordinatePointFeatureMapFromLayer(layerIdArray[0], layerIdArray[1]);
     // indexes.forEach(index => coordPoints.push(this.transformFeatureInCoordinatePoint(mapIndexToFeature.get(index))))
     indexes.forEach(index => {
      const feature = mapIndexToFeature.get(index);
      if (feature) {
        coordPoints.push(this.transformFeatureInCoordinatePoint(feature));
      }
    });

    }
    );
    return coordPoints;
  }

  getSelectedCoordinatePointsFeatures(): Feature[] {
    const coordPoints: Feature[] = [];
    this.layerIdToCPIndexSelected.forEach((indexes, layerId) => {
      const layerIdArray: [string, boolean] = JSON.parse(layerId);
      const mapIndexToFeature: Map<number, Feature<Geometry>> = this.getCoordinatePointFeatureMapFromLayer(layerIdArray[0], layerIdArray[1]);
      //indexes.forEach(index => coordPoints.push(mapIndexToFeature.get(index)))
      indexes.forEach(index => {
      const feature = mapIndexToFeature.get(index);
      if (feature) {
        coordPoints.push(feature);
      }
    });
    }
    );
    return coordPoints;
  }


  getSelectedFeaturesOfType(type: FeatureType) {
    if (type == FeatureType.Navaid) {
      return this.getAllNavaidsFeaturesFromLayers().filter((feature) => this.selectedNavaids.has("" + feature.get('id')));
    }
    if (type == FeatureType.CoordinatePoint) {
      return this.getSelectedCoordinatePointsFeatures();
    }

    return this.selectedFeatures.filter((feature) => feature.getProperties().featureType == type)
  }
  removeCalculationFeaturesFromLayer(feats: Feature[], layer: Layer): void {
    if (feats != null) {
      feats.forEach(elm => {
        layer.olLayer.getSource().removeFeature(elm);
      });
    }
  }

  removePerformanceCalculationFeaturesFromLayer(feats: Feature[], layer: TopLevelLayers): void {
    if (feats != null) {
      feats.forEach(elm => {
        if (elm.getProperties().ID.includes('NSE') && layer.layers[0] != undefined) {
          let selected_layer = layer.layers.filter(layer => layer.id.includes('NSE'))[0];
          selected_layer.olLayer.getSource().removeFeature(elm);
        }
        if (elm.getProperties().ID.includes('PAIRS') && layer.layers[1] != undefined) {
          let selected_layer = layer.layers.filter(layer => layer.id.includes('PAIRS'))[0];
          selected_layer.olLayer.getSource().removeFeature(elm);
        }
        if (elm.getProperties().ID.includes('REDUNDANCY') && layer.layers[2] != undefined) {
          let selected_layer = layer.layers.filter(layer => layer.id.includes('Redundancy'))[0];
          selected_layer.olLayer.getSource().removeFeature(elm);
        }
        if (elm.getProperties().ID.includes('ANGLE') && layer.layers[3] != undefined) {
          let selected_layer = layer.layers.filter(layer => layer.id.includes('Subtended Angles'))[0];
          selected_layer.olLayer.getSource().removeFeature(elm);
        }
      });
    }
  }

  getCoordinatePointsPartial(extent: [number, number, number, number]): Observable<CoordinatePointModel[]> {
    const params = {
      minX: extent[0].toString(),
      minY: extent[1].toString(),
      maxX: extent[2].toString(),
      maxY: extent[3].toString(),
    }
    return this.http.get<ArrayBuffer>(this.endpointService.endpointPartialCoordinatePoints, {
      ...this.endpointService.httpOptions,
      params,
      responseType: "arraybuffer" as "json",
    }).pipe(protobufPipe<CoordinatePointModel>(CoordinatePointModel));
  }

  getCoordinatePoints(): Observable<CoordinatePoint[]> {
    return this.http.get<ArrayBuffer>(this.endpointService.apiUrlCoordinatePoints, {
      ...this.endpointService.httpOptions,
      responseType: "arraybuffer" as "json", // Receive binary data
    }).pipe(protobufPipe<CoordinatePoint>(CoordinatePointModel));
  }

  getCoordinatePointsCount(): Observable<number> {
    return this.http.get<number>(this.endpointService.endpointCoordinatePointsCount,
      this.endpointService.httpOptions
    );
  }

  fetchTotalCoordinatePointsCount(): void {
    this.getCoordinatePointsCount().subscribe((count) => {
      this.totalCoordinatePointsInProject = count;
    });
  }

  getCoordinatePoint(id: number | string): Observable<CoordinatePointModel> {
    return this.http.get<CoordinatePointModel>(
      this.endpointService.apiUrlCoordinatePoints + '/' + id,
      this.endpointService.httpOptions
    );
  }

  getProceduresPartial(extent: [number, number, number, number]): Observable<ProcedureModel[]> {
    const params = {
      minX: extent[0].toString(),
      minY: extent[1].toString(),
      maxX: extent[2].toString(),
      maxY: extent[3].toString(),
    }
    return this.http.get<ArrayBuffer>(this.endpointService.endpointPartialProcedures, {
      ...this.endpointService.httpOptions,
      params,
      responseType: "arraybuffer" as "json",
    }).pipe(protobufPipe<ProcedureModel>(ProcedureModel));
  }

  getProcedures(): Observable<ProcedureModel[]> {
    return this.http.get<ArrayBuffer>(this.endpointService.apiUrlProcedures, {
      ...this.endpointService.httpOptions,
      responseType: "arraybuffer" as "json", // Receive binary data
    }).pipe(protobufPipe<ProcedureModel>(ProcedureModel));
  }

  // getProcedures(): Observable<ProcedureModel[]> {
  //   return this.http.get<ProcedureModel[]>(
  //     this.endpointService.apiUrlProcedures,
  //     this.endpointService.httpOptions
  //   );
  // }

  getAirSpaceBoundariesPartial(extent: [number, number, number, number]): Observable<AirSpaceBoundaryModel[]> {
    const params = {
      minX: extent[0].toString(),
      minY: extent[1].toString(),
      maxX: extent[2].toString(),
      maxY: extent[3].toString(),
    }
    return this.http.get<ArrayBuffer>(this.endpointService.endpointPartialAirSpaceBoundaries, {
      ...this.endpointService.httpOptions,
      params,
      responseType: "arraybuffer" as "json",
    }).pipe(protobufPipe<AirSpaceBoundaryModel>(AirSpaceBoundaryModel));
  }

  getAirSpaceBoundaries(): Observable<AirSpaceBoundaryModel[]> {
    return this.http.get<ArrayBuffer>(this.endpointService.apiUrlAirSpaceBoundary, {
      ...this.endpointService.httpOptions,
      responseType: "arraybuffer" as "json", // Receive binary data
    }).pipe(protobufPipe<AirSpaceBoundaryModel>(AirSpaceBoundaryModel));
  }

  getAirSpaceBoundary(id: string): Observable<AirSpaceBoundaryModel> {
    return this.http.get<AirSpaceBoundaryModel>(
      this.endpointService.apiUrlAirSpaceBoundary + '/' + id,
      this.endpointService.httpOptions
    );
  }

  getAirSpaceBoundaryByID(id: string): Observable<AirSpaceBoundaryModel> {
    return this.http.get<AirSpaceBoundaryModel>(
      this.endpointService.apiUrlAirSpaceBoundary + "/" + id,
      this.endpointService.httpOptions
    );
  }

  getProcedureByID(id: string): Observable<ProcedureModel> {
    return this.http.get<ProcedureModel>(
      this.endpointService.apiUrlProcedures + "/" + id,
      this.endpointService.httpOptions
    );
  }

  getTrajectoriesPartial(extent: [number, number, number, number]): Observable<TrajectoryModel[]> {
    const params = {
      minX: extent[0].toString(),
      minY: extent[1].toString(),
      maxX: extent[2].toString(),
      maxY: extent[3].toString(),
    }
    return this.http.get<TrajectoryModel[]>(
      this.endpointService.endpointPartialTrajectories,
      {
        ...this.endpointService.httpOptions,
        params
      }
    );
  }

  getTrajectories(): Observable<TrajectoryModel[]> {
    return this.http.get<TrajectoryModel[]>(
      this.endpointService.apiUrlTrajectory,
      this.endpointService.httpOptions
    );
  }

  deleteNavaid(id: string): Observable<boolean> {
    this.http
      .delete<boolean>(
        this.endpointService.apiUrl + '/' + id,
        this.endpointService.httpOptions
      )
      .subscribe(
        () => {
          const navaidConfigIndex: number = this.configurationService.currentConfiguration.navaids.findIndex(p => p.id.toString() == id);
          if (navaidConfigIndex != -1) {
            this.configurationService.currentConfiguration.navaids.splice(navaidConfigIndex, 1);
          }
          return true;
        },
        (error) => {
          if (error && error.status == 401) {
            this.modalService.showMesssageModal(
              'Error Deleting',
              'Default Project is not editable.'
            )
            return false;
          }
          if (error && error.status == 409) {
            this.configurationService.showCalculationsOnGoingErrorMessage();
            return false;
          }
          this.modalService.showMesssageModal(
            'Error Deleting',
            `There was an error deleting the NavAids.`
          );
          return false;
        }
      );
    return of(false);
  }

  deleteNavaidBulk(navaidList: NavaidModel[]): Observable<boolean> {
    return this.http
      .post<boolean>(
        this.endpointService.endpointBulkDelete,
        JSON.stringify(navaidList),
        this.endpointService.jsonHttpOptions
      );
  }

  deleteSAAMBulk(ids: number[]): Observable<boolean> {
    return this.http
      .post<boolean>(
        this.endpointService.endpointBulkDeleteSAAMTraffic,
        JSON.stringify(ids),
        this.endpointService.jsonHttpOptions
      );
  }

  deleteFlightInspectionsBulk(ids: number[]): Observable<boolean> {
    const projectId = this.projectService.activeProject.id;
    return this.http
      .post<boolean>(
        this.endpointService.endpointBulkDeleteFlightInspectionTool,
        JSON.stringify(ids),
        {
        ...this.endpointService.jsonHttpOptions,
        params: { projectId: projectId }
        }
      );
  }

  deleteProcessingToolBulk(ids: number[]): Observable<boolean> {
    const projectId = this.projectService.activeProject.id;
    return this.http
      .post<boolean>(
        this.endpointService.endpointBulkDeleteProcessingTool,
        JSON.stringify(ids),
        {
        ...this.endpointService.jsonHttpOptions,
        params: { projectId: projectId }
        }
      );
  }

  deleteProcedureBulk(proceduresList: ProcedureModel[]): Observable<boolean> {
    return this.http
      .post<boolean>(
        this.endpointService.endpointBulkDeleteProcedure,
        JSON.stringify(proceduresList),
        this.endpointService.jsonHttpOptions
      );
  }

  deleteTrajectoriesBulk(ids: number[]): Observable<boolean> {
    return this.http
      .post<boolean>(
        this.endpointService.endpointBulkDeleteTrajectory,
        JSON.stringify(ids),
        this.endpointService.jsonHttpOptions
      );
  }

  deleteAirspaceBoundaryBulk(asbList: AirSpaceBoundaryModel[]): Observable<boolean> {
    return this.http
      .post<boolean>(
        this.endpointService.endpointBulkDeleteAirSpaceBoundary,
        JSON.stringify(asbList),
        this.endpointService.jsonHttpOptions
      );
  }

  deleteCoordinatePointsBulk(coordPointList: CoordinatePointModel[]): Observable<boolean> {
    return this.http
      .post<boolean>(
        this.endpointService.endpointBulkDeleteCoordinatePoints,
        JSON.stringify(coordPointList),
        this.endpointService.jsonHttpOptions
      );
  }

  async getTerrainElevation(latitude: number, longitude: number) {
    const terrainInformation = await this.calculateTerrainHeightAtPoint([longitude, latitude]).toPromise();
    if (terrainInformation != null) {
      return of<number>(terrainInformation["terrainHeigth"]);
    } else {
      throw new Error("Error performing Calculation: Could not get Elevation");
    };
  }

  calculateTerrainHeightAtPoint(coordinate: Coordinate, navaidId?: string) {
    const terrainHeightDTO = new TerrainHeightDTO();
    terrainHeightDTO.coordinate = coordinate;
    terrainHeightDTO.projectId = this.projectService.activeProject.id;
    navaidId ? terrainHeightDTO.navaidId = navaidId : terrainHeightDTO.navaidId = null;
    return this.http
      .post(
        this.endpointService.terrainHeightUrl,
        terrainHeightDTO,
        this.endpointService.httpOptions
      );
  }

  calculateTerrainHeightAtPointBulk(coordinates: Coordinate[], pendingCalculation: PendingCalculation, navaidIds?: string[]) {
    const terrainHeightDTO = new TerrainHeightBulkDTO();
    terrainHeightDTO.coordinates = coordinates;
    terrainHeightDTO.projectId = this.projectService.activeProject.id;
    terrainHeightDTO.pendingCalculation = pendingCalculation.mapToPendingCalculationDTO();
    navaidIds ? terrainHeightDTO.navaidIds = navaidIds : terrainHeightDTO.navaidIds = null;
    return this.http
      .post(
        this.endpointService.terrainHeightBulkUrl,
        terrainHeightDTO,
        this.endpointService.httpOptions
      );

  }

  getNavaidElevationMetersBulkInitialization(navaids: NavaidModel[], pendingCalculation: PendingCalculation) {
    try {
      const navaidsCoordinates: Coordinate[] = [];
      const navaidIds: string[] = [];
      for (const navaid of navaids) {
        navaidsCoordinates.push([navaid.longitude, navaid.latitude]);
        navaidIds.push(navaid.navaidid);
      }
      pendingCalculation.elevationType = this.configurationService.currentConfiguration.calculation.elevationType;
      // send http request to server. Actual response will be handled by ProgressService.
      this.calculateTerrainHeightAtPointBulk(navaidsCoordinates, pendingCalculation, navaidIds).subscribe({
        error: error => {
          if (error && error.status == 409) {
            this.modalService.showMesssageModal(
              'Calculation unsuccessful',
              'An active terrain is being uploaded, you cannot perform calculations. Please wait for it to finish.' +
              ' If this is not the case, please refresh the page.'
            );
          }
        }
      });
    } catch (e) {
      console.log("Error performing Calculation: Could not get Elevation");
      throw e;
    }
  }

  resumeGetNavaidElevationMetersBulk(terrainInformations: any, navaids: any[]) {
    if (terrainInformations != null && terrainInformations.length == navaids.length) {
      const toReturn: number[] = [];
      for (let i = 0; i < navaids.length; i++) {
        toReturn.push(Math.round(terrainInformations[i]["terrainHeigth"] + this.convertToMeters(navaids[i]._antheight)));
      }
      return toReturn;
    } else {
      throw new Error("Error performing Calculation: Could not get Elevation");
    }
  }

  getNavaidFeatureElevationMetersBulkInitialization(navaidFeatures: Feature<Geometry>[], pendingCalculation: PendingCalculation) {
    try {
      const navaidsCoordinates: Coordinate[] = [];
      const navaidIds: string[] = [];
      for (const navaidFeature of navaidFeatures) {
        navaidsCoordinates.push([navaidFeature.get('longitude'), navaidFeature.get('latitude')]);
        navaidIds.push(navaidFeature.get('navaidid'));
      }
      pendingCalculation.elevationType = this.configurationService.currentConfiguration.calculation.elevationType;
      // send http request to server. Actual response will be handled by ProgressService.
      this.calculateTerrainHeightAtPointBulk(navaidsCoordinates, pendingCalculation, navaidIds).subscribe({
        error: error => {
          if (error && error.status == 409) {
            this.modalService.showMesssageModal(
              'Calculation unsuccessful',
              'An active terrain is being uploaded, you cannot perform calculations. Please wait for it to finish.' +
              ' If this is not the case, please refresh the page.'
            );
          }
        }
      });
    } catch (e) {
      console.log("Error performing Calculation: Could not get Elevation");
      throw e;
    }
  }

  resumeGetNavaidFeatureElevationMetersBulk(terrainInformations: any, navaidFeatures: Feature<Geometry>[]) {
    if (terrainInformations != null && terrainInformations.length == navaidFeatures.length) {
      const toReturn: number[] = [];
      for (let i = 0; i<navaidFeatures.length; i++){
        toReturn.push(Math.round(terrainInformations[i]["terrainHeigth"] + this.convertToMeters(navaidFeatures[i].get('antheight') ?? 0)));
      }
      return toReturn;
    } else {
      throw new Error("Error performing Calculation: Could not get Elevation");
    }
  }

  async getNavaidElevationMeters(navaid: NavaidModel): Promise<number> {
    try {
      if (this.configurationService.currentConfiguration.calculation.elevationType == 'Relative') {
        const terrainInformation = await this.calculateTerrainHeightAtPoint([navaid.longitude, navaid.latitude]).toPromise();
        if (terrainInformation != null) {
          return terrainInformation["terrainHeigth"] + this.convertToMeters(navaid.antheight);
        } else {
          throw new Error("Error performing Calculation: Could not get Elevation");
        }
      } else {
        return +navaid.elevationMeters;
      }
    } catch (e) {
      console.log("Error performing Calculation: Could not get Elevation");
      throw e;
    }
  }

  async getNavaidFeatureElevationMeters(navaidFeature: Feature<Geometry>): Promise<number> {
    try {
      if (this.configurationService.currentConfiguration.calculation.elevationType == 'Relative') {
        const terrainInformation = await this.calculateTerrainHeightAtPoint([navaidFeature.get('longitude'), navaidFeature.get('latitude')]).toPromise();
        if (terrainInformation != null) {
          return terrainInformation["terrainHeigth"] + this.convertToMeters(navaidFeature.get('antheight'));
        } else {
          throw new Error("Error performing Calculation: Could not get Elevation");
        }
      } else {
        return this.convertToMeters(navaidFeature.get('elevation'));
      }
    } catch (e) {
      console.log("Error performing Calculation: Could not get Elevation");
      throw e;
    }
  }

  postValidationCoordinates(validationCoordinatesDTO: any): Observable<boolean> {
    validationCoordinatesDTO.projectId = this.projectService.activeProject.id;
    return this.http.post<boolean>(this.endpointService.apiUrlValidateCoordinates, validationCoordinatesDTO, this.endpointService.httpOptions);
  }

  transformFeatureInNavaid(
    arg0: Feature<import('ol/geom/Geometry').default>
  ): NavaidModel {
    let model: NavaidModel = new NavaidModel();
    model.navaidid = arg0.get('navaidid');
    model.name = arg0.get('name');
    model.latitude = arg0.get('latitude');
    model.longitude = arg0.get('longitude');
    model.elevation = arg0.get('elevation');
    model.antheight = arg0.get('antheight');
    model.doc = arg0.get('doc');
    model.maxaltitude = arg0.get('maxaltitude');
    model.maxaltitudeMeters = this.convertToMeters(arg0.get('maxaltitude'));
    model.cone = arg0.get('cone');
    model.id = arg0.get('id');
    model.icaocc = arg0.get('icaocc');
    model.navaidtype = arg0.get('navaidtype');
    model.infosrce = arg0.get('infosrce');
    model.elevationMeters = this.convertToMeters(
      arg0.get('elevation')
    ).toString()
    model.antheightMeters = this.convertToMeters(
      arg0.get('antheight')
    )
    model.antennatype = arg0.get('antennatype');
    model.arinc424fom = arg0.get('arinc424fom');

    model.bias = arg0.get('bias');
    model.cableloss = arg0.get('cableloss');
    model.channel = arg0.get('channel');
    model.declaredeirp = arg0.get('declaredeirp');
    model.dmetacanclass = arg0.get('dmetacanclass');
    model.dueforreplacement = arg0.get('dueforreplacement');
    model.equipmenttype = arg0.get('equipmenttype');
    model.fligthinspectioninterval = arg0.get('fligthinspectioninterval');
    model.infoupdate = arg0.get('infoupdate');
    model.lastinspection = arg0.get('lastinspection');
    model.losthreshold = arg0.get('losthreshold');
    model.manufacturer = arg0.get('manufacturer');
    model.maxload = arg0.get('maxload');
    model.meetingpost1989sarps = arg0.get('meetingpost1989sarps');
    model.model = arg0.get('model');
    model.mtbo = arg0.get('mtbo');
    model.ndbfrequency = arg0.get('ndbfrequency');
    model.notes = arg0.get('notes');
    model.notupdate = arg0.get('notupdate');
    model.offsetdist = arg0.get('offsetdist');
    model.operationalsince = arg0.get('operationalsince');
    model.operationalstatus = arg0.get('operationalstatus') != null ? arg0.get('operationalstatus').toUpperCase() : null;
    model.operator = arg0.get('operator');
    model.plannedinspection = arg0.get('plannedinspection');
    model.plannedremoval = arg0.get('plannedremoval');
    model.quiescentsquitterrate = arg0.get('quiescentsquitterrate');
    model.sectorizationtext = arg0.get('sectorizationtext');
    model.transmoutpower = arg0.get('transmoutpower');
    model.updated = arg0.get('updated');
    model.userdefined = !arg0.get('userdefined');
    model.usesectorization = arg0.get('usesectorization');
    model.vordocmaxrange = arg0.get('vordocmaxrange');
    model.vordueforreplace = arg0.get('vordueforreplace');
    model.vorinpectioninterval = arg0.get('vorinpectioninterval');
    model.vorlastinsp = arg0.get('vorlastinsp');
    model.vorlatitude = arg0.get('vorlatitude');
    model.vorlongitude = arg0.get('vorlongitude');
    model.vormanufacturer = arg0.get('vormanufacturer');
    model.vormodel = arg0.get('vormodel');
    model.voroperationalsince = arg0.get('voroperationalsince');
    model.voroperstatus = arg0.get('voroperstatus') != null ? arg0.get('voroperstatus').toUpperCase() : null;
    model.vorplannedinspection = arg0.get('vorplannedinspection');
    model.vorplannedremoval = arg0.get('vorplannedremoval');
    model.vortype = arg0.get('vortype') != null ? arg0.get('vortype').toUpperCase() : null;
    model.sectorizations = arg0.get('sectorizations');
    model.actualScreeningAngle = arg0.get('actualScreeningAngle');
    model.isselected = false;
    model.associatedAirspaceBoundaries = arg0.get('associatedAirspaceBoundaries') == null ? [] : arg0.get('associatedAirspaceBoundaries');
    model.antennaModelName = arg0.get("antennaModelName");

    if (arg0.get("effectiveHeight") != null) {
      model.effectiveHeight = arg0.get("effectiveHeight");
    }

    let resultingProcedures: ProcedureModel[] = [];
    let procedures: ProcedureModel[] = arg0.get('associatedProcedures');
    let criticalProcedures: ProcedureModel[] = arg0.get('associatedProceduresCritical');
    if (procedures != undefined && criticalProcedures != undefined) {
      procedures = procedures.concat(criticalProcedures);

      procedures.forEach(proc => {
        resultingProcedures.push(proc);
      });
    } else {
      procedures = [];
    }
    model.navaidFiles = arg0.get('navaidFiles');

    model.associatedProcedures = resultingProcedures;
    this.defineFrequenciesFromChannel(model);
    return model;
  }
  defineFrequenciesFromChannel(navaid: NavaidModel): void {
    let channelFreqObject: ChannelFreqObject = null;
    if (navaid != null) {
      channelFreqObject = FreqConversionUtil.findByChannel(navaid.channel);
    }

    if (channelFreqObject != null) {
      if (channelFreqObject.vorFreq != null) {
        navaid.vhfTunFreqInput = channelFreqObject.vorFreq.toString();
      }
      else {
        navaid.vhfTunFreqInput = null;
      }
      navaid.uhfUplinkFreqInput = channelFreqObject.uplinkFreq;
      navaid.uhfDownlinkFreqInput = channelFreqObject.downlinkFreq;
    }

    else if (navaid.vhfTunFreqInput == null && navaid.channel == null) {
      navaid.uhfDownlinkFreqInput = null;
      navaid.uhfUplinkFreqInput = null;
    }
  }
  convertToFeet(value: number): number {
    return Math.round((value / 0.3048) * 100) / 100;
  }

  convertToMeters(value: number): number {
    return Math.round((value / 3.2808) * 100) / 100;
  }

  convertCelciusToFahrenheit(value: number): number {
    return (value * 1.8 + 32.00);
  }

  convertFahrenheitToCelcius(value: number): number {
    return Math.round((value - 32) * 0.5556);
  }

  convertHpaToInHg(value: number): number {
    return value * 0.02952998330101;
  }

  convertInHgToHpa(value: number): number {
    return value / 0.02952998330101;
  }


  transformFeatureInCoordinatePoint(
    arg0: Feature<import('ol/geom/Geometry').default>
  ): CoordinatePointModel {
    let model: CoordinatePointModel = new CoordinatePointModel();
    model.id = arg0.get('id');
    model.coordpointid = arg0.get('coordpointid');
    model.name = arg0.get('name');
    model.type = arg0.get('type');
    model.latitude = arg0.get('latitude');
    model.longitude = arg0.get('longitude');
    model.minaltitude = arg0.get('minaltitude');
    model.minaltitudeMeters = this.convertToMeters(arg0.get('minaltitude'));
    model.maxaltitude = arg0.get('maxaltitude');
    model.maxaltitudeMeters = this.convertToMeters(arg0.get('maxaltitude'));
    model.nominalaltitude = arg0.get('nominalaltitude');
    model.nominalaltitudeMeters = this.convertToMeters(arg0.get('nominalaltitude'));
    model.notupdate = arg0.get('notupdate');
    model.updated = arg0.get('updated');
    model.userdefined = arg0.get('userdefined');
    model.configId = arg0.get('configId');
    model.projectId = arg0.get('projectId');
    model.composedName = arg0.get('coordpointid') + ' - ' + arg0.get('name');
    model.uuid = arg0.get('uuid') ? arg0.get('uuid') : null;
    return model;
  }

  transformFeatureInNavaidCalculationDTO(
    arg0: Feature<import('ol/geom/Geometry').default>
  ): NavaidDTOCalculation {
    let model: NavaidDTOCalculation = new NavaidDTOCalculation();
    model.id = arg0.get('navaidid');
    model.type = arg0.get('navaidtype');
    model.latitude = arg0.get('latitude');
    model.longitude = arg0.get('longitude');
    model.elevation = arg0.get('elevation');
    model.doc = arg0.get('doc');
    model.maxOperationalFL = arg0.get('maxaltitude');
    model.maxOperationalFL = model.maxOperationalFL / 100;
    model.maxaltitude = arg0.get('maxaltitude');
    model.coneOfSilenceAngle = arg0.get('cone');
    model.uniqueId =
      arg0.get('navaidid') +
      '_' +
      arg0.get('icaocc') +
      '_' +
      arg0.get('navaidtype');
    model.forceCalculation = false;
    model.mtbo = arg0.get('mtbo');
    model.LOSMarginAngle = arg0.get('0.0');
    model.vorDmeDocConstrain = arg0.get('vordocmaxrange');
    model.transmutPower = arg0.get('declaredeirp');
    model.usesKeyHoling = arg0.get('usesectorization');
    model.vorFrequency = 1070;
    model.screeningAngRestrictionsCount = 0;
    model.screeningAngRestrictions = arg0.get('actualScreeningAngle');
    model.sectorizations = arg0.get('sectorizations');
    model.sortedSectors = arg0.get('sectorizations');
    model.icaocc = arg0.get('icaocc');
    model.name = arg0.get('name');
    model.declaredEIRP = arg0.get('declaredeirp');
    model.channel = arg0.get("channel");
    model.antennaModelName = arg0.get('antennaModelName');
    model.antheightMeters = this.convertToMeters(
      arg0.get('antheight')
    )
    if (arg0.get('id')) {
      model.dataBaseId = arg0.get('id')
    }
    return model;
  }

  transformFeatureInProcedureCalculationDTO(arg0: Feature<import('ol/geom/Geometry').default>): ProcedureDTOCalculation {
    let model: ProcedureDTOCalculation = new ProcedureDTOCalculation();

    let rnavType = arg0.get('rnavperformancetype');

    switch (rnavType) {
      case "B_RNAV":
        model.rnavType = 0;
        break;
      case "P_RNAV":
        model.rnavType = 1;
        break;
      case "A_RNP":
        model.rnavType = 2;
        break;
    }

    let procedureType = arg0.get('proceduretype');

    if (procedureType.startsWith("assessment")) {
      procedureType = arg0.get('procedureid').substr(0, arg0.get('procedureid').indexOf('_'));
    }

    switch (procedureType) {
      case "SID":
        model.type = 0;
        break;
      case "STAR":
        model.type = 1;
        break;
      case "ENROUTE":
        model.type = 2;
        break;
    }

    let legs = arg0.get('procedurelegs');
    for (let index = 0; index < legs.length; index++) {
      // let procOffset = new ProcedureLegModel();
      // const shouldOffset = (legs[index].offset && legs[index].offset != 0.0) && (legs[index].direction && legs[index].direction != "NotSet");

      // if (shouldOffset) {
      //   const azimuthAngle = await this.getAzimuthAngle(legs[index].startPoint.coordPoint, legs[index].endPoint.coordPoint);
      //   const startCPoffset = await this.getCoordinateOffset(legs[index].startPoint.coordPoint, legs[index].offset, azimuthAngle, legs[index].direction);
      //   const endCPoffset = await this.getCoordinateOffset(legs[index].endPoint.coordPoint, legs[index].offset, azimuthAngle, legs[index].direction);

      //   procOffset.startPoint = cloneDeep(legs[index].startPoint);
      //   procOffset.startPoint.coordPoint = startCPoffset;
      //   procOffset.endPoint = cloneDeep(legs[index].endPoint);
      //   procOffset.endPoint.coordPoint = endCPoffset;
      // }


      if (index == 0) {
        let firstPoint = new WaypointsDTOCalculation();
        firstPoint.id = legs[index].startPoint.id;
        firstPoint.identification = legs[index].startPoint.coordPoint.coordpointid;
        firstPoint.name = legs[index].startPoint.coordPoint.name;
        firstPoint.fixpoint = false;
        // firstPoint.latitude = !shouldOffset ?  legs[index].startPoint.coordPoint.latitude : procOffset.startPoint.coordPoint.latitude;
        // firstPoint.longitude = !shouldOffset ? legs[index].startPoint.coordPoint.longitude : procOffset.startPoint.coordPoint.longitude;
        firstPoint.latitude = legs[index].startPoint.coordPoint.latitude;
        firstPoint.longitude = legs[index].startPoint.coordPoint.longitude;
        firstPoint.aircraftheight = this.feetToMeters(legs[index].startPoint.altitude);
        model.waypoints.push(firstPoint);

        if (!legs[index].isstraightleg) {
          let fixPoint = new WaypointsDTOCalculation();
          fixPoint.id = legs[index].fixPoint.id;
          fixPoint.identification = legs[index].fixPoint.coordPoint.coordpointid;
          fixPoint.name = legs[index].fixPoint.coordPoint.name;
          fixPoint.fixpoint = true;
          fixPoint.latitude = legs[index].fixPoint.coordPoint.latitude;
          fixPoint.longitude = legs[index].fixPoint.coordPoint.longitude;
          fixPoint.aircraftheight = this.feetToMeters(legs[index].fixPoint.altitude);
          model.waypoints.push(fixPoint);
        }

        let lastPoint = new WaypointsDTOCalculation();
        lastPoint.id = legs[index].endPoint.id;
        lastPoint.identification = legs[index].endPoint.coordPoint.coordpointid;
        lastPoint.name = legs[index].endPoint.coordPoint.name;
        lastPoint.fixpoint = false;
        // lastPoint.latitude = !shouldOffset ? legs[index].endPoint.coordPoint.latitude : procOffset.endPoint.coordPoint.latitude;
        // lastPoint.longitude = !shouldOffset ? legs[index].endPoint.coordPoint.longitude : procOffset.endPoint.coordPoint.longitude;
        lastPoint.latitude = legs[index].endPoint.coordPoint.latitude;
        lastPoint.longitude = legs[index].endPoint.coordPoint.longitude;
        lastPoint.aircraftheight = this.feetToMeters(legs[index].endPoint.altitude);
        model.waypoints.push(lastPoint);
        //first

      } else if (index == legs.length - 1) {

        if (!legs[index].isstraightleg) {
          let fixPoint = new WaypointsDTOCalculation();
          fixPoint.id = legs[index].fixPoint.id;
          fixPoint.identification = legs[index].fixPoint.coordPoint.coordpointid;
          fixPoint.name = legs[index].fixPoint.coordPoint.name;
          fixPoint.fixpoint = true;
          fixPoint.latitude = legs[index].fixPoint.coordPoint.latitude;
          fixPoint.longitude = legs[index].fixPoint.coordPoint.longitude;
          fixPoint.aircraftheight = this.feetToMeters(legs[index].fixPoint.altitude);
          model.waypoints.push(fixPoint);
        }

        let lastPoint = new WaypointsDTOCalculation();
        lastPoint.id = legs[index].endPoint.id;
        lastPoint.identification = legs[index].endPoint.coordPoint.coordpointid;
        lastPoint.name = legs[index].endPoint.coordPoint.name;
        lastPoint.fixpoint = false;
        // lastPoint.latitude = !shouldOffset ? legs[index].endPoint.coordPoint.latitude : procOffset.endPoint.coordPoint.latitude;
        // lastPoint.longitude = !shouldOffset ? legs[index].endPoint.coordPoint.longitude : procOffset.endPoint.coordPoint.longitude;
        lastPoint.latitude = legs[index].endPoint.coordPoint.latitude;
        lastPoint.longitude = legs[index].endPoint.coordPoint.longitude;
        lastPoint.aircraftheight = this.feetToMeters(legs[index].endPoint.altitude);
        model.waypoints.push(lastPoint);

      } else {

        if (!legs[index].isstraightleg) {
          let fixPoint = new WaypointsDTOCalculation();
          fixPoint.id = legs[index].fixPoint.id;
          fixPoint.identification = legs[index].fixPoint.coordPoint.coordpointid;
          fixPoint.name = legs[index].fixPoint.coordPoint.name;
          fixPoint.fixpoint = true;
          fixPoint.latitude = legs[index].fixPoint.coordPoint.latitude;
          fixPoint.longitude = legs[index].fixPoint.coordPoint.longitude;
          fixPoint.aircraftheight = this.feetToMeters(legs[index].fixPoint.altitude);
          model.waypoints.push(fixPoint);
        }

        let lastPoint = new WaypointsDTOCalculation();
        lastPoint.id = legs[index].endPoint.id;
        lastPoint.identification = legs[index].endPoint.coordPoint.coordpointid;
        lastPoint.name = legs[index].endPoint.coordPoint.name;
        lastPoint.fixpoint = false;
        // lastPoint.latitude = !shouldOffset ? legs[index].endPoint.coordPoint.latitude : procOffset.endPoint.coordPoint.latitude;
        // lastPoint.longitude = !shouldOffset ? legs[index].endPoint.coordPoint.longitude : procOffset.endPoint.coordPoint.longitude;
        lastPoint.latitude = legs[index].endPoint.coordPoint.latitude;
        lastPoint.longitude = legs[index].endPoint.coordPoint.longitude;
        lastPoint.aircraftheight = this.feetToMeters(legs[index].endPoint.altitude);
        model.waypoints.push(lastPoint);
      }
    }
    return model;
  }


  public feetToMeters(feet: any) {
    return feet * 0.3048;
  }

  setCalculationsLayer(calculationsLayers: ParentLayers) {
    this.calculationsLayers = calculationsLayers;
  }

  setAirSpaceBoundariesLayer(airspaceboundariesLayer: ParentLayers) {
    this.airspaceboundariesLayers = airspaceboundariesLayer;
  }

  setAzimuthToolLayer(azimuthToolLayer: ParentLayers) {
    this.azimuthToolLayer = azimuthToolLayer;
  }

  setRangeRingToolLayer(rangeRingToolLayer: ParentLayers) {
    this.rangeRingToolLayer = rangeRingToolLayer;
  }

  setHorizontalToolLayer(horizonToolLayer: ParentLayers) {
    this.horizonToolLayer = horizonToolLayer;
  }

  setProcedureAnalysisLayer(procedureAnalysisLayer: ParentLayers) {
    this.procedureAnalysisLayer = procedureAnalysisLayer;
  }

  setCrossSectionLayer(crossSectionLayer: ParentLayers) {
    this.crossSectionLayer = crossSectionLayer;
  }

  setProcedureGraphLayer(procedureGraphLayer: ParentLayers) {
    this.procedureGraphLayer = procedureGraphLayer;
  }

  set8dbBoundaryLayer(dbBoundaryLayer: ParentLayers) {
    this.dbBoundaryLayer = dbBoundaryLayer;
  }

  setTrajectoriesLayer(trajectorieslayer: ParentLayers) {
    this.trajecttoriesLayers = trajectorieslayer;
  }

  setProceduresLayer(proceduresLayer: ParentLayers) {
    this.proceduresLayers = proceduresLayer;
  }

  setNavaidsLayer(navaidsLayers: ParentLayers) {
    this.navaidsLayers = navaidsLayers;
  }
  setSAAMTrafficLayer(saamTrafficDensityLayer: ParentLayers) {
    this.saamTrafficDensityLayer = saamTrafficDensityLayer;
  }
  setFlightInspectionLayer(flightInspectionLayer: ParentLayers) {
    this.flightInspectionLayer = flightInspectionLayer;
  }
  setUserLayer(userLayers: ParentLayers) {
    this.userLayers = userLayers;
  }
  setProcessingToolLayer(processingToolLayer: ParentLayers) {
    this.processingToolLayer = processingToolLayer;
  }
  getAreasLayer(): ParentLayers {
    return this.areasLayers;
  }

  getAnnotationsLayer(): ParentLayers {
    return this.annotationLayers;
  }

  setAreasLayer(areasLayers: ParentLayers) {
    this.areasLayers = areasLayers;
  }

  setAnnotationLayer(annotationsLayers: ParentLayers) {
    this.annotationLayers = annotationsLayers;
  }

  getNavaidsLayer(): ParentLayers {
    return this.navaidsLayers;
  }

  setCoordinatePointsLayer(coordinatePointsLayers: ParentLayers) {
    this.coordinatePointsLayers = coordinatePointsLayers;
  }

  getCoordinatePointsLayer(): ParentLayers {
    return this.coordinatePointsLayers;
  }

  setStaticLayer(staticLayer: ParentLayers) {
    this.staticLayer = staticLayer;
  }

  getCalculationsLayer(): ParentLayers {
    return this.calculationsLayers;
  }

  getSelectedFeatures(): Array<Feature> {


    let toReturn = clone(this.selectedFeatures);

    toReturn.push(...this.getAllNavaidsFeaturesFromLayers()
      .filter((feature: Feature) => this.selectedNavaids.has("" + feature.get('id'))));

    toReturn.push(...this.getSelectedCoordinatePointsFeatures());

    return toReturn;
  }

  addSelectedFeature(feature: Feature): void {

    if (feature.get('featureType') == FeatureType.Navaid) {
      this.selectedNavaids.add("" + feature.get('id'));
    }
    else if (feature.get('featureType') == FeatureType.CoordinatePoint) {
      this.selectedCoordinatePoints.add("" + feature.get('id'));
    }
    else {
      this.selectedFeatures.push(feature);
    }
  }

  removeSelectedFeatureCoordinatePointFromLayer(index: number, layerId: string, published: boolean) {
    const indexes: number[] = this.layerIdToCPIndexSelected.get(JSON.stringify([layerId, published]));

    if (!indexes) {
      return;
    }

    const indexToBeRemoved: number = indexes.findIndex(i => i == index);

    if (indexToBeRemoved == -1) {
      return;
    }
    indexes.splice(indexToBeRemoved, 1)
    this.layerIdToCPIndexSelected.set(JSON.stringify([layerId, published]), indexes);

    const source = coordinatePointsSelectedLayer.olLayer.getSource();

    for (const feature of source.getFeatures()) {
      if (feature.get(CoordinatePointModel.INDEX_FEATURE_PROPERTY) == index
        && feature.get(CoordinatePointModel.LAYER_ID_FEATURE_PROPERTY) == layerId
        && feature.get(CoordinatePointModel.PUBLISHED_FEATURE_PROPERTY) == published) {
        source.removeFeature(feature);
        return;
      }
    }
  }

  removeSelectedFeature(feature: Feature): void {
    if (feature.get('featureType') == FeatureType.Navaid) {
      this.selectedNavaids.delete("" + feature.get('id'));
    }
    else if (feature.get('featureType') == FeatureType.CoordinatePoint) {
      const index: number = feature.get(CoordinatePointModel.INDEX_FEATURE_PROPERTY);
      const layerId: string = feature.get(CoordinatePointModel.LAYER_ID_FEATURE_PROPERTY);
      const published: boolean = feature.get(CoordinatePointModel.PUBLISHED_FEATURE_PROPERTY);
      if (index && layerId) {
        this.removeSelectedFeatureCoordinatePointFromLayer(index, layerId, published);
      }
    }
    else {
      this.selectedFeatures = this.selectedFeatures.filter((selectedFeature) => selectedFeature != feature);
    }
  }

  public clearArray<T>(array: T[]) {
    while (array.length) {
      array.pop();
    }
  }

  clearSelectedFeatures(): void {
    this.selectedFeatures = [];
    this.selectedNavaids.clear();
    this.clearSelectedCoordinatePoints();
  }

  clearSelectedCoordinatePoints(clearMapSelections: boolean = true) {
    coordinatePointsSelectedLayer.olLayer.getSource().clear();
    this.layerIdToCPIndexSelected.clear();
    clearMapSelections ? this.mapService.clearCoordinatePointsSelections() : false;
  }

  getLayerOfType(type: string, subType: string) {
    if (type == "Navaids") {
      return this.navaidsLayers.childLayers[0].layers
        .filter((element) => subType == 'All Navaids' ? true : element.id == subType.toLowerCase())
    }
    else if (type == "CoordinatePoints") {
      return this.coordinatePointsLayers.childLayers[0].layers
        .filter((element) => subType == 'All Coordinate Points' ? true : element.id == subType.toLowerCase());
    }
    else if (type == "Air_Space_Boundary") {
      return this.airspaceboundariesLayers.childLayers[0].layers
        .filter((element) => element.id == type);
    }
  }
  changeNavaidFeatureColor(layer: Layer, feature: Feature, userdefined: boolean, subType: string, color: string) {
    if (feature.getProperties().userdefined != userdefined && subType != 'all') {
      return;
    }
    let layerStyle: Style = (layer.olLayer.getStyle()) as Style;
    let iconSelected: Icon = (layerStyle.getImage() as Icon);
    let navaid: NavaidModel = this.transformFeatureInNavaid(feature);
    navaid.userdefined = !navaid.userdefined;
    let newFeature: Feature = this.createNavaidFeature(navaid, color == '' ? null : color);
    let style = new Style({
      image: new Icon({
        scale: layerStyle.getImage().getScale(),
        color: color == '' ? 'black' : color,
        src: iconSelected.getSrc(),
      }),
    });
    layer.olLayer.getSource().removeFeature(feature);
    newFeature.setStyle(style);
    layer.olLayer.getSource().addFeature(newFeature);
  }
  changeCoordinatePointFeatureColor(layer: Layer, feature: Feature, userdefined: boolean, subType: string, color: string) {
    if (feature.get(CoordinatePointModel.PUBLISHED_FEATURE_PROPERTY) == userdefined && subType != 'all') {
      return;
    }
    layer.olLayer.getSource().removeFeature(feature);
    this.setFeatureStyle(feature, layer, color);
    layer.olLayer.getSource().addFeature(feature);
  }

  setFeatureStyle(feature: Feature, layer: Layer, color: string) {
    const layerStyle: Style = (layer.olLayer.getStyle()) as Style;
    const iconSelected: Icon = (layerStyle.getImage() as Icon);
    const style = new Style({
      image: new Icon({
        scale: layerStyle.getImage().getScale(),
        color: color == '' ? 'black' : color,
        src: iconSelected.getSrc(),
      }),
    });
    feature.setStyle(style);
  }


  changeColorOfType(type: string, subType: string, userdefined: boolean, color: string) {
    this.getParentLayer(type)
      .childLayers[0].layers.filter(layer => layer.id == subType || subType == 'all')
      .forEach(layer => {
        layer.olLayer.getSource().getFeatures().forEach((feature) => {
          if (type == "Navaids") {
            this.changeNavaidFeatureColor(layer, feature, userdefined, subType, color);
          }
          else if (type == "Coordinate Points") {
            this.changeCoordinatePointFeatureColor(layer, feature, userdefined, subType, color)
          }
          else if (type == "Air Space Boundary") {
            let airspace: AirSpaceBoundaryModel = this.transformFeatureInAirspaceBoundary(feature);
            let newFeature: Feature = this.createAirSpaceBoundaryFeature(airspace, color);
            let style: Style = new Style({
              fill: new Fill({ color: color }),
              stroke: new Stroke({ color: color, width: 2 })
            });
            newFeature.setStyle(style)
            layer.olLayer.getSource().removeFeature(feature);
            layer.olLayer.getSource().addFeature(newFeature);
          }

        }
        )
      }
      );
  }
  createNavaid(navaidPayload: NavaidModel): boolean {
    this.uiBlock.startBlock("Saving Navaid...")
    this.http
      .post(
        this.endpointService.apiUrl,
        navaidPayload,
        this.endpointService.httpOptions
      )
      .subscribe(
        (data) => {
          if (data['errors'].length == 0) {
            //this.addNavaidToMap(data['navaid'] as NavaidModel);
            this.modalService.showMesssageModal("NavAid created", "The NavAid was created sucessfully!");
            //this.deleteAllProceduresFromMap();
            this.deleteNavaidsFromMap();
            // ---------
            // Get all navaids after importing
            // this.getNavaids()
            // ---------
            // OR
            // ---------
            // Get partial navaids results by extent
            // Usar fetchAndAddNavaids se o filtro estiver ativo
            this.fetchTotalNavaidsCount();

          if (this.navaidsFilterService.filters.some(f => f.active)) {

              this.fetchAndAddNavaids();
            } else {
              const extent = this.mapService.getCurrentExtent();
              this.fetchAndAddPartialNavaids(extent);
            }
            //this.fetchAndAddProcedures();
            //this.clearSelectedFeatures();
            this.uiBlock.stopBlock();
            return true;
          }
          else {
            let message: string = '';
            data['errors'].forEach(result => {
              if (message.length < 0) {
                message = message + result['message'] + ';';
              } else {
                message = message + ' ' + result['message'] + ';';
              }
            });
            this.modalService.showMesssageModal('Error Creating Navaid', message);
            this.uiBlock.stopBlock();
            return false;
          }
        },
        (error) => {
          this.uiBlock.stopBlock();
          if (error && error.status == 401) {
            this.modalService.showMesssageModal(
              'Error Saving',
              'Default Project is not editable.'
            )
            return false;
          }
          if (error && error.status == 409) {
            this.configurationService.showCalculationsOnGoingErrorMessage();
            return false;
          }
          this.modalService.showMesssageModal(
            'Error Saving',
            `There was an error saving the NavAid.`
          );
          return false;
        }
      );
    return true;
  }


  async saveNavaid(navaidPayload: NavaidModel): Promise<boolean> {
    this.uiBlock.startBlock("Saving Navaid...");
    const extent = this.mapService.getCurrentExtent();

    this.groundStationsService.removeGroundStations([navaidPayload], await lastValueFrom(this.getNavaids()), true);

    this.http
      .put(
        this.endpointService.apiUrl + '/' + navaidPayload.id,
        navaidPayload,
        this.endpointService.httpOptions
      )
      .subscribe(
        (data: any) => {
          if (Array.isArray(data) && data.some((result: any) => result.success === false)) {
            let errorMessages = data
              .filter((result: any) => result.success === false)
              .map((result: any) => result.message)
              .join('\n');
            this.modalService.showMesssageModal(
              'Error Saving',
              errorMessages
            );
            this.uiBlock.stopBlock();
            return false;
          }

          this.deleteNavaidsFromMap();
          // Usar fetchAndAddPartialNavaids que aplica filtros corretamente
          if (this.navaidsFilterService.filters.some(f => f.active)) {
              this.fetchAndAddNavaids();
            } else {
              const extent = this.mapService.getCurrentExtent();
              this.fetchAndAddPartialNavaids(extent);
            }

          this.deleteAllProceduresFromMap();
          // this.fetchAndAddProcedures();  // Get all OR


          this.fetchAndAddPartialProcedures(extent); // Get partial results by extent
          this.modalService.showMesssageModal("Navaid Saved", "The NavAid was saved sucessfully!")
          this.uiBlock.stopBlock();
          return true;
        },
        (error) => {
          if (error && error.status == 401) {
            this.modalService.showMesssageModal(
              'Error Saving',
              'Default Project is not editable.'
            )
            return false;
          }
          if (error && error.status == 409) {
            this.configurationService.showCalculationsOnGoingErrorMessage();
            return false;
          }
          this.modalService.showMesssageModal(
            'Error Saving',
            `There was an error saving the NavAid.`
          );
          this.uiBlock.stopBlock();
          return false;
        }
      );
    return true;
  }


  deleteNavaidsByUniqueId(type: string) {
    let source; // = navaidsLayers.layers.find(element => element.id === "dme").olLayer.getSource();
    switch (type) {
      case 'DME': {
        source = this.navaidsLayers.childLayers[0].layers
          .find((element) => element.id === 'dme')
          .olLayer.getSource();
        break;
      }
      case 'VOR/DME': {
        source = this.navaidsLayers.childLayers[0].layers
          .find((element) => element.id === 'vor_dme')
          .olLayer.getSource();
        break;
      }
      case 'VORTAC': {
        source = this.navaidsLayers.childLayers[0].layers
          .find((element) => element.id === 'vortac')
          .olLayer.getSource();
        break;
      }
      case 'TACAN': {
        source = this.navaidsLayers.childLayers[0].layers
          .find((element) => element.id === 'tacan')
          .olLayer.getSource();
        break;
      }
      case 'DME/ILS': {
        source = this.navaidsLayers.childLayers[0].layers
          .find((element) => element.id === 'dme_ils')
          .olLayer.getSource();
        break;
      }
      case 'NDB': {
        source = this.navaidsLayers.childLayers[0].layers
          .find((element) => element.id === 'ndb')
          .olLayer.getSource();
        break;
      }
      case 'VOR': {
        source = this.navaidsLayers.childLayers[0].layers
          .find((element) => element.id === 'vor')
          .olLayer.getSource();
        break;
      }
    }
    // var features = source.getFeatures();
    // this.selectedFeatures.forEach((feature) => {
    //   if (features != null && features.length > 0) {
    //     for (let x in features) {
    //       var properties = features[x].getProperties();
    //       var id = properties.id;
    //       if (id == feature.getProperties().id) {
    //         source.removeFeature(features[x]);
    //         break;
    //       }
    //     }
    //   }
    // });
  }

  getDefaultAntennaTypeOfNavaidType(navaid: NavaidModel) {
    switch (navaid.navaidtype) {
      case NavaidTypes.DME: return AntennaTypes.OMNIDIRECTIONAL;
      case NavaidTypes.VOR_DME: return AntennaTypes.OMNIDIRECTIONAL;
      case NavaidTypes.TACAN: return AntennaTypes.OMNIDIRECTIONAL;
      case NavaidTypes.VORTAC: return AntennaTypes.OMNIDIRECTIONAL;
      case NavaidTypes.DME_ILS: return AntennaTypes.SECTORIAL_DIRECTIONAL;
      default: return null;
    }
  }
  assignNavaidDefaultValues(navAidsList: NavaidModel[]) {
    for (let navaid of navAidsList) {
      navaid.antennatype = this.getDefaultAntennaTypeOfNavaidType(navaid);
    }
  }
  public importNavAids(navAidsList: NavaidModel[], format: string) {
    this.assignNavaidDefaultValues(navAidsList);

    const activeProjectId : number = this.configurationService.currentConfiguration.projectId;

    var promise = new Promise<void>((resolve, reject) => {
      this.uiBlock.startBlock(`Loading NavAids data from ${format} file...`);
      this.http
        .post<any[]>(
          `${this.endpointService.endpointImportNavaids}/${activeProjectId}`,
          navAidsList,
          this.endpointService.jsonHttpOptions,
          
        )
        .toPromise()
        .then(
          (res: ErrorModel[]) => {
            //check if there are any errors in response
            let errorMessages = [];
            res.forEach(response => {
              if (!response.success) {
                errorMessages.push(`${response.message}`);
              }
            });
            if (errorMessages.length > 0) {
              this.uiBlock.stopBlock();
              if (format == 'SAFIRE') {
                let validNavaids = cloneDeep(navAidsList.filter(navaid => !(navaid.name == null || navaid.name == '' || navaid.navaidid == null || navaid.navaidid == '')));
                errorMessages.forEach((message: string) => {
                  let navaidIdInErrorMessage = message.substring(message.indexOf(':') + 2, message.indexOf(' -'));

                  validNavaids = cloneDeep(validNavaids.filter((navaid: NavaidModel) => {
                    return navaidIdInErrorMessage != navaid.navaidid + '/' + navaid.name;
                  })
                  );
                })
                this.modalService.showMultipleMesssagesModal(
                  'Error importing',
                  errorMessages,
                  null,
                  (() => this.importNavAids(validNavaids, format)).bind(this)
                );
              }
              else {
                this.modalService.showMultipleMesssagesModal(
                  'Error importing',
                  errorMessages,
                );
                reject(errorMessages);
              }
              return;
            }
            if (format == "SAFIRE") {
              let acceptedButInvalidNavaids: NavaidModel[] = navAidsList.filter((navaid: NavaidModel) => navaid.maxaltitude > this.configurationService.currentConfiguration.facilityConfiguration.docMaxAltitudeFT)
              let ids = "";
              for (let navaid of acceptedButInvalidNavaids) {
                ids += navaid.navaidid + ", ";
              }
              ids = ids.substring(0, ids.length - 2);
              if (acceptedButInvalidNavaids.length > 0) {
                this.modalService.showMesssageModal("Warning!", `${acceptedButInvalidNavaids.length} navaids have max altitude value outside the correct range.
                Here are their ID's: \n` + ids)}
            }
            // Success
            //delete navaids from layers
            this.deleteNavaidsFromMap();
            //get navaids from database and add them to map
            let addNavaidsPromise = new Promise<void>((resolve, reject) => {
              // ---------
              // Get all navaids after importing
              // this.getNavaids()
              // ---------
              // OR
              // ---------
              // Get partial navaids results by extent
              const extent = this.mapService.getCurrentExtent();
              this.getNavaidsPartial(extent)
              // ---------
                .toPromise()
                .then(
                  (navaids) => {
                    navaids.forEach((element) => {
                      this.addNavaidToMap(element);
                    });
                    this.uiBlock.stopBlock();
                    this.modalService.showMesssageModal(
                      'Import successful',
                      'The NavAids were imported successfully.'
                    );
                    resolve();
                  },
                  (msg) => {
                    this.uiBlock.stopBlock();
                    this.modalService.showMesssageModal(
                      'Error importing',
                      `There was an error importing the NavAids. Please make sure you are importing the correct ${format} file.`
                    );
                    reject(msg);
                  }
                );
            });
            resolve();
          },
          (error) => {
            this.uiBlock.stopBlock();
            this.handleImportError(error, format, 'Navaids');
            reject(error);
          }
        );
    });
  }

  getDuplicates(coordPoint: CoordinatePointModel) {
    let coord_points: CoordinatePointModel[] = [];
    this.getAllCoordinatePointsFeaturesFromLayers().forEach(point => {
      coord_points.push(this.transformFeatureInCoordinatePoint(point));
    });
    return coord_points.filter((point) => CoordinatePointModel.duplicationCheckCondition(point, coordPoint))
  }

  getDuplicatesOfCPList(coordPoints: CoordinatePointModel[]) {
    let duplicates: CoordinatePointModel[] = this.getDuplicatesWithinList(coordPoints);
    let coordPointsOnMap: CoordinatePointModel[] = [];
    this.getAllCoordinatePointsFeaturesFromLayers().forEach(point => {
      coordPointsOnMap.push(this.transformFeatureInCoordinatePoint(point));
    });
    coordPoints.forEach((coordPoint: CoordinatePointModel) =>
      duplicates.push(...coordPointsOnMap.filter((coordPointOnMap: CoordinatePointModel) => CoordinatePointModel.duplicationCheckCondition(coordPoint, coordPointOnMap)))
    )
    return duplicates;
  }
  getDuplicatesWithinList(coord_points: CoordinatePointModel[]) {
    let duplicates: CoordinatePointModel[] = [];
    const processedIds = new Set<String>();

    for (let i = 0; i < coord_points.length - 1; i++) {
      if (processedIds.has(coord_points[i].coordpointid)) {
        continue;
      }

      processedIds.add(coord_points[i].coordpointid);
      let duplicateDetected = false;

      for (let j = i + 1; j < coord_points.length; j++) {
        if (CoordinatePointModel.duplicationCheckCondition(coord_points[i], coord_points[j])) {
          duplicates.push(coord_points[j]);
          duplicateDetected = true;
        }
      }

      if (duplicateDetected) {
        duplicates.push(coord_points[i]);
      }
    }
    return duplicates;
  }
  duplicateCPWarningModal(points: CoordinatePointModel[], proceedFunction, cancelFunction) {
    let duplicates: CoordinatePointModel[] = this.getDuplicatesOfCPList(points);
    if (duplicates.length == 0) {
      proceedFunction(points);
      return;
    }
    const bsRef: BsModalRef = this.popupService.show(CoordPointDuplicationWarningComponent, {
      backdrop: 'static' // Prevent closing on backdrop click
    });
    bsRef.content.duplicateCoordinatePoints = duplicates
    bsRef.content.onUserResponse.subscribe((result) => {
      switch (result) {
        case CoordPointDuplicationWarningComponent.CANCEL:
          cancelFunction(points);
          break;
        case CoordPointDuplicationWarningComponent.PROCEED:
          proceedFunction(points);
          break;
      }
    }
    )
  }

  importParsedCP(points: CoordinatePointModel[], importAerodromes?: File) {
    this.duplicateCPWarningModal(points,
      (points) => {
        this.uiBlock.startBlock('Loading Coordinate Points data from file...');
        const activeProjectId : number = this.configurationService.currentConfiguration.projectId;
        this.http.post(
          `${this.endpointService.endpointUploadCoordinatePoints}/${activeProjectId}`,
          points,
          this.endpointService.httpOptions,
        )
          .subscribe((res: ErrorModel[]) => {
            //check if there are any errors in response
            let errorMessages = [];
            res.forEach(response => {
              if (!response.success) {
                errorMessages.push(`${response.message}`);
              }
            });

            if (errorMessages.length > 0) {
              this.uiBlock.stopBlock();
              this.modalService.showMultipleMesssagesModal(
                'Error importing',
                errorMessages
              );
              return;
            }
            const extent = this.mapService.getCurrentExtent();

            this.selectedCoordinatePoints.clear();
            this.deleteCoordinatePointsFromMap();
            //this.fetchAndAddCoordinatePoints(); // Get all OR
            this.fetchAndAddPartialCoordinatePoints(extent); // Get partial results by extent
            this.coordinatePointsLayers.childLayers.forEach(child => {
              child.showAll();
            });
            // this.userSettingsService.userSettings.layerVisibilities
            // .find(element => element[0] == "Coordinate Points")[1]
            // .forEach(element => element.visible = true);
            // this.userSettingsService.updateSettings();
            this.uiBlock.stopBlock();
            if (importAerodromes) {
              this.uploadCP(importAerodromes, ImportFileType.AERODROMES_EAD_51, "XML");
              return;
            }
            this.modalService.showMesssageModal(
              'Import successful',
              'The Coordinate Points were imported successfully.'
            );
          },
            (error) => {
              this.uiBlock.stopBlock();
              this.handleImportError(error, "", 'Coordinate Points')
            }
          )
      },
      () => null
    )
  }

  uploadCP(fileToUpload: File, importType: ImportFileType, format: string) {
    const formData: FormData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    this.uiBlock.startBlock(`Parsing ${format} file...`);
    this.http
      .post(
        this.endpointService.endpointParseImportFileCoordinatePoints + '/' + importType,
        formData,
        this.endpointService.httpOptions
      )
      .subscribe((points: CoordinatePointModel[]) => {
        this.uiBlock.stopBlock();
        if (!points || points.length == 0) {
          this.modalService.showMesssageModal(
            'Error importing',
            `No available Coordinate Points in file. Please make sure you are importing the correct ${format} file.`
          );
          return;
        }
        this.importParsedCP(points);
      },
        (error) => {
          this.uiBlock.stopBlock();
          this.handleImportError(error, format);
        }
      );
  }

  exportCPXMLFileHttpRequest(identifiers: string, projectId: number = null) {
    return this.http
      .get<Blob>(this.endpointService.endpointDownloadCoordinatePoints, {
        headers: this.endpointService.httpOptions.headers,
        responseType: 'blob' as 'json',
        params: {
          "ids": identifiers != null ? identifiers : null,
          "projectId": projectId != null ? projectId.toString() : null
        }
      });
  }
  public exportCPXMLFile(identifiers: string) {
    this.uiBlock.startBlock('Exporting Coordinate Points into file...');

    this.exportCPXMLFileHttpRequest(identifiers)
      .subscribe(
        data => {
          var fileName = "ExportedCP_" + new Date().toISOString().slice(0, 19) + ".xml";
          this.downloadFile(data, fileName);
          this.modalService.showMesssageModal(
            'Export successfull',
            'The Coordinate Points were exported successfully.'
          );
          this.uiBlock.stopBlock();
        },
        error => {
          this.modalService.showMesssageModal(
            'Error exporting',
            'There was an error exporting the Coordinate Points. Please try again.'
          );
          this.uiBlock.stopBlock();
        },
        () => {
        }
      );
  }
  uploadNavaidsXMLHttpRequest(fileToUpload: File): Observable<NavaidModel[]> {
    const formData: FormData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    return this.http
      .post<NavaidModel[]>(
        this.endpointService.endpointParseImportFileNavaids + '/' + ImportFileType.NAVAIDS_XML,
        formData,
        this.endpointService.httpOptions
      )
  }
  getCoordinatePointsFromLegs(procedure: ProcedureModel): CoordinatePointModel[] {
    let points: CoordinatePointModel[] = [];
    points.push(procedure.procedureLegs[0].startPoint.coordPoint);

    procedure.procedureLegs
      .forEach((leg) => {
        points.push(leg.endPoint.coordPoint);
        if (leg.fixPoint != null && leg.fixPoint.coordPoint != null) {
          points.push(leg.fixPoint.coordPoint);
        }
      })
    return points;
  }


  public handleImportError(error, fileType: string = "", type?: string) {
    const extent = this.mapService.getCurrentExtent();


    if (error && error.status == 401) {
      this.modalService.showMesssageModal(
        'Error importing',
        'Default Project is not editable.'
      )
      return;
    }
    if (error && error.status == 409) {
      this.configurationService.showCalculationsOnGoingErrorMessage();
      return;
    }
    if (error && error.status == 507) {


      this.modalService.showMesssageModal(
        'Warning',
        UserSpaceLimitWarningMessage
      )
      if (type == null)
        return;
      switch (type) {
        case 'Navaids':
          this.deleteNavaidsFromMap();
          // this.fetchAndAddNavaids(); // Get all OR
          this.fetchAndAddPartialNavaids(extent); // Get partial results by extent
          break;
        case 'Coordinate Points':
          this.deleteCoordinatePointsFromMap();
          //this.fetchAndAddCoordinatePoints(); // Get all OR
          this.fetchAndAddPartialCoordinatePoints(extent); // Get partial results by extent
          break;
        case 'Procedures':
          this.deleteAllProceduresFromMap();
          //this.fetchAndAddProcedures(); // Get all OR
          this.fetchAndAddPartialProcedures(extent); // Get partial results by extent
          break
      }
      return;
    }
    if (!error || !error.error) {
      this.modalService.showMesssageModal(
        'Error importing',
        `There was an error importing the file. Please make sure you are importing the correct ${fileType} file.`
      )
      return;
    }
    if (error.error[0].code == "GE1") {
      this.modalService.showMesssageModal(
        'Error importing',
        error.error[0].message
      )
      return;
    }
    let errorMessages = [];
    error.error.forEach(response => {
      if (!response.success) {
        errorMessages.push(`${response.message} `)
      }
    });
    if (errorMessages) {
      this.modalService.showMultipleMesssagesModal(
        'Error importing',
        errorMessages
      );
    }
  }

  public uploadProcedure(fileToUpload: File) {
    const formData: FormData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    this.uiBlock.startBlock('Parsing XML file...');
    this.http
      .post(
        this.endpointService.endpointParseImportFileProcedures + '/' + ImportFileType.PROCEDURES_XML,
        formData,
        this.endpointService.httpOptions
      )
      .subscribe((procedures: ProcedureModel[]) => {
        this.uiBlock.stopBlock();
        if (!procedures || procedures.length == 0) {
          this.modalService.showMesssageModal(
            'Error importing',
            "No available Procedures in file. Please make sure you are importing the correct XML file."
          );
          return;
        }
        this.importProceduresFromUpload(procedures);
      }, (error) => {
        this.uiBlock.stopBlock();
        this.handleImportError(error, "XML");
      })
  }

  public uploadProcedureFromArinc424(fileToUpload: File) {
    const formData: FormData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    this.uiBlock.startBlock('Parsing ARINC 424 file...');
    this.http
      .post(
        this.endpointService.endpointParseImportFileProcedures + '/' + ImportFileType.PROCEDURES_ARINC424,
        formData,
        this.endpointService.httpOptions
      )
      .subscribe((procedures: ProcedureModel[]) => {
        this.uiBlock.stopBlock();
        this.importProceduresFromUpload(procedures);
      }, (error) => {
        this.uiBlock.stopBlock();
        this.handleImportError(error, "ARINC 424");
      })
  }

  public importProceduresFromUpload(procedures: ProcedureModel[]): void {
    let points: CoordinatePointModel[] = [];
    procedures.forEach((procedure) => {
      points.push(...this.getCoordinatePointsFromLegs(procedure));
    }
    )
    this.duplicateCPWarningModal(points,
      (points) => {
        this.uiBlock.startBlock('Loading Procedures data from file...');
        this.http.post(
          this.endpointService.endpointUploadProcedures,
          procedures,
          this.endpointService.httpOptions
        ).subscribe((res: ErrorModel[]) => {
          //check if there are any errors in response
          let errorMessages = [];
          res.forEach(response => {
            if (!response.success) {
              errorMessages.push(`${response.message}`);
            }
          });

          if (errorMessages.length > 0) {
            this.uiBlock.stopBlock();
            this.modalService.showMultipleMesssagesModal(
              'Error importing',
              errorMessages
            );
            return;
          }

          const extent = this.mapService.getCurrentExtent();

          this.deleteNavaidsFromMap();
          // this.fetchAndAddNavaids(); // Get all OR
          this.fetchAndAddPartialNavaids(extent); // Get partial results by extent

          this.deleteAllProceduresFromMap();
          // this.fetchAndAddProcedures(); // Get all OR
          this.fetchAndAddPartialProcedures(extent); // Get partial results by extent

          this.deleteCoordinatePointsFromMap();
          //this.fetchAndAddCoordinatePoints(); // Get all OR
          this.fetchAndAddPartialCoordinatePoints(extent); // Get partial results by extent

          this.zoomToProcedures(procedures)
          this.uiBlock.stopBlock();
          this.modalService.showMesssageModal(
            'Import successful',
            'The Procedure was imported successfully.'
          );
        },
          (error) => {
            this.uiBlock.stopBlock();
            this.handleImportError(error, "", 'Procedures');
          }
        )
      },
      () => this.uiBlock.stopBlock())
  }

  public postTrajectory(format: string, formData: FormData) {
    if (format == 'RVT') {
      return this.http
        .post(
          this.endpointService.endpointUploadTrajectory,
          formData,
          this.endpointService.httpOptions
        )
    }
    else {
      return this.http
        .post(
          this.endpointService.endpointUploadTrajectoryKMZ,
          formData,
          this.endpointService.httpOptions
        )


    }
  }
  public uploadTrajectory(fileToUpload: File, format: string, trajectory: TrajectoryModel, isNewProc: boolean) {
    const extent = this.mapService.getCurrentExtent();

    if (!fileToUpload.name.endsWith(format.toLowerCase())) {
      this.modalService.showMesssageModal(
        'Wrong format',
        `Choose a ${format} file`
      );
      return;
    }
    const formData: FormData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    formData.append('procedure', isNewProc ? "New Procedure" : trajectory.procedureName);
    formData.append('procedureType', trajectory.procedureType);
    formData.append('rnavPerformanceType', trajectory.procedureRnav);
    formData.append('trajectoryName', trajectory.name);

    this.uiBlock.startBlock(`Loading Trajectory data from ${format} file...`);
    this.postTrajectory(format, formData)
      .subscribe((trajectoryResult: TrajectoryModel) => {
        this.deleteTrajectoriesFromMap();
        // this.fetchAndAddTrajectories(); // Get all OR
        this.fetchAndAddPartialTrajectories(extent); // Get partial results by extent

        let trajectoryFeature: Feature = this.createTrajectoryFeature(trajectoryResult);
        this.mapService.getMap('map').getView().fit(trajectoryFeature.getGeometry().getExtent());
        this.uiBlock.stopBlock();
        this.modalService.showMesssageModal(
          'Import successful',
          'The Trajectory was imported successfully.'
        );
      }, (error) => {
        this.uiBlock.stopBlock();
        if (error && error.status == 401) {
          this.modalService.showMesssageModal(
            'Error importing',
            'Default Project is not editable.'
          )
          return;
        }
        this.modalService.showMesssageModal(
          'Error importing',
          `There was an error importing the trajectory. Please make sure you are importing the correct ${format} file.`
        );
      })
  }

  public uploadAirSpaceBoundary(fileToUpload: File) {
    const formData: FormData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    const extent = this.mapService.getCurrentExtent();

    this.uiBlock.startBlock('Loading Air Space Boundaries data from XML file...');
    this.http
      .post(
        this.endpointService.endpointUploadAirSpaceBoundary,
        formData,
        this.endpointService.httpOptions
      )
      .subscribe((res: ErrorModel[]) => {
        //check if there are any errors in response
        let errorMessages = [];
        res.forEach(response => {
          if (!response.success) {
            errorMessages.push(`${response.message}`);
          }
        });

        if (errorMessages.length > 0) {
          this.uiBlock.stopBlock();
          this.modalService.showMultipleMesssagesModal(
            'Error importing',
            errorMessages
          );
          return;
        }

        this.deleteNavaidsFromMap();
        // this.fetchAndAddNavaids(); // Get all OR
        this.fetchAndAddPartialNavaids(extent); // Get partial results by extent

        this.deleteAirSpaceBoundariesFromMap();
        // this.fetchAndAddAirSpaceBoundaries();  // Get all OR
        this.fetchAndAddPartialAirSpaceBoundaries(extent);  // Get partial results by extent

        this.deleteCoordinatePointsFromMap();
        //this.fetchAndAddCoordinatePoints(); // Get all OR
        this.fetchAndAddPartialCoordinatePoints(extent); // Get partial results by extent

        this.clearSelectedFeatures();
        this.uiBlock.stopBlock();
        this.modalService.showMesssageModal(
          'Import successful',
          'The Air Space Boundaries were imported successfully.'
        );
      }, (error) => {
        this.uiBlock.stopBlock();
        if (error && error.status == 401) {
          this.modalService.showMesssageModal(
            'Error Importing',
            'Default Project is not editable.'
          )
          return;
        }
        this.modalService.showMesssageModal(
          'Error importing',
          'There was an error importing the Air Space Boundaries. Please make sure you are importing the correct XML file.'
        );
      })
  }

  populateProceduresTable() {
    this.clearArray(this.procedures);
    this.getProcedures().forEach((procedureList) => {
      procedureList.forEach((procedureDb) => {

        //is the procedure form the db in the map?
        //if yes the proceure status if On mmap if not it is Not on Map
        let foundInMap = false;
        let procedureFoundInMap = null;
        this.proceduresLayers.childLayers[0].layers.forEach((element) => {
          let source = element.olLayer.getSource();
          var features = source.getFeatures();
          features.forEach((procedureMap) => {
            if (
              procedureDb.procedureid ==
              procedureMap.getProperties().procedureid
            ) {
              foundInMap = true;
              procedureFoundInMap = procedureMap;
            }
          });
        });

        if (foundInMap) {
          procedureFoundInMap.setProperties({ mapstatus: "On Map" });
          this.procedures.push(procedureFoundInMap);
        }
        else {
          let feat: Feature = this.createProcedureFeature(procedureDb);
          feat.setProperties({ mapstatus: "Not On Map" });
          this.procedures.push(feat);
        }
      });
    });
  }

  populateAirSpaceBoundaryTable() {
    this.clearArray(this.airspaceBoundaries);
    this.getAirSpaceBoundaries().forEach((airspaceList) => {
      airspaceList.forEach((airspaceDb) => {

        //is the procedure form the db in the map?
        //if yes the proceure status if On mmap if not it is Not on Map
        let foundInMap = false;
        let airspaceFoundInMap = null;
        this.airspaceboundariesLayers.childLayers[0].layers.forEach((element) => {
          let source = element.olLayer.getSource();
          var features = source.getFeatures();
          features.forEach((airspaceMap) => {
            if (airspaceDb.uniqueid == airspaceMap.getProperties().uniqueId) {
              foundInMap = true;
              airspaceFoundInMap = airspaceMap;
            }
          });
        });

        if (foundInMap) {
          airspaceFoundInMap.setProperties({ mapstatus: "On Map" });
          this.airspaceBoundaries.push(airspaceFoundInMap);
        }
        else {
          let feat: Feature = this.createAirSpaceBoundaryFeature(airspaceDb);
          feat.setProperties({ mapstatus: "Not On Map" });
          this.airspaceBoundaries.push(feat);
        }
      });
    });
  }
  exportNavaidsXMLFileHttpRequest(identifiers: string, includeNavaidFiles: boolean = false, projectId: number = null) {
    return this.http
      .get<Blob>(this.endpointService.endpointDownload, {
        headers: this.endpointService.httpOptions.headers,
        responseType: 'blob' as 'json',
        params: {
          "ids": identifiers != null ? identifiers : null,
          "projectId": projectId != null ? projectId.toString() : null,
          "includeFiles": JSON.stringify(includeNavaidFiles)
        }
      });
  }
  public exportNavaidsXMLFile(identifiers: string, includeNavaidFiles: boolean = false) {
    this.uiBlock.startBlock('Exporting Navaids to file...');

    this.exportNavaidsXMLFileHttpRequest(identifiers, includeNavaidFiles)
      .subscribe(
        data => {
          var fileName = "ExportedNavaids_" + new Date().toISOString().slice(0, 19) + ".xml";
          this.downloadFile(data, fileName);
          this.modalService.showMesssageModal(
            'Export successfull',
            'The Navaids were exported successfully.'
          );
          this.uiBlock.stopBlock();
        },
        error => {
          this.modalService.showMesssageModal(
            'Error exporting',
            'There was an error exporting the Navaids. Please try again.'
          );
          this.uiBlock.stopBlock();
        },
        () => {
        }
      );
  }

  public exportAirSpaceBoundariesXMLFile(identifiers: string, projectId: number = null) {
    this.uiBlock.startBlock('Exporting Air Space Boundaries to file...');

    this.http
      .get<Blob>(this.endpointService.endpointDownloadAirSpaceBoundary, {
        headers: this.endpointService.httpOptions.headers,
        responseType: 'blob' as 'json',
        params: {
          "ids": identifiers != null ? identifiers : null,
          "projectId": projectId != null ? projectId.toString() : null
        }
      })
      .subscribe(
        data => {
          var fileName = "ExportedAirSpaceBoundaries_" + new Date().toISOString().slice(0, 19) + ".xml";
          this.downloadFile(data, fileName);
          this.modalService.showMesssageModal(
            'Export successfull',
            'The Air Space Boundaries were exported successfully.'
          );
          this.uiBlock.stopBlock();
        },
        error => {
          this.modalService.showMesssageModal(
            'Error exporting',
            'There was an error exporting the Air Space Boundaries. Please try again.'
          );
          this.uiBlock.stopBlock();
        },
        () => {
        }
      );
  }
  exportProceduresXMLFileHttpRequest(identifiers: string, projectId: number = null) {
    return this.http
      .get<Blob>(this.endpointService.endpointDownloadProcedures, {
        headers: this.endpointService.httpOptions.headers,
        responseType: 'blob' as 'json',
        params: {
          "ids": identifiers != null ? identifiers : null,
          "projectId": projectId != null ? projectId.toString() : null
        }
      });
  }
  public exportProceduresXMLFile(identifiers: string) {
    this.uiBlock.startBlock('Exporting Procedures to file...');

    this.exportProceduresXMLFileHttpRequest(identifiers)
      .subscribe(
        data => {
          this.uiBlock.stopBlock();
          if (data == null || data.size == 0) {
            this.modalService.showMesssageModal(
              'Error exporting',
              'There was an error exporting the Procedures. Please try again.'
            );
            return;
          }
          var fileName = "ExportedProcedures_" + new Date().toISOString().slice(0, 19) + ".xml";
          this.downloadFile(data, fileName);
          this.modalService.showMesssageModal(
            'Export successfull',
            'The Procedures were exported successfully.'
          );
        },
        error => {
          this.modalService.showMesssageModal(
            'Error exporting',
            'There was an error exporting the Procedures. Please try again.'
          );
          this.uiBlock.stopBlock();
        },
        () => {
        }
      );
  }

  exportAirSpaceBoundariesXMLFileHttpRequest(identifiers: string, projectId: number = null) {
    return this.http
      .get<Blob>(this.endpointService.endpointDownloadAirSpaceBoundary, {
        headers: this.endpointService.httpOptions.headers,
        responseType: 'blob' as 'json',
        params: {
          "ids": identifiers != null ? identifiers : null,
          "projectId": projectId != null ? projectId.toString() : null
        }
      });
  }
  exportAreasXMLFileHttpRequest() {
    return this.http
      .get<Blob>(this.endpointService.areasXMLDownload, {
        headers: this.endpointService.httpOptions.headers,
        responseType: 'blob' as 'json',
      })
  }
  exportAnnotationsXMLFileHttpRequest() {
    return this.http
      .get<Blob>(this.endpointService.annotationsXMLDownload, {
        headers: this.endpointService.httpOptions.headers,
        responseType: 'blob' as 'json',
      })
  }
  exportTrajectoryXMLFileHttpRequest() {
    return this.http
      .get<Blob>(this.endpointService.endpointDownloadTrajectoryXML, {
        headers: this.endpointService.httpOptions.headers,
        responseType: 'blob' as 'json',
      })
  }
  public downloadFile(data: Blob, fileName: string) {
    fileSaver.saveAs(data, fileName);
  }

  public deleteProcedureFromMap(procedure: Feature): void {
    this.proceduresLayers.childLayers[0].layers.forEach((element) => {
      let source = element.olLayer.getSource();
      var features = source.getFeatures();
      features.forEach((procedureMap) => {
        if (
          procedure.getProperties().procedureid ==
          procedureMap.getProperties().procedureid
        ) {
          source.removeFeature(procedureMap);
        }
      });
    });
  }

  public deleteProcedureModelFromMap(procedure: ProcedureModel): void {
    this.proceduresLayers.childLayers[0].layers.forEach((element) => {
      let source = element.olLayer.getSource();
      var features = source.getFeatures();
      features.forEach((procedureMap) => {
        if (
          procedure.procedureid ==
          procedureMap.getProperties().procedureid
        ) {
          source.removeFeature(procedureMap);
        }
      });
    });
  }
  public deleteSaamAirSpaceFromMap(saamairspace: SAAMAirSpace) {
    let source = this.saamTrafficDensityLayer.childLayers[0].layers[0].olLayer.getSource();
    let features = source.getFeatures();
    features.forEach((feature) => {
      if (feature.get('id') == saamairspace.Id) {
        source.removeFeature(feature);
      }
    })
  }
  public deleteAirSpaceBoundaryModelFromMap(airspace: AirSpaceBoundaryModel): void {
    this.proceduresLayers.childLayers[0].layers.forEach((element) => {
      let source = element.olLayer.getSource();
      var features = source.getFeatures();
      features.forEach((airspaceMap) => {
        if (
          airspace.uniqueid ==
          airspaceMap.getProperties().uniqueId
        ) {
          source.removeFeature(airspaceMap);
        }
      });
    });
  }
  public deleteTrajectoryModelFromMap(trajectoryToRemove: TrajectoryModel): void {
    this.trajecttoriesLayers.childLayers[0].layers.forEach((element) => {
      let source = element.olLayer.getSource();
      var features = source.getFeatures();
      features.forEach((trajectoryOnMap) => {
        if (trajectoryToRemove.uniqueid === trajectoryOnMap.getProperties().uniqueid) {
          source.removeFeature(trajectoryOnMap);
        }
      });
    });
  }

  public deleteProceduresFeaturesFromMap(feats: Feature[]): void {
    let source; // = navaidsLayers.layers.find(element => element.id === "dme").olLayer.getSource();
    feats.forEach((feature) => {
      switch (feature.getProperties().proceduretype) {
        case 'SID': {
          source = this.proceduresLayers.childLayers[0].layers
            .find((element) => element.id === 'sid')
            .olLayer.getSource();
          break;
        }
        case 'STAR': {
          source = this.proceduresLayers.childLayers[0].layers
            .find((element) => element.id === 'star')
            .olLayer.getSource();
          break;
        }
        case 'ENROUTE': {
          source = this.proceduresLayers.childLayers[0].layers
            .find((element) => element.id === 'enroute')
            .olLayer.getSource();
          break;
        }
        case 'ASSESSMENT': {
          source = this.proceduresLayers.childLayers[0].layers
            .find((element) => element.id === 'assessment')
            .olLayer.getSource();
          break;
        }
        default: {
          break;
        }
      }

      var features = source.getFeatures();
      if (features != null && features.length > 0) {
        for (let x in features) {
          var properties = features[x].getProperties();
          var id = properties.id;
          if (id == feature.getProperties().id) {
            source.removeFeature(features[x]);
            this.removeSelectedFeature(features[x]);
            break;
          }
        }
      }
    });
  }

  public deleteNavaids(feats: any): void {
    this.uiBlock.startBlock("Deleting Navaids...");
    let source; // = navaidsLayers.layers.find(element => element.id === "dme").olLayer.getSource();
    let criticalNavaidProperties: any[] = [];
    let navaids: NavaidModel[] = [];

    for (let feature of feats) {
      const nav: NavaidModel = this.transformFeatureInNavaid(feature);
      const navaidPayload: NavaidModel = this.getNavaidPayload(nav);
      navaidPayload.associatedProcedures = feature.get("associatedProcedures");
      navaidPayload.associatedAirspaceBoundaries = feature.get("associatedAirspaceBoundaries");
      navaids.push(navaidPayload);
      if (feature.get("associatedProceduresCritical") != null && feature.get("associatedProceduresCritical").length > 0) {
        criticalNavaidProperties.push(feature.getProperties());
      }
    }

    if (criticalNavaidProperties.length != 0) {
      let bodyErrorMessage: string = "Critical NavAids:\n\n";
      for (let i = 0; i < criticalNavaidProperties.length; i++) {
        for (let j = 0; j < criticalNavaidProperties[i].associatedProceduresCritical.length; j++)
          bodyErrorMessage += `NavAid: ${criticalNavaidProperties[i].name} - Procedure ${criticalNavaidProperties[i].associatedProceduresCritical[j].name}\n`
      }
      this.modalService.showMesssageModal("Selected NavAids will not be deleted", bodyErrorMessage);
      this.uiBlock.stopBlock();
      return;
    }

    this.deleteNavaidBulk(navaids).subscribe(
      (result) => {
        for (let feature of feats) {
          switch (feature.get("navaidtype")) {
            case 'DME': {
              source = this.navaidsLayers.childLayers[0].layers
                .find((element) => element.id === 'dme')
                .olLayer.getSource();
              break;
            }
            case 'VOR_DME': {
              source = this.navaidsLayers.childLayers[0].layers
                .find((element) => element.id === 'vor_dme')
                .olLayer.getSource();
              break;
            }
            case 'VORTAC': {
              source = this.navaidsLayers.childLayers[0].layers
                .find((element) => element.id === 'vortac')
                .olLayer.getSource();
              break;
            }
            case 'TACAN': {
              source = this.navaidsLayers.childLayers[0].layers
                .find((element) => element.id === 'tacan')
                .olLayer.getSource();
              break;
            }
            case 'DME_ILS': {
              source = this.navaidsLayers.childLayers[0].layers
                .find((element) => element.id === 'dme_ils')
                .olLayer.getSource();
              break;
            }
            case 'NDB': {
              source = this.navaidsLayers.childLayers[0].layers
                .find((element) => element.id === 'ndb')
                .olLayer.getSource();
              break;
            }
            case 'VOR': {
              source = this.navaidsLayers.childLayers[0].layers
                .find((element) => element.id === 'vor')
                .olLayer.getSource();
              break;
            }
          }

          source.removeFeature(feature);
          this.removeSelectedFeature(feature);
        }

        for (const navaid of navaids) {
          const navaidConfigIndex: number = this.configurationService.currentConfiguration.navaids.findIndex(p => p.id == navaid.id);
          if (navaidConfigIndex != -1) {
            this.configurationService.currentConfiguration.navaids.splice(navaidConfigIndex, 1);
          }
          // update procedures associated navaids list
          if (navaid.associatedProcedures != null && navaid.associatedProcedures.length > 0) {
            for (const associatedProcedure of navaid.associatedProcedures) {
              const procedureFeature: Feature<Geometry> = this.getProcedureFeatureFromLayers(associatedProcedure.id.toString());
              const procedureNavaids: NavaidModel[] = procedureFeature.get('navaids');
              if (procedureNavaids != null && procedureNavaids.length > 0) {
                const index = procedureNavaids.findIndex(n => n.id == navaid.id);
                if (index != -1) {
                  procedureNavaids.splice(index, 1)
                  procedureFeature.set("navaids", procedureNavaids);
                }
              }
            }
          }
          // update airspace boundaries associated navaids list
          if (navaid.associatedAirspaceBoundaries != null && navaid.associatedAirspaceBoundaries.length > 0) {
            for (const associatedAirspaceBoundary of navaid.associatedAirspaceBoundaries) {
              const airspaceFeature: Feature<Geometry> = this.getAirspaceBoundaryFeatureFromLayers(associatedAirspaceBoundary.id.toString());
              const airspaceNavaids: NavaidModel[] = airspaceFeature.get('navaids');
              if (airspaceNavaids != null && airspaceNavaids.length > 0) {
                const index = airspaceNavaids.findIndex(n => n.id == navaid.id);
                if (index != -1) {
                  airspaceNavaids.splice(index, 1)
                  airspaceFeature.set("navaids", airspaceNavaids);
                }
              }
            }
          }
        }
        this.fetchTotalNavaidsCount();
        this.modalService.showMesssageModal("Navaids Deleted", "Navaids deleted with success.");
        this.uiBlock.stopBlock();
      },
      (error) => {
        this.uiBlock.stopBlock();
        if (error && error.status == 401) {
          this.modalService.showMesssageModal(
            'Error Deleting',
            'Default Project is not editable.'
          )
          return;
        }
        if (error && error.status == 409) {
          this.configurationService.showCalculationsOnGoingErrorMessage();
          return;
        }
        this.modalService.showMesssageModal(
          'Error Deleting',
          `Error deleting navaids.`
        );
      })
  }

  public deleteNavaidFeaturesFromMap(feats: any) {
    let source; // = navaidsLayers.layers.find(element => element.id === "dme").olLayer.getSource();
    for (const feature of feats) {
      switch (feature.getProperties().navaidtype) {
        case 'DME': {
          source = this.navaidsLayers.childLayers[0].layers
            .find((element) => element.id === 'dme')
            .olLayer.getSource();
          break;
        }
        case 'VOR_DME': {
          source = this.navaidsLayers.childLayers[0].layers
            .find((element) => element.id === 'vor_dme')
            .olLayer.getSource();
          break;
        }
        case 'VORTAC': {
          source = this.navaidsLayers.childLayers[0].layers
            .find((element) => element.id === 'vortac')
            .olLayer.getSource();
          break;
        }
        case 'TACAN': {
          source = this.navaidsLayers.childLayers[0].layers
            .find((element) => element.id === 'tacan')
            .olLayer.getSource();
          break;
        }
        case 'DME_ILS': {
          source = this.navaidsLayers.childLayers[0].layers
            .find((element) => element.id === 'dme_ils')
            .olLayer.getSource();
          break;
        }
        case 'NDB': {
          source = this.navaidsLayers.childLayers[0].layers
            .find((element) => element.id === 'ndb')
            .olLayer.getSource();
          break;
        }
        case 'VOR': {
          source = this.navaidsLayers.childLayers[0].layers
            .find((element) => element.id === 'vor')
            .olLayer.getSource();
          break;
        }
      }

      const features = source.getFeatures();
      if (features != null && features.length > 0) {
        //const featureToRemove = features.find(x => x.getProperties().id == feature.getProperties().id);
        if (feature != null) {
          source.removeFeature(feature);
          this.removeSelectedFeature(feature);
        }
      }

    };
  }

  public deleteNavaidsFromMap(): void {

    this.navaidsLayers.childLayers.forEach(function (childLayer: TopLevelLayers) {
      for (let layer of childLayer.layers) {
        layer.olLayer.getSource().clear();
      }
    });
  }
  public deleteSAAMLayersFromMap() {
    this.saamTrafficDensityLayer.childLayers.forEach(function (childLayer: TopLevelLayers) {
      for (let layer of childLayer.layers) {
        layer.olLayer.getSource().clear();
      }
    });
  }
  public deleteAssessmentProcedureFromMap(procedure: ProcedureModel): void {
    const source = this.proceduresLayers.childLayers[0].layers
      .find((element) => element.id === 'assessment')
      .olLayer.getSource();

    let features = source.getFeatures().filter((feature) => feature.get('id') == procedure.id);
    if (features != null && features.length > 0) {

      features.forEach((feature) =>
        source.removeFeature(feature)
      )
    }
    this.removeProcedureOffSetFromMap(procedure);
    // this.proceduresLayers.childLayers[0].layers.forEach((element) => {
    //   let source = element.olLayer.getSource();
    //   var features = source.getFeatures();
    //   features.forEach((procedureMap) => {
    //     if ( procedure.procedureid == procedureMap.getProperties().procedureid) {
    //       source.removeFeature(procedureMap);

    //     }
    //   });
    // });

  }

  public deleteProceduresFromMap(): void {
    /*this.proceduresLayers.childLayers[0].layers.forEach((element) => {
      let source = element.olLayer.getSource();
      this.selectedFeatures.forEach((feature) => {
        var features = source.getFeatures();
        if (features != null && features.length > 0) {
          for (let x in features) {
            var properties = features[x].getProperties();
            //console.log(properties);
            var id = properties.id;
            if (id == feature.getProperties().id) {
              //this.deleteCoordinatePoint(feature.get("id"));
              source.removeFeature(features[x]);
              break;
            }
          }
        }
      });
    });*/
    this.proceduresLayers.childLayers.forEach(function (childLayer: TopLevelLayers) {
      for (let layer of childLayer.layers) {
        layer.olLayer.getSource().clear();
      }
    });
  }

  public deleteCoordinatePointsFromMap(): void {
    this.coordinatePointsLayers.childLayers.forEach(function (childLayer: TopLevelLayers) {
      for (let layer of childLayer.layers) {
        layer.olLayer.getSource().clear();
      }
    });
    this.clearIndexToFeatureMaps();
    this.clearSelectedCoordinatePoints();
    this.allCoordinatePointsLoaded = false;
  }

  public deleteTrajectoriesFromMap(): void {
    this.trajecttoriesLayers.childLayers.forEach(function (childLayer: TopLevelLayers) {
      for (let layer of childLayer.layers) {
        layer.olLayer.getSource().clear();
      }
    });
  }

  public deleteAllProceduresFromMap(): void {
    this.proceduresLayers.childLayers.forEach(function (childLayer: TopLevelLayers) {
      for (let layer of childLayer.layers) {
        layer.olLayer.getSource().clear();
      }
    });
  }

  public deleteCoordinatePoints(coordinatePoints: CoordinatePointModel[]): void {
    this.uiBlock.startBlock("Deleting Coordinate Points...")
    this.deleteCoordinatePointsBulk(coordinatePoints).subscribe(
      async (result) => {
        this.clearSelectedCoordinatePoints();
        this.deleteCoordinatePointsFromMap();
        this.fetchTotalCoordinatePointsCount();
        await this.fetchAndAddCoordinatePoints();
        for (const cp of coordinatePoints) {
          const cpConfigIndex: number = this.configurationService.currentConfiguration.coordPoints.findIndex(c => c.id == cp.id);
          if (cpConfigIndex != -1) {
            this.configurationService.currentConfiguration.coordPoints.splice(cpConfigIndex, 1);
          }
        }
        this.modalService.showMesssageModal("Coordinate Points Deleted", "Coordinate points deleted with success.");
        this.uiBlock.stopBlock();
      },
      (error) => {
        this.uiBlock.stopBlock();
        if (error && error.status == 401) {
          this.modalService.showMesssageModal(
            'Error Deleting',
            'Default Project is not editable.'
          )
          return;
        }
        this.modalService.showMesssageModal(
          'Error Deleting',
          `Error deleting the selected coordinate points.`
        );
      }
    );

  }


  public getLayerIdFromCoordPointType(coordPointType: string): string {
    switch (coordPointType) {
      case 'WAYPOINT':
        return 'waypoint';
      case 'ARP_CIVIL':
        return 'arp_civil';
      case 'ARP_MILITAR':
        return 'arp_militar';
      case 'ARP_MIXED':
        return 'arp_mixed';
      case 'RWY_THR':
        return 'rwy_thr';
      case 'AIRSPACE_BOUNDARY_VERTEX':
        return 'airspace_vertex';
      case 'FIX_POINT':
        return 'fix_point';
      default:
        return "";
    }
  }

  public getLayerFromCoordPointType(coordPointType: string): Layer {
    switch (coordPointType) {
      case 'WAYPOINT':
        return this.coordinatePointsLayers.childLayers[0].layers
          .find((element) => element.id === 'waypoint');
      case 'ARP_CIVIL':
        return this.coordinatePointsLayers.childLayers[0].layers
          .find((element) => element.id === 'arp_civil');
      case 'ARP_MILITAR':
        return this.coordinatePointsLayers.childLayers[0].layers
          .find((element) => element.id === 'arp_militar');
      case 'ARP_MIXED':
        return this.coordinatePointsLayers.childLayers[0].layers
          .find((element) => element.id === 'arp_mixed');
      case 'RWY_THR':
        return this.coordinatePointsLayers.childLayers[0].layers
          .find((element) => element.id === 'rwy_thr');
      case 'AIRSPACE_BOUNDARY_VERTEX':
        return this.coordinatePointsLayers.childLayers[0].layers
          .find((element) => element.id === 'airspace_vertex');
      case 'FIX_POINT':
        return this.coordinatePointsLayers.childLayers[0].layers
          .find((element) => element.id === 'fix_point');
      default:
        return null;
    }
  }

  public deleteCoordinatePointsFeatures(feats: Feature[]): void {
    let indexToFeatureMap: Map<number, Feature<Geometry>>;
    let layer: Layer;
    // sort features by type and published
    feats.sort((a: Feature, b: Feature) => {
      const typeA = a.get("type");
      const typeB = b.get("type");

      const publishedA = a.get("userdefined") ? 1 : 0; // 0 for published, 1 for not published
      const publishedB = b.get("userdefined") ? 1 : 0;

      // First compare by type
      const typeComparison = typeA.localeCompare(typeB);

      // If types are the same, compare by published status
      if (typeComparison === 0) {
        return publishedA - publishedB;
      }

      return typeComparison;
    });
    let coordinates: Coordinate[];
    for (let i = 0; i < feats.length; i++) {
      const feature = feats[i];
      const published: boolean = !feature.get("userdefined");
      switch (feature.getProperties().type) {
        case 'WAYPOINT':
          layer = this.coordinatePointsLayers.childLayers[0].layers
            .find((element) => element.id === 'waypoint')


          if (published) {
            indexToFeatureMap = this.waypointsPublishedIndexToFeature;
          } else {
            indexToFeatureMap = this.waypointsIndexToFeature;
          }

          break;
        case 'ARP_CIVIL':
          layer = this.coordinatePointsLayers.childLayers[0].layers
            .find((element) => element.id === 'arp_civil')

          if (published) {
            indexToFeatureMap = this.arpCivilPublishedIndexToFeature;
          } else {
            indexToFeatureMap = this.arpCivilIndexToFeature;
          }

          break;
        case 'ARP_MILITAR':
          layer = this.coordinatePointsLayers.childLayers[0].layers
            .find((element) => element.id === 'arp_militar')

          if (published) {
            indexToFeatureMap = this.arpMilitarPublishedIndexToFeature;
          } else {
            indexToFeatureMap = this.arpMilitarIndexToFeature;
          }

          break;
        case 'ARP_MIXED':
          layer = this.coordinatePointsLayers.childLayers[0].layers
            .find((element) => element.id === 'arp_mixed')

          if (published) {
            indexToFeatureMap = this.arpMixedPublishedIndexToFeature;
          } else {
            indexToFeatureMap = this.arpMixedIndexToFeature;
          }

          break;
        case 'RWY_THR':
          layer = this.coordinatePointsLayers.childLayers[0].layers
            .find((element) => element.id === 'rwy_thr')

          if (published) {
            indexToFeatureMap = this.rwyThrPublishedIndexToFeature;
          } else {
            indexToFeatureMap = this.rwyThrIndexToFeature;
          }

          break;
        case 'AIRSPACE_BOUNDARY_VERTEX':
          layer = this.coordinatePointsLayers.childLayers[0].layers
            .find((element) => element.id === 'airspace_vertex')

          if (published) {
            indexToFeatureMap = this.airspaceVertexPublishedIndexToFeature;
          } else {
            indexToFeatureMap = this.airspaceVertexIndexToFeature;
          }

          break;
        case 'FIX_POINT':
          layer = this.coordinatePointsLayers.childLayers[0].layers
            .find((element) => element.id === 'fix_point')

          if (published) {
            indexToFeatureMap = this.fixPointPublishedIndexToFeature;
          } else {
            indexToFeatureMap = this.fixPointIndexToFeature;
          }

          break;
        default:
          this.modalService.showMesssageModal("Error", "There was an error removing the Coordinate Point from the map.");
          return;
      }
      const vectorSource = layer.olLayer.getSource();
      const publishedIndex = this.getPublishedIndexForMultiPointVectorSource(vectorSource, published);
      if (!coordinates) {
        coordinates = (vectorSource.getFeatures()[publishedIndex].getGeometry() as MultiPoint).getCoordinates();
      }
      const featCoord: Coordinate = olProj.fromLonLat([feature.get("longitude"), feature.get("latitude")], this.mapService.getMaps().getView().getProjection());
      let featIndex = -1;
      for (const [index, featureIte] of indexToFeatureMap) {
        if (feature.get("id") == featureIte.get("id")) {
          featIndex = index;
          indexToFeatureMap.delete(index);
        }
      }
      if (featIndex == -1) {
        return;
      }
      // Create a temporary array to store the changes that need to be made on indexMap
      const updates: [number, Feature][] = [];

      for (let [index, featureIte] of indexToFeatureMap) {
        if (featIndex < index) {
          updates.push([index - 1, featureIte]);
        }
      }

      // Apply the updates: first remove the old keys, then set the new ones
      for (let [index, featureIte] of updates) {
        indexToFeatureMap.delete(index + 1);  // Remove the old key (original index)
        indexToFeatureMap.set(index, featureIte);  // Set the new key
      }

      coordinates = coordinates.filter(c => c[0] != featCoord[0] || c[1] != featCoord[1]);

      // if feature is the last element of list or the last element of a given type, update layer
      if (i == feats.length - 1 || feats[i + 1].get("type") != feature.get("type") || feats[i + 1].get("userdefined") != feature.get("userdefined")) {
        this.createAndAddMultiPointFeatureToLayer(coordinates, layer, published);
        coordinates = null;
      }

    };
  }

  public deleteAirSpaceBoundariesFromMap(): void {
    this.airspaceboundariesLayers.childLayers.forEach(function (childLayer: TopLevelLayers) {
      for (let layer of childLayer.layers) {
        layer.olLayer.getSource().clear();
      }
    });
  }

  private updateNavaidsAssociatedAirspace(airspace: AirSpaceBoundaryModel) {
    const allNavaidsOnMap: Feature<Geometry>[] = this.getAllNavaidsFeaturesFromLayers();
    this.removeExtraNavaidsAssociatedAirspace(airspace, allNavaidsOnMap);
    this.addNavaidsAssociatedAirspace(airspace, allNavaidsOnMap);
  }

  private removeExtraNavaidsAssociatedAirspace(airspace: AirSpaceBoundaryModel, allNavaidsOnMap: Feature<Geometry>[]) {
    for (const navaidOnMap of allNavaidsOnMap) {
      let associatedAirspaces: any[] = navaidOnMap.get("associatedAirspaceBoundaries");
      if (associatedAirspaces == null || associatedAirspaces.length == 0) {
        continue;
      }
      let associatedAirspaceIndex = associatedAirspaces.findIndex(p => p.id == airspace.id);
      if (associatedAirspaceIndex != -1) { // navaid contains associated Airspace
        if (airspace.navaids != null && airspace.navaids.findIndex(n => n.id == navaidOnMap.get("id")) == -1) { // Airspace doesnt contain navaid
          associatedAirspaces.splice(associatedAirspaceIndex, 1);
          navaidOnMap.set("associatedAirspaceBoundaries", associatedAirspaces);
        }
      }
    }
  }

  private addNavaidsAssociatedAirspace(airspace: AirSpaceBoundaryModel, allNavaidsOnMap: Feature<Geometry>[]) {
    if (airspace.navaids != null && airspace.navaids.length > 0) {
      for (const airspaceNav of airspace.navaids) {
        const navaidOnMap = allNavaidsOnMap.find(n => n.get("id") == airspaceNav.id);
        if (navaidOnMap != null) {
          if (navaidOnMap.get("associatedAirspaceBoundaries") == null) {
            navaidOnMap.set("associatedAirspaceBoundaries", []);
          }
          if (navaidOnMap.get("associatedAirspaceBoundaries").findIndex(p => p.id == airspace.id) == -1) { // airspace is not associated
            const newList: any[] = navaidOnMap.get("associatedAirspaceBoundaries");
            newList.push(airspace);
            navaidOnMap.set("associatedAirspaceBoundaries", newList);
          }
        }
      }
    }
  }

  private updateNavaidsAssociatedProcedures(procedures: ProcedureModel[], allNavaidsOnMap: Feature<Geometry>[]) {
    for (const procedure of procedures) {
      this.removeExtraNavaidsAssociatedProcedure(procedure, allNavaidsOnMap);
      this.addNavaidsAssociatedProcedure(procedure, allNavaidsOnMap);
    }
  }

  private removeExtraNavaidsAssociatedProcedure(procedure: ProcedureModel, allNavaidsOnMap: Feature<Geometry>[]) {
    for (const navaidOnMap of allNavaidsOnMap) {
      let associatedProcedures: any[] = navaidOnMap.get("associatedProcedures");
      if (associatedProcedures == null || associatedProcedures.length == 0) {
        continue;
      }
      let associatedProcedureIndex = associatedProcedures.findIndex(p => p.id == procedure.id);
      if (associatedProcedureIndex != -1) { // navaid contains associated procedure
        if (procedure.navaids != null && procedure.navaids.findIndex(n => n.id == navaidOnMap.get("id")) == -1) { // procedure doesnt contain navaid
          associatedProcedures.splice(associatedProcedureIndex, 1);
          navaidOnMap.set("associatedProcedures", associatedProcedures);
        }
      }

      associatedProcedures = navaidOnMap.get("associatedProceduresCritical");
      if (associatedProcedures == null || associatedProcedures.length == 0) {
        continue;
      }
      associatedProcedureIndex = associatedProcedures.findIndex(p => p.id == procedure.id);
      if (associatedProcedureIndex != -1) { // navaid contains associated procedure
        if (procedure.criticalNavaids != null && procedure.criticalNavaids.findIndex(n => n.id == navaidOnMap.get("id")) == -1) { // procedure doesnt contain navaid
          associatedProcedures.splice(associatedProcedureIndex, 1);
          navaidOnMap.set("associatedProceduresCritical", associatedProcedures);
        }
      }
    }
  }

  private addNavaidsAssociatedProcedure(procedure: ProcedureModel, allNavaidsOnMap: Feature<Geometry>[]) {
    if (procedure.navaids != null && procedure.navaids.length > 0) {
      for (const procedureNav of procedure.navaids) {
        const navaidOnMap = allNavaidsOnMap.find(n => n.get("id") == procedureNav.id);
        if (navaidOnMap != null) {
          if (navaidOnMap.get("associatedProcedures") == null) {
            navaidOnMap.set("associatedProcedures", []);
          }
          if (navaidOnMap.get("associatedProcedures").findIndex(p => p.id == procedure.id) == -1) { // procedure is not associated
            const newList: any[] = navaidOnMap.get("associatedProcedures");
            newList.push(procedure);
            navaidOnMap.set("associatedProcedures", newList);
          }
        }
      }
    }
    if (procedure.criticalNavaids != null && procedure.criticalNavaids.length > 0) {
      for (const procedureNav of procedure.criticalNavaids) {
        const navaidOnMap = allNavaidsOnMap.find(n => n.get("id") == procedureNav.id);
        if (navaidOnMap != null) {
          if (navaidOnMap.get("associatedProceduresCritical") == null) {
            navaidOnMap.set("associatedProceduresCritical", []);
          }
          if (navaidOnMap.get("associatedProceduresCritical").findIndex(p => p.id == procedure.id) == -1) { // procedure is not associated
            const newList: any[] = navaidOnMap.get("associatedProceduresCritical");
            newList.push(procedure);
            navaidOnMap.set("associatedProceduresCritical", newList);
          }
        }
      }
    }
  }

  fetchAndAddPartialProcedures(extent: [number, number, number, number], isSwitchProject: boolean = false): void {
    let self = this;
    if (isSwitchProject) {
      this.uiBlock.startBlock("Adding procedures to map...");
      this.deleteProceduresFromMap();
    }
    this.getProceduresPartial(extent).subscribe(
      (procedures) => {
        try {
          procedures.forEach((element) => {
            self.addProcedureToMap(element);
          });
        } finally {
          if (isSwitchProject) this.uiBlock.stopBlock();
        }
      },
      () => { if (isSwitchProject) this.uiBlock.stopBlock(); }
    );
  }

  public fetchAndAddProcedures(updateAssociatedNavaids: boolean = false): void {
    this.uiBlock.startBlock("Adding entities to map...");
    this.getProcedures().subscribe((procedures) => {
      try {
        if (updateAssociatedNavaids && procedures != null && procedures.length > 0) {
          const allNavaidsOnMap: Feature<Geometry>[] = this.getAllNavaidsFeaturesFromLayers();
          this.updateNavaidsAssociatedProcedures(procedures, allNavaidsOnMap);
        }
        procedures.forEach((procedure) => {
          if (procedure.mapstatus) {
            this.addProcedureToMap(procedure);
          }
        })
      } finally {
        this.uiBlock.stopBlock()
      }
    },
      () => {
        this.uiBlock.stopBlock()
      }



    );
  }
  public changeUserLayerFeaturesStyle(features: Feature[], userLayer: UserLayer) {
    features.forEach((feature: Feature) => {
      let style: Style;
      let strokeColorFeature: string;
      let fillColorFeature: string;
      if (!userLayer.userLayerColorActive) {
        strokeColorFeature = feature.get('color');
        fillColorFeature = feature.get('color');
        if (strokeColorFeature == null || fillColorFeature == null) {
          return;
        }
      }
      else {
        strokeColorFeature = userLayer.lineChecked ? this.utilsService.hexToRgb2(userLayer.strokeColor, userLayer.lineOpacity) : null;
        fillColorFeature = userLayer.fillChecked ? this.utilsService.hexToRgb2(userLayer.fillColor, userLayer.fillOpacity) : null;
      }

      if (feature.get('geometry') instanceof LineString || feature.get('geometry') instanceof MultiLineString) {
        style = new Style({
          stroke: strokeColorFeature != null ? new Stroke({
            color: strokeColorFeature,
            width: userLayer.lineWidth
          }) : null
        })
      }
      else if (feature.get('geometry') instanceof Polygon || feature.get('geometry') instanceof MultiPolygon) {
        style = new Style({
          stroke: strokeColorFeature != null ? new Stroke({
            color: strokeColorFeature,
            width: userLayer.lineWidth
          }) : null,
          fill: fillColorFeature != null ? new Fill({ color: fillColorFeature }) : null
        })
      }
      else if (feature.get('geometry') instanceof Point) {
        style = this.utilsService.getStyleOfShape(userLayer.shape,
          userLayer.lineChecked ? userLayer.strokeColor : null, userLayer.lineWidth,
          userLayer.fillChecked ? userLayer.fillColor : null, userLayer.radius);
      }
      if (userLayer.propertyDisplayed != null && feature.get(userLayer.propertyDisplayed) != "" && userLayer.labelChecked) {
        style.setText(new Text({ text: JSON.stringify(feature.get(userLayer.propertyDisplayed)), scale: 2 }));
        feature.setStyle(cloneDeep(style))

      }
      else {
        feature.setStyle(style);
      }

    })
  }
  public fetchAndAddUserLayersToMap(isSwitchProject: boolean = false) {
    isSwitchProject ? this.uiBlock.startBlock("Adding entities to map...") : false;
    try {
      this.userSettingsService.userSettings.userLayers
        .forEach((userLayer: UserLayer) => {
          let features: Feature[];
          if (userLayer.type == UserLayerTypes.SHAPEFILE) {
            features = new GeoJSON().readFeatures(JSON.parse(userLayer.data), {
              featureProjection: this.rcsControl.activeRCS.isactive ? this.rcsControl.activeRCS.epsg : "EPSG:3857",
              dataProjection: 'CRS:84'
            });
          }
          else {
            features = new KML().readFeatures(userLayer.data, {
              featureProjection: this.rcsControl.activeRCS.isactive ? this.rcsControl.activeRCS.epsg : "EPSG:3857",
              dataProjection: 'CRS:84'
            });
          }
          this.changeUserLayerFeaturesStyle(features, userLayer);


          const vectorSource = new VectorSource({
            features: features,
          });
          const vectorLayer = new VectorLayerDMTR({
            source: vectorSource,
          });
          let layer: Layer = {
            id: JSON.stringify(userLayer.id), name: userLayer.name,
            visible: userLayer.visible, image: "",
            olLayer: vectorLayer
          }
          this.userLayers.childLayers[0].addLayers([layer]);
        })
    } finally {
      isSwitchProject ? this.uiBlock.stopBlock() : false;
    }

  }
  public createHighlightStyle(highlightIndex, multiPoint) {
    var styles = [];
    var coordinates = multiPoint.getCoordinates();

    coordinates.forEach(function (coord, index) {
      var style = new Style({
        image: new Icon({
          scale: 0.2,
          color: (highlightIndex == 0) ? 'red' : 'blue',
          src: "/assets/img/cp4-white.png",
        }),
      })
      styles.push(style);
    });

    return styles;
  }

  public addCoordinatePointsToMapMultipoint(coordinatePoints: CoordinatePoint[]) {
    const WaypointLayer = this.coordinatePointsLayers.childLayers[0].layers
      .find((element) => element.id === 'waypoint');
    const ARPCivilLayer = this.coordinatePointsLayers.childLayers[0].layers
      .find((element) => element.id == 'arp_civil')
    const ARPMilitarLayer = this.coordinatePointsLayers.childLayers[0].layers
      .find((element) => element.id == 'arp_militar')
    const ARPMixedLayer = this.coordinatePointsLayers.childLayers[0].layers
      .find((element) => element.id == 'arp_mixed')
    const RWY_THRLayer = this.coordinatePointsLayers.childLayers[0].layers
      .find((element) => element.id == 'rwy_thr')
    const VertexLayer = this.coordinatePointsLayers.childLayers[0].layers
      .find((element) => element.id == 'airspace_vertex')
    const FixPointLayer = this.coordinatePointsLayers.childLayers[0].layers
      .find((element) => element.id == 'fix_point')

    this.selectedCoordinatePoints.clear();

    let wayPointCoords: Coordinate[] = [];
    let arpCivilCoords: Coordinate[] = [];
    let arpMilitarCoords: Coordinate[] = [];
    let arpMixedCoords: Coordinate[] = [];
    let rwyThrCoords: Coordinate[] = [];
    let airspaceVertexCoords: Coordinate[] = [];
    let fixPointCoords: Coordinate[] = [];

    let wayPointPublishedCoords: Coordinate[] = [];
    let arpCivilPublishedCoords: Coordinate[] = [];
    let arpMilitarPublishedCoords: Coordinate[] = [];
    let arpMixedPublishedCoords: Coordinate[] = [];
    let rwyThrPublishedCoords: Coordinate[] = [];
    let airspaceVertexPublishedCoords: Coordinate[] = [];
    let fixPointPublishedCoords: Coordinate[] = [];

    this.clearIndexToFeatureMaps();
    // if (coordinatePoints[0] == null) {
    //   return;
    // }

    coordinatePoints.forEach((element) => {

      switch (element.type) {
        case 'WAYPOINT':
          if (element.userdefined) {
            wayPointCoords.push(olProj.fromLonLat([element.longitude, element.latitude], this.mapService.getMaps().getView().getProjection()));
            this.waypointsIndexToFeature.set(wayPointCoords.length - 1, this.createCoordinatePointFeature(element));
          } else {
            wayPointPublishedCoords.push(olProj.fromLonLat([element.longitude, element.latitude], this.mapService.getMaps().getView().getProjection()));
            this.waypointsPublishedIndexToFeature.set(wayPointPublishedCoords.length - 1, this.createCoordinatePointFeature(element));
          }
          break;
        case 'ARP_CIVIL':
          if (element.userdefined) {
            arpCivilCoords.push(olProj.fromLonLat([element.longitude, element.latitude], this.mapService.getMaps().getView().getProjection()));
            this.arpCivilIndexToFeature.set(arpCivilCoords.length - 1, this.createCoordinatePointFeature(element));
          } else {
            arpCivilPublishedCoords.push(olProj.fromLonLat([element.longitude, element.latitude], this.mapService.getMaps().getView().getProjection()));
            this.arpCivilPublishedIndexToFeature.set(arpCivilPublishedCoords.length - 1, this.createCoordinatePointFeature(element));
          }
          break;
        case 'ARP_MILITAR':
          if (element.userdefined) {
            arpMilitarCoords.push(olProj.fromLonLat([element.longitude, element.latitude], this.mapService.getMaps().getView().getProjection()));
            this.arpMilitarIndexToFeature.set(arpMilitarCoords.length - 1, this.createCoordinatePointFeature(element));
          } else {
            arpMilitarPublishedCoords.push(olProj.fromLonLat([element.longitude, element.latitude], this.mapService.getMaps().getView().getProjection()));
            this.arpMilitarPublishedIndexToFeature.set(arpMilitarPublishedCoords.length - 1, this.createCoordinatePointFeature(element));
          }
          break;
        case 'ARP_MIXED':
          if (element.userdefined) {
            arpMixedCoords.push(olProj.fromLonLat([element.longitude, element.latitude], this.mapService.getMaps().getView().getProjection()));
            this.arpMixedIndexToFeature.set(arpMixedCoords.length - 1, this.createCoordinatePointFeature(element));
          } else {
            arpMixedPublishedCoords.push(olProj.fromLonLat([element.longitude, element.latitude], this.mapService.getMaps().getView().getProjection()));
            this.arpMixedPublishedIndexToFeature.set(arpMixedPublishedCoords.length - 1, this.createCoordinatePointFeature(element));
          }
          break;
        case 'RWY_THR':
          if (element.userdefined) {
            rwyThrCoords.push(olProj.fromLonLat([element.longitude, element.latitude], this.mapService.getMaps().getView().getProjection()));
            this.rwyThrIndexToFeature.set(rwyThrCoords.length - 1, this.createCoordinatePointFeature(element));
          } else {
            rwyThrPublishedCoords.push(olProj.fromLonLat([element.longitude, element.latitude], this.mapService.getMaps().getView().getProjection()));
            this.rwyThrPublishedIndexToFeature.set(rwyThrPublishedCoords.length - 1, this.createCoordinatePointFeature(element));
          }
          break;
        case 'AIRSPACE_BOUNDARY_VERTEX':
          if (element.userdefined) {
            airspaceVertexCoords.push(olProj.fromLonLat([element.longitude, element.latitude], this.mapService.getMaps().getView().getProjection()));
            this.airspaceVertexIndexToFeature.set(airspaceVertexCoords.length - 1, this.createCoordinatePointFeature(element));
          } else {
            airspaceVertexPublishedCoords.push(olProj.fromLonLat([element.longitude, element.latitude], this.mapService.getMaps().getView().getProjection()));
            this.airspaceVertexPublishedIndexToFeature.set(airspaceVertexPublishedCoords.length - 1, this.createCoordinatePointFeature(element));
          }
          break;
        case 'FIX_POINT':
          if (element.userdefined) {
            fixPointCoords.push(olProj.fromLonLat([element.longitude, element.latitude], this.mapService.getMaps().getView().getProjection()));
            this.fixPointIndexToFeature.set(fixPointCoords.length - 1, this.createCoordinatePointFeature(element));
          } else {
            fixPointPublishedCoords.push(olProj.fromLonLat([element.longitude, element.latitude], this.mapService.getMaps().getView().getProjection()));
            this.fixPointPublishedIndexToFeature.set(fixPointPublishedCoords.length - 1, this.createCoordinatePointFeature(element));
          }
          break;
        default:
          break;
      }
    });

    // user defined multipoint features
    this.createAndAddMultiPointFeatureToLayer(wayPointCoords, WaypointLayer, false);
    this.createAndAddMultiPointFeatureToLayer(arpCivilCoords, ARPCivilLayer, false);
    this.createAndAddMultiPointFeatureToLayer(arpMilitarCoords, ARPMilitarLayer, false);
    this.createAndAddMultiPointFeatureToLayer(arpMixedCoords, ARPMixedLayer, false);
    this.createAndAddMultiPointFeatureToLayer(rwyThrCoords, RWY_THRLayer, false);
    this.createAndAddMultiPointFeatureToLayer(airspaceVertexCoords, VertexLayer, false);
    this.createAndAddMultiPointFeatureToLayer(fixPointCoords, FixPointLayer, false);

    // published multipoint features
    this.createAndAddMultiPointFeatureToLayer(wayPointPublishedCoords, WaypointLayer, true);
    this.createAndAddMultiPointFeatureToLayer(arpCivilPublishedCoords, ARPCivilLayer, true);
    this.createAndAddMultiPointFeatureToLayer(arpMilitarPublishedCoords, ARPMilitarLayer, true);
    this.createAndAddMultiPointFeatureToLayer(arpMixedPublishedCoords, ARPMixedLayer, true);
    this.createAndAddMultiPointFeatureToLayer(rwyThrPublishedCoords, RWY_THRLayer, true);
    this.createAndAddMultiPointFeatureToLayer(airspaceVertexPublishedCoords, VertexLayer, true);
    this.createAndAddMultiPointFeatureToLayer(fixPointPublishedCoords, FixPointLayer, true);
  }

  createAndAddMultiPointFeatureToLayer(coordinates: Coordinate[], layer: Layer, published: boolean) {
    const color = this.getColorOfType('Coordinate Points', layer.id, !published);
    const multiPointGeometry: MultiPoint = new MultiPoint(coordinates);
    const multiPointFeature = new Feature({ geometry: multiPointGeometry });
    this.setFeatureStyle(multiPointFeature, layer, color);
    multiPointFeature.set(CoordinatePointModel.LAYER_ID_FEATURE_PROPERTY, layer.id);
    multiPointFeature.set(CoordinatePointModel.PUBLISHED_FEATURE_PROPERTY, published);
    const source = layer.olLayer.getSource();
    const features = source.getFeatures();

    const multiPointFeatureIndex = this.getPublishedIndexForMultiPointVectorSource(source, published);
    if (multiPointFeatureIndex == -1) {
      source.addFeature(multiPointFeature);  // Add the new feature
      return;
    }

    source.clear();
    for (let i = 0; i < features.length; i++) {
      if (i == multiPointFeatureIndex) {
        source.addFeature(multiPointFeature);  // Add the new feature
        continue;
      }
      source.addFeature(features[i]); // add the other features
    }
  }

  public async fetchAndAddPartialCoordinatePoints(extent: [number, number, number, number], isSwitchProject: boolean = false): Promise<void>  {
    if (this.allCoordinatePointsLoaded && this.coordinatePointsFilterService.filters.some(f => f.active)) {
      return;
    }

    if (this.totalCoordinatePointsInProject === 0) {
      this.fetchTotalCoordinatePointsCount();
    }
    isSwitchProject ? this.uiBlock.startBlock("Adding entities to map...") : false;
    try {
      this.selectedCoordinatePoints.clear();
      let coordinatePoints: CoordinatePoint[] = await lastValueFrom(this.getCoordinatePointsPartial(extent))

        if (this.coordinatePointsFilterService.filters.some(f => f.active)) {
        coordinatePoints = this.applyFiltersToCoordinatePointsList(coordinatePoints);
      }

      this.addCoordinatePointsToMapMultipoint(coordinatePoints);

      this.allCoordinatePointsLoaded = false;
      /*this.coordinatePointsLayers.childLayers.forEach(child => {
        child.showAll();
            });*/
    } finally {
      isSwitchProject ? this.uiBlock.stopBlock() : false;
    }
  }

  public async fetchAndAddCoordinatePoints(isSwitchProject: boolean = false): Promise<void> {
    isSwitchProject ? this.uiBlock.startBlock("Adding entities to map...") : false;
    try {
      this.selectedCoordinatePoints.clear();
      this.deleteCoordinatePointsFromMap();
      let coordinatePoints: CoordinatePoint[] = await lastValueFrom(this.getCoordinatePoints());

      //Apply filters before adding to the map
      if (this.coordinatePointsFilterService.filters.some(f => f.active)) {
        coordinatePoints = this.applyFiltersToCoordinatePointsList(coordinatePoints);
      }

      this.addCoordinatePointsToMapMultipoint(coordinatePoints);
      this.allCoordinatePointsLoaded = true;

      const totalToDisplay = this.totalCoordinatePointsInProject;
      const displayedCount = coordinatePoints.length;
      this.informationMessageCoordinatePoints = "Displaying " + displayedCount + " of " + totalToDisplay + ".";

      this.coordinatePointsLayers.childLayers.forEach(child => {
        child.showAll();
      });
    } finally {
      isSwitchProject ? this.uiBlock.stopBlock() : false;
    }
  }

  filterNavaids(filters: FilterModel[], isFilter: boolean) {
    let auxThis = this;
    let activeFilters: FilterModel[] = [];
    for (let filter of filters) {
      if (filter.active) {
        activeFilters.push(filter);
      }
    }
    return new Promise(function (resolve, reject) {
      let numberOfNavaids: number = 0;

      let navaidsToRemove: Feature[] = [];

      let features: Feature[] = auxThis.getAllNavaidsFeaturesFromLayers();

      features.forEach(nav => {
        numberOfNavaids++;
        navaidsToRemove.push(nav);
        navaidsToRemove = auxThis.performNavaidFilter(navaidsToRemove, auxThis.transformFeatureInNavaid(nav), nav, activeFilters);
      })

      if (isFilter) {
        numberOfNavaids -= navaidsToRemove.length;
        auxThis.deleteNavaidFeaturesFromMap(navaidsToRemove);
      } else {
        const filteredArray = features.filter(value => !navaidsToRemove.includes(value));

        filteredArray.forEach(navaid => {
          let layer: VectorLayerDMTR = auxThis.navaidsLayers.childLayers[0].layers.find((element) => element.id === navaid.getProperties().navaidtype.toLowerCase()).olLayer;
          navaid.setStyle(layer.getStyleSelected());
          auxThis.addSelectedFeature(navaid);
        })
      }
      const totalToDisplay = auxThis.totalNavaidsInProject;
      const displayedCount = activeFilters.length === 0 ? totalToDisplay : (features.length - navaidsToRemove.length);
      auxThis.informationMessageNavaids = "Displaying " + displayedCount + " of " + totalToDisplay + ".";
      resolve(null);
    });
  }

  performNavaidFilter(navaidsToRemove: Feature[], nav: NavaidModel, feat: Feature, filters: FilterModel[]): Feature[] {
    let iterator: number = 0;

    let orList: OrFilter[] = [];
    let andList: AndFilter[] = [];
    let toReturnOr: boolean = true;
    let toReturnAnd: boolean = true;

    filters.forEach(filter => {
      iterator++;

      let count: number = filters.filter(filter_aux => filter_aux.field == filter.field).length;
      let count_filter: number = orList.filter(filter_aux => filter_aux.getFilterName() == filter.field).length;

      if (count > 1) {
        if (count_filter > 0) {
          let filterValue: OrFilter = orList.find(orfilter => orfilter.getFilterName() == filter.field)

          filterValue.addElement(this.filterNavaidByFields(nav, feat, filter));

        } else {
          let newOrFilter: OrFilter = new OrFilter(filter.field);
          newOrFilter.addElement(this.filterNavaidByFields(nav, feat, filter));
          orList.push(newOrFilter);
        }
      } else {

        let newAndFilter: AndFilter = new AndFilter(filter.field);
        newAndFilter.addElement(this.filterNavaidByFields(nav, feat, filter));
        andList.push(newAndFilter);
      }
    });

    orList.forEach(or => {
      toReturnOr = toReturnOr && or.getOrResult();
    })

    andList.forEach(and => {
      toReturnAnd = toReturnAnd && and.getOrResult();
    })

    if (toReturnOr && toReturnAnd) {
      const index = navaidsToRemove.indexOf(feat, 0);
      if (index > -1) {
        navaidsToRemove.splice(index, 1);
      }
    }


    return navaidsToRemove;
  }


  filterNavaidByFields(nav: NavaidModel, feat: Feature, filter: FilterModel): boolean {
    let toReturn: boolean = false;

    switch (filter.field) {
      case "Type":
        if (nav.navaidtype != null) {
          if (nav.navaidtype == NavAidsCSVContent.transformNavaidType(filter.value)) {
            toReturn = true;

          }
        }
        break;
      case "Published":
        toReturn = (filter.value === 'Published') === nav.userdefined;
        break;
      case "ICAO Country Code (ECAC+ENP)":
        let ecacEnpIcaoCodesAux: icaoccModel[] = [];
        ecacEnpIcaoCodesAux = this.ecacEnpIcaoCodes.filter(code => code.icaocode == filter.value);
        if (nav.icaocc != null) {

          if (nav.icaocc == ecacEnpIcaoCodesAux[0].icaocode) {
            toReturn = true;
          }

        }

        break;
      case "ICAO Country Code(rest of the world)":
        let worldIcaoCodesAux: icaoccModel[] = [];
        worldIcaoCodesAux = this.worldIcaoCodes.filter(code => code.icaocode == filter.value);
        if (nav.icaocc != null) {
          if (nav.icaocc == worldIcaoCodesAux[0].icaocode) {
            toReturn = true;
          }
        }

        break;
      case "DOC":
        if (nav.doc != null) {
          let doc: number = parseFloat(nav.doc);
          let minDoc: number = this.getMinFromFilter(filter);
          let maxDoc: number = this.getMaxFromFilter(filter);
          if (doc >= minDoc && doc <= maxDoc)
            toReturn = true;
        }
        break;
      case "DOC Maximum Altitude":
        if (nav.maxaltitude != null) {
          let minDocAltitude: number = this.getMinFromFilter(filter);
          let maxDocAltitude: number = this.getMaxFromFilter(filter);
          if (nav.maxaltitude >= minDocAltitude && nav.maxaltitude <= maxDocAltitude)
            toReturn = true;
        }
        break;
      case "DME/TACAN Operational status":
        if (nav.navaidtype != 'VOR' && nav.navaidtype != 'VORTAC') {
          if (nav.operationalstatus != null) {
            if (nav.operationalstatus == Object.values(NavaidStatus).find(status => status.html === filter.value).value) {
              toReturn = true;
            }
          }
        }

        break;
      case "DME/TACAN Operational at date":
        if (nav.navaidtype != 'VOR' && nav.navaidtype != 'VORTAC') {
          if (nav.operationalsince != null) {
            let minDateForOperationalSince: Date = this.getMinDateFromFilter(filter);
            let maxDateForOperationalSince: Date = this.getMaxDateFromFilter(filter);
            let operationalsinceDate: Date = nav.operationalsince != null ? new Date(nav.operationalsince) : null;
            let plannedRemovalDate: Date = nav.plannedremoval != null ? new Date(nav.plannedremoval) : null;

            if (nav.plannedremoval != null) {
              if ((this.utilsService.after(operationalsinceDate, minDateForOperationalSince)
                && this.utilsService.before(operationalsinceDate, maxDateForOperationalSince))
                || this.utilsService.equals(operationalsinceDate, minDateForOperationalSince)
                || this.utilsService.equals(plannedRemovalDate, maxDateForOperationalSince)) {
                toReturn = true;
              } else if ((this.utilsService.after(plannedRemovalDate, minDateForOperationalSince)
                && this.utilsService.before(plannedRemovalDate, maxDateForOperationalSince))
                || this.utilsService.equals(plannedRemovalDate, minDateForOperationalSince)
                || this.utilsService.equals(plannedRemovalDate, maxDateForOperationalSince)) {
                toReturn = true;
              } else if ((this.utilsService.after(operationalsinceDate, minDateForOperationalSince)
                && this.utilsService.before(plannedRemovalDate, maxDateForOperationalSince))
                || this.utilsService.equals(operationalsinceDate, minDateForOperationalSince)
                || this.utilsService.equals(plannedRemovalDate, maxDateForOperationalSince)) {
                toReturn = true;
              } else if ((this.utilsService.before(operationalsinceDate, minDateForOperationalSince)
                && this.utilsService.after(plannedRemovalDate, maxDateForOperationalSince))
                || this.utilsService.equals(operationalsinceDate, minDateForOperationalSince)
                || this.utilsService.equals(plannedRemovalDate, maxDateForOperationalSince)) {
                toReturn = true;
              } else if (this.utilsService.after(operationalsinceDate, minDateForOperationalSince)
                && this.utilsService.equals(operationalsinceDate, maxDateForOperationalSince)) {
                toReturn = true;
              }
            } else {
              if (this.utilsService.after(operationalsinceDate, minDateForOperationalSince)
                && this.utilsService.before(operationalsinceDate, maxDateForOperationalSince)
                || this.utilsService.equals(operationalsinceDate, minDateForOperationalSince)
                || this.utilsService.equals(operationalsinceDate, maxDateForOperationalSince)) {
                toReturn = true;
              }
            }
          }
        }
        break;
      case "DME/TACAN Date for comissioning":
        if (nav.navaidtype != 'VOR' && nav.navaidtype != 'VORTAC') {
          if (nav.operationalsince != null) {
            let operationalsinceDate: Date = new Date(nav.operationalsince);
            let minDateForVORReplacementDate: Date = this.getMinDateFromFilter(filter);
            let maxDateForVORReplacementDate: Date = this.getMaxDateFromFilter(filter);
            if (this.utilsService.after(operationalsinceDate, minDateForVORReplacementDate)
              && this.utilsService.before(operationalsinceDate, maxDateForVORReplacementDate)
              || this.utilsService.equals(operationalsinceDate, minDateForVORReplacementDate)
              || this.utilsService.equals(operationalsinceDate, maxDateForVORReplacementDate))
              toReturn = true;
          }
        }

        // nav.getD
        break;
      case "DME/TACAN Date for replacement":
        if (nav.navaidtype != 'VOR' && nav.navaidtype != 'VORTAC') {
          if (nav.dueforreplacement != null) {
            let dueforreplacementDate: Date = new Date(nav.dueforreplacement);
            let minDateForReplacement: Date = this.getMinDateFromFilter(filter);
            let maxDateForReplacement: Date = this.getMaxDateFromFilter(filter);
            if (this.utilsService.after(dueforreplacementDate, minDateForReplacement)
              && this.utilsService.before(dueforreplacementDate, maxDateForReplacement)
              || this.utilsService.equals(dueforreplacementDate, minDateForReplacement)
              || this.utilsService.equals(dueforreplacementDate, maxDateForReplacement))
              toReturn = true;
          }
        }

        break;
      case "DME/TACAN Date of planned removal":
        if (nav.navaidtype != 'VOR' && nav.navaidtype != 'VORTAC') {
          if (nav.plannedremoval != null) {
            let plannedremovalDate: Date = new Date(nav.plannedremoval);
            let minDateForPlannedRemoval: Date = this.getMinDateFromFilter(filter);
            let maxDateForPlannedRemoval: Date = this.getMaxDateFromFilter(filter);
            if (this.utilsService.after(plannedremovalDate, minDateForPlannedRemoval)
              && this.utilsService.before(plannedremovalDate, maxDateForPlannedRemoval)
              || this.utilsService.equals(plannedremovalDate, minDateForPlannedRemoval)
              || this.utilsService.equals(plannedremovalDate, maxDateForPlannedRemoval))
              toReturn = true;
          }
        }

        break;
      case "DME/TACAN purpose":
        if (nav.dmetacanclass != null) {
          filter.value == 'ENR&TMA' ? filter.value = 'ENR_TMA' : false;
          if (nav.dmetacanclass == filter.value) {
            toReturn = true;
          }
        }
        break;
      case "VHF tuning frequency":
        if (nav.vhfTunFreqInput != null) {
          if (nav.vhfTunFreqInput == filter.value) {
            toReturn = true;
          }
        }
        break;
      case "Channel":
        if (nav.channel != null) {
          if (nav.channel == filter.value) {
            toReturn = true;
          }
        }
        break;
      case "Transmitter output power":
        if (nav.transmoutpower != null) {
          let minTOP: number = this.getMinFromFilter(filter);
          let maxTOP: number = this.getMaxFromFilter(filter);
          if (nav.transmoutpower >= minTOP && nav.transmoutpower <= maxTOP)
            toReturn = true;
        }
        break;
      case "Declared EIRP":
        if (nav.declaredeirp != null) {
          let minEIRP: number = this.getMinFromFilter(filter);
          let maxEIRP: number = this.getMaxFromFilter(filter);
          if (nav.declaredeirp >= minEIRP && nav.declaredeirp <= maxEIRP)
            toReturn = true;
        }
        break;
      case "ARINC 424 FOM":
        if (nav.arinc424fom != null) {
          if (nav.arinc424fom == filter.value) {
            toReturn = true;
          }
        }
        break;
      case "VOR Type":
        if (nav.vortype != null) {
          if (nav.vortype == filter.value.toUpperCase()) {
            toReturn = true;
          }
        }
        break;
      case "VOR Operational Status":
        if (nav.navaidtype == 'VOR' || nav.navaidtype == 'VORTAC') {
          if (nav.voroperstatus != null) {
            if (nav.voroperstatus == Object.values(NavaidStatus).find(status => status.html === filter.value).value) {
              toReturn = true;
            }
          }
        } else {
          if (nav.operationalstatus != null) {
            if (nav.operationalstatus == Object.values(NavaidStatus).find(status => status.html === filter.value).value) {
              toReturn = true;
            }
          }
        }
        break;
      case "VOR Operational at Date":
        if (nav.navaidtype == 'VOR_DME' || nav.navaidtype == 'VORTAC') {
          if (nav.voroperationalsince != null) {
            let voroperationalsinceDate: Date = new Date(nav.voroperationalsince);
            let vorplannedremovalDate: Date = new Date(nav.vorplannedremoval);
            let minDateForOperationalSince: Date = this.getMinDateFromFilter(filter);
            let maxDateForOperationalSince: Date = this.getMaxDateFromFilter(filter);
            if (nav.vorplannedremoval != null) {
              if ((this.utilsService.after(voroperationalsinceDate, minDateForOperationalSince)
                && this.utilsService.before(voroperationalsinceDate, maxDateForOperationalSince))
                || this.utilsService.equals(voroperationalsinceDate, minDateForOperationalSince)
                || this.utilsService.equals(vorplannedremovalDate, maxDateForOperationalSince)) {
                toReturn = true;
              } else if ((this.utilsService.after(vorplannedremovalDate, minDateForOperationalSince)
                && this.utilsService.before(vorplannedremovalDate, maxDateForOperationalSince))
                || this.utilsService.equals(vorplannedremovalDate, minDateForOperationalSince)
                || this.utilsService.equals(vorplannedremovalDate, maxDateForOperationalSince)) {
                toReturn = true;
              } else if ((this.utilsService.after(voroperationalsinceDate, minDateForOperationalSince)
                && this.utilsService.before(vorplannedremovalDate, maxDateForOperationalSince))
                || this.utilsService.equals(voroperationalsinceDate, minDateForOperationalSince)
                || this.utilsService.equals(vorplannedremovalDate, maxDateForOperationalSince)) {
                toReturn = true;
              } else if ((this.utilsService.before(voroperationalsinceDate, minDateForOperationalSince)
                && this.utilsService.after(vorplannedremovalDate, maxDateForOperationalSince))
                || this.utilsService.equals(voroperationalsinceDate, minDateForOperationalSince)
                || this.utilsService.equals(vorplannedremovalDate, maxDateForOperationalSince)) {
                toReturn = true;
              } else if (this.utilsService.after(voroperationalsinceDate, minDateForOperationalSince)
                && this.utilsService.equals(voroperationalsinceDate, maxDateForOperationalSince)) {
                toReturn = true;
              }
            } else {
              if (this.utilsService.after(voroperationalsinceDate, minDateForOperationalSince)
                && this.utilsService.before(voroperationalsinceDate, maxDateForOperationalSince)
                || this.utilsService.equals(voroperationalsinceDate, minDateForOperationalSince)
                || this.utilsService.equals(voroperationalsinceDate, maxDateForOperationalSince)) {
                toReturn = true;
              }

            }
          }
        } else if (nav.navaidtype == 'VOR') {
          if (nav.operationalsince != null) {
            let minDateForOperationalSince: Date = this.getMinDateFromFilter(filter);
            let maxDateForOperationalSince: Date = this.getMaxDateFromFilter(filter);
            let operationalsinceDate: Date = new Date(nav.operationalsince);
            let plannedremovalDate: Date = new Date(nav.plannedremoval);
            if (nav.plannedremoval != null) {
              if ((this.utilsService.after(operationalsinceDate, minDateForOperationalSince)
                && this.utilsService.before(operationalsinceDate, maxDateForOperationalSince))
                || this.utilsService.equals(operationalsinceDate, minDateForOperationalSince)
                || this.utilsService.equals(plannedremovalDate, maxDateForOperationalSince)) {
                toReturn = true;
              } else if ((this.utilsService.after(plannedremovalDate, minDateForOperationalSince)
                && this.utilsService.before(plannedremovalDate, maxDateForOperationalSince))
                || this.utilsService.equals(plannedremovalDate, minDateForOperationalSince)
                || this.utilsService.equals(plannedremovalDate, maxDateForOperationalSince)) {
                toReturn = true;
              } else if ((this.utilsService.after(operationalsinceDate, minDateForOperationalSince)
                && this.utilsService.before(plannedremovalDate, maxDateForOperationalSince))
                || this.utilsService.equals(operationalsinceDate, minDateForOperationalSince)
                || this.utilsService.equals(plannedremovalDate, maxDateForOperationalSince)) {
                toReturn = true;
              } else if ((this.utilsService.before(operationalsinceDate, minDateForOperationalSince)
                && this.utilsService.after(plannedremovalDate, maxDateForOperationalSince))
                || this.utilsService.equals(operationalsinceDate, minDateForOperationalSince)
                || this.utilsService.equals(plannedremovalDate, maxDateForOperationalSince)) {
                toReturn = true;
              } else if (this.utilsService.after(operationalsinceDate, minDateForOperationalSince)
                && this.utilsService.equals(operationalsinceDate, maxDateForOperationalSince)) {
                toReturn = true;
              }
            } else {
              if (this.utilsService.after(operationalsinceDate, minDateForOperationalSince)
                && this.utilsService.before(operationalsinceDate, maxDateForOperationalSince)
                || this.utilsService.equals(operationalsinceDate, minDateForOperationalSince)
                || this.utilsService.equals(operationalsinceDate, maxDateForOperationalSince)) {
                toReturn = true;
              }
            }
          }
        }

        break;
      case "VOR Date for comissioning":
        if (nav.navaidtype == 'VOR_DME' || nav.navaidtype == 'VORTAC') {
          if (nav.voroperationalsince != null) {
            let minDateForVORReplacementDate: Date = this.getMinDateFromFilter(filter);
            let maxDateForVORReplacementDate: Date = this.getMaxDateFromFilter(filter);
            let voroperationalsinceDate: Date = new Date(nav.voroperationalsince);
            if (this.utilsService.after(voroperationalsinceDate, minDateForVORReplacementDate)
              && this.utilsService.before(voroperationalsinceDate, maxDateForVORReplacementDate)
              || this.utilsService.equals(voroperationalsinceDate, minDateForVORReplacementDate)
              || this.utilsService.equals(voroperationalsinceDate, maxDateForVORReplacementDate))
              toReturn = true;
          }
        } else {
          if (nav.operationalsince != null) {
            let minDateForVORReplacementDate: Date = this.getMinDateFromFilter(filter);
            let maxDateForVORReplacementDate: Date = this.getMaxDateFromFilter(filter);
            let operationalsinceDate: Date = new Date(nav.operationalsince);
            if (this.utilsService.after(operationalsinceDate, minDateForVORReplacementDate)
              && this.utilsService.before(operationalsinceDate, maxDateForVORReplacementDate)
              || this.utilsService.equals(operationalsinceDate, minDateForVORReplacementDate)
              || this.utilsService.equals(operationalsinceDate, maxDateForVORReplacementDate))
              toReturn = true;
          }
        }

        break;
      case "VOR Date for replacement":
        if (nav.navaidtype == 'VOR_DME' || nav.navaidtype == 'VORTAC') {
          if (nav.vordueforreplace != null) {
            let vordueforreplaceDate: Date = new Date(nav.vordueforreplace);
            let minDateForVORReplacementDate: Date = this.getMinDateFromFilter(filter);
            let maxDateForVORReplacementDate: Date = this.getMaxDateFromFilter(filter);
            if (this.utilsService.after(vordueforreplaceDate, minDateForVORReplacementDate)
              && this.utilsService.before(vordueforreplaceDate, maxDateForVORReplacementDate)
              || this.utilsService.equals(vordueforreplaceDate, minDateForVORReplacementDate)
              || this.utilsService.equals(vordueforreplaceDate, maxDateForVORReplacementDate))
              toReturn = true;
          }
        } else {
          if (nav.dueforreplacement != null) {
            let dueforreplaceDate: Date = new Date(nav.dueforreplacement);
            let minDateForVORReplacementDate: Date = this.getMinDateFromFilter(filter);
            let maxDateForVORReplacementDate: Date = this.getMaxDateFromFilter(filter);
            if (this.utilsService.after(dueforreplaceDate, minDateForVORReplacementDate)
              && this.utilsService.before(dueforreplaceDate, maxDateForVORReplacementDate)
              || this.utilsService.equals(dueforreplaceDate, minDateForVORReplacementDate)
              || this.utilsService.equals(dueforreplaceDate, maxDateForVORReplacementDate))
              toReturn = true;
          }
        }

        break;
      case "VOR Date of planned removal":
        if (nav.navaidtype == 'VOR_DME' || nav.navaidtype == 'VORTAC') {
          if (nav.vorplannedremoval != null) {
            let vorplannedremovalDate: Date = new Date(nav.vorplannedremoval);
            let minDateForVORPlannedRemoval: Date = this.getMinDateFromFilter(filter);
            let maxDateForVORPlannedRemoval: Date = this.getMaxDateFromFilter(filter);
            if (this.utilsService.after(vorplannedremovalDate, minDateForVORPlannedRemoval)
              && this.utilsService.before(vorplannedremovalDate, maxDateForVORPlannedRemoval)
              || this.utilsService.equals(vorplannedremovalDate, minDateForVORPlannedRemoval)
              || this.utilsService.equals(vorplannedremovalDate, maxDateForVORPlannedRemoval))
              toReturn = true;
          }
        } else {
          if (nav.plannedremoval != null) {
            let plannedremovalDate: Date = new Date(nav.plannedremoval);
            let minDateForVORPlannedRemoval: Date = this.getMinDateFromFilter(filter);
            let maxDateForVORPlannedRemoval: Date = this.getMaxDateFromFilter(filter);
            if (this.utilsService.after(plannedremovalDate, minDateForVORPlannedRemoval)
              && this.utilsService.before(plannedremovalDate, maxDateForVORPlannedRemoval)
              || this.utilsService.equals(plannedremovalDate, minDateForVORPlannedRemoval)
              || this.utilsService.equals(plannedremovalDate, maxDateForVORPlannedRemoval))
              toReturn = true;
          }
        }

        break;
      case "Selected Navaids on the map":
        if (filter.navaidsSelectedOnMapId && filter.navaidsSelectedOnMapId.includes(feat.get("id"))) {
          toReturn = true;
        }
        break;
      case "Bias":
        let minBias: number = this.getMinFromFilter(filter);
        let maxBias = this.getMaxFromFilter(filter);
        if (Number.isNaN(minBias) && Number.isNaN(maxBias)) {
          toReturn = nav.bias == null || nav.bias == 0;
        }
        else {
          toReturn = nav.bias <= maxBias && nav.bias >= minBias;
        }
        break;
      case "Antenna Type":
        toReturn = nav.antennatype == filter.value
        break;
      default:
        break;
    }

    return toReturn;
  }
  getMinFromFilter(filter: FilterModel): number {

    return parseFloat(filter.value.substring(0, filter.value.indexOf("<") - 1));
  }

  getMaxFromFilter(filter: FilterModel): number {
    let first: number = filter.value.indexOf("<");
    let second: number = filter.value.indexOf("<", first + 1);
    return parseFloat(
      filter.value.substring(second + 2, filter.value.length));
  }

  getMinDateFromFilter(filter: FilterModel): Date {
    let stringDate: string = filter.value.substring(0, filter.value.indexOf("<") - 1);
    let date: Date = null;
    try {
      date = new Date(stringDate);
    } catch (e) {
      e.printStackTrace();
    }
    return date;
  }

  getMaxDateFromFilter(filter: FilterModel): Date {
    let first: number = filter.value.indexOf("<");
    let second: number = filter.value.indexOf("<", first + 1);
    let stringDate: string = filter.value.substring(second + 2, filter.value.length);

    let date: Date = null;
    try {
      date = new Date(stringDate);
    } catch (e) {
      e.printStackTrace();
    }
    return date;
  }

  featureExists(feat: Feature, list: Feature[]): boolean {
    return list.some(function (el) {
      return el.getProperties().id === feat.getProperties().id;
    });
  }
  filterCoordinatePoints(filters: FilterModel[], isFilter: boolean) {
    this.clearSelectedCoordinatePoints();

    let numberOfCoordinatePoints: number = 0;
    let coordinatePointsToRemove: Feature[] = [];

    let activeFilters: FilterModel[] = [];
    for (let filter of filters) {
      if (filter.active) {
        activeFilters.push(filter);
      }
    }

    let features: Feature[] = this.getAllCoordinatePointsFeaturesFromLayers();

    features.forEach(coordPoint => {
      numberOfCoordinatePoints++;
      coordinatePointsToRemove.push(coordPoint);
      coordinatePointsToRemove = this.performFilter(coordinatePointsToRemove, this.transformFeatureInCoordinatePoint(coordPoint), coordPoint, activeFilters);
    });


    if (isFilter) {
      coordinatePointsToRemove.forEach(nav => {
        numberOfCoordinatePoints--;
      });
      this.deleteCoordinatePointsFeatures(coordinatePointsToRemove);
    } else {
      const filteredArray = features.filter(value => !coordinatePointsToRemove.includes(value));

      filteredArray.forEach(coordPoint => {
        let layer: VectorLayerDMTR = this.coordinatePointsLayers.childLayers[0].layers.find((element) => element.id === coordPoint.getProperties().type.toLowerCase()).olLayer;
        coordPoint.setStyle(layer.getStyleSelected());
        this.addSelectedFeature(coordPoint);
      })
    }

    const totalToDisplay = this.totalCoordinatePointsInProject;
    const displayedCount = activeFilters.length === 0 ? totalToDisplay : (features.length - coordinatePointsToRemove.length);
    this.informationMessageCoordinatePoints = "Displaying " + displayedCount + " of " + totalToDisplay + ".";
    return numberOfCoordinatePoints;
  }

  performFilter(coordinatePointsToRemove: Feature[], coordPoint: CoordinatePointModel, feat: Feature, filters: FilterModel[]): Feature[] {
    let iterator: number = 0;

    let orList: OrFilter[] = [];
    let andList: AndFilter[] = [];
    let toReturnOr: boolean = true;
    let toReturnAnd: boolean = true;

    filters.forEach(filter => {
      iterator++;

      let count: number = filters.filter(filter_aux => filter_aux.field == filter.field).length;
      let count_filter: number = orList.filter(filter_aux => filter_aux.getFilterName() == filter.field).length;

      if (count > 1) {
        if (count_filter > 0) {
          let filterValue: OrFilter = orList.find(orfilter => orfilter.getFilterName() == filter.field)

          filterValue.addElement(this.filterByFields(coordPoint, feat, filter));

        } else {
          let newOrFilter: OrFilter = new OrFilter(filter.field);
          newOrFilter.addElement(this.filterByFields(coordPoint, feat, filter));
          orList.push(newOrFilter);
        }
      } else {

        let newAndFilter: AndFilter = new AndFilter(filter.field);
        newAndFilter.addElement(this.filterByFields(coordPoint, feat, filter));
        andList.push(newAndFilter);
      }
    });

    orList.forEach(or => {
      toReturnOr = toReturnOr && or.getOrResult();
    })

    andList.forEach(and => {
      toReturnAnd = toReturnAnd && and.getOrResult();
    })

    if (toReturnOr && toReturnAnd) {
      const index = coordinatePointsToRemove.indexOf(feat, 0);
      if (index > -1) {
        coordinatePointsToRemove.splice(index, 1);
      }
    }
    return coordinatePointsToRemove;
  }

  filterByFields(coordPoint: CoordinatePointModel, feat: Feature, filter: FilterModel): boolean {
    let toReturn: boolean = false;

    switch (filter.field) {
      case "Type":
        toReturn = this.toInternalStringValue(filter.value) === coordPoint.type
        break;
      case "Published":
        toReturn = (filter.value === 'published') === coordPoint.userdefined;
        break;
      default:
        console.log("INVALID COORDINATE POINT TYPE");
        break;
    }

    if (coordPoint.type === 'Airspace_Boundary_Vertex'.toUpperCase()) {
      console.log("true");
    }

    return toReturn;
  }

  public applyFiltersToCoordinatePointsList(coordinatePoints: CoordinatePoint[]): CoordinatePoint[] {
    const activeFilters = this.coordinatePointsFilterService.filters.filter(f => f.active);

    if (activeFilters.length === 0) {
      return coordinatePoints;
    }

    return coordinatePoints.filter(coordPoint => {
      let orList: OrFilter[] = [];
      let andList: AndFilter[] = [];

      activeFilters.forEach(filter => {
        let count: number = activeFilters.filter(f => f.field === filter.field).length;
        let count_filter: number = orList.filter(f => f.getFilterName() === filter.field).length;

        if (count > 1) {
          if (count_filter > 0) {
            orList.filter(f => f.getFilterName() === filter.field)[0].addElement(this.filterByFieldsOnModel(coordPoint, filter));
          } else {
            let newOrFilter: OrFilter = new OrFilter(filter.field);
            newOrFilter.addElement(this.filterByFieldsOnModel(coordPoint, filter));
            orList.push(newOrFilter);
          }
        } else {
          let newAndFilter: AndFilter = new AndFilter(filter.field);
          newAndFilter.addElement(this.filterByFieldsOnModel(coordPoint, filter));
          andList.push(newAndFilter);
        }
      });

      let toReturnOr: boolean = true;
      let toReturnAnd: boolean = true;

      orList.forEach(or => {
        toReturnOr = toReturnOr && or.getOrResult();
      });

      andList.forEach(and => {
        toReturnAnd = toReturnAnd && and.getOrResult();
      });

      return toReturnOr && toReturnAnd;
    });
  }

  private filterByFieldsOnModel(coordPoint: CoordinatePoint, filter: FilterModel): boolean {
    let toReturn: boolean = false;

    // Altitude range filters are modeled via minAltitude/maxAltitude in FilterModel.
    if (filter.minAltitude != null && filter.maxAltitude != null) {
      const minAltitude = Number(filter.minAltitude);
      const maxAltitude = Number(filter.maxAltitude);

      if (isNaN(minAltitude) || isNaN(maxAltitude)) {
        return false;
      }

      return coordPoint.minaltitude >= minAltitude && coordPoint.maxaltitude <= maxAltitude;
    }

    switch (filter.field) {
      case "Type":
        toReturn = this.toInternalStringValue(filter.value) === coordPoint.type;
        break;
      case "Published":
        toReturn = (filter.value === 'published') === coordPoint.userdefined;
        break;
      default:
        break;
    }

    return toReturn;
  }

  toInternalStringValue(comboboxValue: string): string {
    let internalValue = ""

    internalValue = comboboxValue.toUpperCase().replace(/ /g, '_').trim();

    return internalValue
  }
  public deleteAnnotationsFromMap(): void {
    this.annotationLayers.childLayers?.forEach(el => {
      el.hideAll();
      el.layers.forEach(layer => {
        layer.olLayer.setVisible(false);
      }
      )
    });
    this.annotationLayers.childLayers = [];
  }

  public fetchAllAnnotations(isSwitchProject: boolean = false): void {
    this.annotations.clear();
    isSwitchProject ? this.uiBlock.startBlock("Adding entities to map...") : false;
    this.getAllAnnotations().subscribe((annotations) => {
      try {
        annotations.forEach((element) => {
          this.addAnnotationToMap(AnnotationModel.map(element));
        });
      } finally {
        isSwitchProject ? this.uiBlock.stopBlock() : false;
      }
    },
      () => {
        isSwitchProject ? this.uiBlock.stopBlock() : false;
      });
  }

  fetchAndAddPartialAirSpaceBoundaries(extent: [number, number, number, number], isSwitchProject: boolean = false): void {
    let self = this;
    isSwitchProject ? this.uiBlock.startBlock("Adding entities to map...") : false;
    this.getAirSpaceBoundariesPartial(extent).subscribe(
      (boundaries) => {
        try {
          boundaries.forEach((element) => {
            self.addAirSpaceBoundaryToMap(element);
          });
        } finally {
          if (isSwitchProject) this.uiBlock.stopBlock();
        }
      },
      () => { isSwitchProject ? this.uiBlock.stopBlock() : false; }
    );
  }

  public fetchAndAddAirSpaceBoundaries(isSwitchProject: boolean = false): void {
    let self = this;
    isSwitchProject ? this.uiBlock.startBlock("Adding entities to map...") : false;
    this.getAirSpaceBoundaries().subscribe((airspace) => {
      try {
        airspace.forEach((element) => {
          if (element.airSpaceBoundaryCoordinatePoints && element.airSpaceBoundaryCoordinatePoints.length > 1)// TODO :see why coordenate points disappear
            if (element.mapstatus) {
              self.addAirSpaceBoundaryToMap(element);
            }
        })
      } finally {
        isSwitchProject ? this.uiBlock.stopBlock() : false;
      }
    },
      () => {
        isSwitchProject ? this.uiBlock.stopBlock() : false;
      }

    );
  }

  fetchAndAddPartialTrajectories(extent: [number, number, number, number], isSwitchProject: boolean = false): void {
    let self = this;
    isSwitchProject ? this.uiBlock.startBlock("Adding entities to map...") : false;
    this.getTrajectoriesPartial(extent).subscribe(
      (trajectories) => {
        try {
          trajectories.forEach((element) => {
            if (element.trajectoryPoints && element.trajectoryPoints.length > 1)
            if (element.mapstatus) {
              self.addTrajectoryToMap(element);
            }
          });
        } finally {
          if (isSwitchProject) this.uiBlock.stopBlock();
        }
      },
      () => { if (isSwitchProject) this.uiBlock.stopBlock(); }
    );
  }

  public fetchAndAddTrajectories(isSwitchProject: boolean = false): void {
    let self = this;
    isSwitchProject ? this.uiBlock.startBlock("Adding entities to map...") : false;
    this.getTrajectories().subscribe((airspace) => {
      try {
        airspace.forEach((element) => {
          if (element.trajectoryPoints && element.trajectoryPoints.length > 1)
            if (element.mapstatus) {
              self.addTrajectoryToMap(element);
            }
        })
      } finally {
        isSwitchProject ? this.uiBlock.stopBlock() : false;
      }
    },
      () => {
        isSwitchProject ? this.uiBlock.stopBlock() : false;
      }

    );
  }

  public addAnnotationToMap(annotation: AnnotationModel): void {
    this.annotations.set(annotation.id, annotation);
    var readedFeatures = new GeoJSON().readFeatures(annotation.source, {
      featureProjection: this.rcsControl.activeRCS.isactive ? this.rcsControl.activeRCS.epsg : "EPSG:3857",// TODO: load selected crs
      dataProjection: 'CRS:84',
    });
    let features: Feature<Geometry>[] = [];
    readedFeatures.forEach(feature => {
      if (feature.getProperties().featureType == FeatureType.Annotation && feature.getProperties().annotationType == AnnotationType.Circle) {
        let circleGeometry = new Circle(feature.getProperties().center, feature.getProperties().radius).transform("EPSG:3857", this.rcsControl.activeRCS.epsg);
        var newFeature = new Feature(circleGeometry);
        newFeature.setProperties({
          annotationType: AnnotationType.Circle,
          featureType: FeatureType.Annotation,
        })
        features.push(newFeature);
      } else {
        features.push(feature);
      }
    });
    var vectorSource = new VectorSource({
      features: features,
      format: new GeoJSON({
        featureProjection: this.rcsControl.activeRCS.isactive ? this.rcsControl.activeRCS.epsg : "EPSG:3857",// TODO: load selected crs
        dataProjection: 'CRS:84',
      }),
    });
    this.createAnnotationLayer(annotation, vectorSource);
  }

  createAnnotationLayer(annotationModel: AnnotationModel, source: VectorSource): void {
    var layer: Layer =
    {
      id: annotationModel.name, name: annotationModel.name, image: '', visible: annotationModel.visible, olLayer: new VectorLayerDMTR({
        source: source,
        style: new Style({
          stroke: new Stroke({ color: annotationModel.color, width: annotationModel.lineWidth }),

        }),
        styleSelected: new Style({
          stroke: new Stroke({ color: "#ffff00", width: annotationModel.lineWidth })
        }),
      })
    };
    if (annotationModel.text != null && annotationModel.text != "") {
      var font = annotationModel.lineWidth + "px " + annotationModel.font;
      layer.olLayer.setStyle(new Style({
        text: new Text({
          font: font,
          fill: new Fill({ color: annotationModel.color }),
          text: annotationModel.text
        }),
      }));
      (layer.olLayer.styleSelected as Style).setText(new Text({
        font: "italic" + font,
        fill: new Fill({ color: "#ffff00" }),
        text: annotationModel.text
      }))
    }
    var topLayer: TopLevelLayers = new TopLevelLayers(
      true,
      layer.name,
      [layer],
      this.mapService.getMap('map'),
      this.modalConfirmationService,
      null,
      null,
      null,
      "Annotations"
    );
    topLayer.status = true;

    this.annotationLayers.childLayers.push(topLayer);
    let annotationLayerVisibility: LayerVisibility = this.userSettingsService.userSettings.annotationsVisibility.find((elem: LayerVisibility) => elem.id == layer.name);
    if (annotationLayerVisibility == null)
      this.userSettingsService.createNewVisibilityLayer("Annotations", annotationModel.name);
    else {
      layer.visible = annotationLayerVisibility.visible;
      layer.olLayer.setVisible(annotationLayerVisibility.visible);
    }
  }

  getAllAnnotations(): Observable<AnnotationModel[]> {
    return this.http.get<AnnotationModel[]>(
      this.endpointService.apiUrlAnnotations + '/list',
      this.endpointService.httpOptions
    )
  }

  saveAnnotation(annotation: AnnotationModel): Observable<any> {
    if (annotation.id == null) {
      return this.http
        .post<any>(
          this.endpointService.apiUrlAnnotations,
          annotation,
          this.endpointService.httpOptions
        );
    } else {
      return this.http
        .put<any>(
          this.endpointService.apiUrlAnnotations,
          annotation,
          this.endpointService.httpOptions
        );
    }
  }

  public addProcedureToMap(procedure: ProcedureModel): void {
    if (!procedure.mapstatus) {
      return;
    }

    let layer: Layer = this.proceduresLayers.childLayers[0].layers
      .find((element) => element.id === procedure.proceduretype.toLowerCase());
    if (!layer) return;

    if (!procedure.mapstatus) {
      return;
    }

    let vectorSource = layer.olLayer.getSource();
    if (vectorSource.getFeatureById(procedure.id)) {
      return;
    }

    let sidSource = this.proceduresLayers.childLayers[0].layers
      .find((element) => element.id === 'sid')
      .olLayer.getSource();
    let enrouteSource = this.proceduresLayers.childLayers[0].layers
      .find((element) => element.id === 'enroute')
      .olLayer.getSource();
    let starSource = this.proceduresLayers.childLayers[0].layers
      .find((element) => element.id === 'star')
      .olLayer.getSource();
    let assessmentSource = this.proceduresLayers.childLayers[0].layers
      .find((element) => element.id === 'assessment')
      .olLayer.getSource();

    let marker = this.createProcedureFeature(procedure);
    switch (procedure.proceduretype) {
      case 'SID':
        sidSource.addFeature(marker);

        break;
      case 'STAR':
        starSource.addFeature(marker);
        break;
      case 'ENROUTE':
        enrouteSource.addFeature(marker);
        break;
      case 'ASSESSMENT':
        assessmentSource.addFeature(marker);
        break;
      default:
        break;
    }
  }
  public zoomToProcedures(procedures: ProcedureModel[]) {
    if (procedures.length > 0) {
      let featureExtent = olExtent.createEmpty();
      procedures.forEach(procedure => {
        let feature: Feature = this.createProcedureFeature(procedure);
        olExtent.extend(featureExtent, feature.getGeometry().getExtent());
      });
      this.mapService.getMap('map').getView().fit(featureExtent);
    }

  }
  public async addProcedureOffSetToMap(procedure: ProcedureModel): Promise<void> {
    let assessmentSource = this.proceduresLayers.childLayers[0].layers
      .find((element) => element.id === 'assessment')
      .olLayer.getSource();
    let assessmentSOffsetource = this.proceduresLayers.childLayers[0].layers
      .find((element) => element.id === 'assessmentoffset')
      .olLayer.getSource();

    let marker = this.createProcedureFeature(procedure);
    assessmentSource.addFeature(marker);

    let marker2 = await this.createProcedureOofsetFeature(procedure);
    assessmentSOffsetource.addFeature(marker2);
  }

  public getProcedureOffSet(procedure: ProcedureModel): Feature<Geometry> {
    let assessmentSOffsetSource = this.proceduresLayers.childLayers[0].layers
      .find((element) => element.id === 'assessmentoffset')
      .olLayer.getSource();

    for (const feature of assessmentSOffsetSource.getFeatures()) {
      if (feature.get('id') === procedure.id) {
        return feature;
      }
    }

    return null;

  }

  public removeProcedureOffSetFromMap(procedure: ProcedureModel) {
    let assessmentSOffsetSource = this.proceduresLayers.childLayers[0].layers
      .find((element) => element.id === 'assessmentoffset')
      .olLayer.getSource();
    // let marker2 = await this.createProcedureOofsetFeature(procedure);
    const sourceOffset = this.proceduresLayers.childLayers[0].layers
      .find((element) => element.id === 'assessmentoffset')
      .olLayer.getSource();

    let features = sourceOffset.getFeatures().filter((feature) => feature.get('id') == procedure.id);
    if (features != null && features.length > 0) {

      features.forEach((feature) =>
        sourceOffset.removeFeature(feature))
    }
  }

  public addAirSpaceBoundaryToMap(airspaceBoundary: AirSpaceBoundaryModel): void {
    if (!airspaceBoundary.mapstatus) {
      return;
    }

    let airSpaceLayerSource = this.airspaceboundariesLayers.childLayers[0].layers
      .find((element) => element.id === 'Air_Space_Boundary')
      .olLayer.getSource();

    if (!airspaceBoundary.mapstatus) {
      return;
    }

    if (airSpaceLayerSource.getFeatureById(airspaceBoundary.id)) {
      return;
    }

    this.updateNavaidsAssociatedAirspace(airspaceBoundary);

    let color = this.userSettingsService.userSettings.colorSettings.airspaceColor;
    let marker = this.createAirSpaceBoundaryFeature(airspaceBoundary, color);
    let style: Style = new Style({
      fill: new Fill({ color: marker.getProperties().originalColor }),
      stroke: new Stroke({ color: marker.getProperties().originalColor, width: 2 })
    });
    marker.setStyle(style)
    airSpaceLayerSource.addFeature(marker);
    //this.addSelectedFeature(marker);

  }
  public addTrajectoryToMap(trajectory: TrajectoryModel): void {
    if (!trajectory.mapstatus) {
      return;
    }

    let trajectoryLayerSource = this.trajecttoriesLayers.childLayers[0].layers
      .find((element) => element.id === 'Trajectory')
      .olLayer.getSource();

    if (!trajectory.mapstatus){
      return;
    }

    if (trajectoryLayerSource.getFeatureById(trajectory.uniqueid)) {
      return;
    }
    let marker = this.createTrajectoryFeature(trajectory);
    trajectoryLayerSource.addFeature(marker);

    //this.addSelectedFeature(marker);

  }
  public fetchAndAddFlightInspection(isSwitchProject: boolean = false) {
    isSwitchProject ? this.uiBlock.startBlock("Adding entities to map...") : false;
    const projectId = this.projectService.activeProject.id;
    this.http.get(
      this.endpointService.endpointGetAllFlightInspection,
      {
        ...this.endpointService.httpOptions,
        params: { projectId: projectId }
      }
    )
      .subscribe((flightInspections: any) => {
        try {
          flightInspections.forEach(element => {
            let flightInspection: any = JSON.parse(element.flightinspectionstr);
            flightInspection.id = element.id;
            this.addFlightInspectionToMap(flightInspection, false);
          });
        } finally {
          isSwitchProject ? this.uiBlock.stopBlock() : false;
        }
      },
        () => {
          isSwitchProject ? this.uiBlock.stopBlock() : false;
        })
  }

  public fetchAndAddProcessingTool(isSwitchProject: boolean = false) {
    isSwitchProject ? this.uiBlock.startBlock("Adding entities to map...") : false;
    const projectId = this.projectService.activeProject.id;
    this.http.get(
      this.endpointService.endpointGetAllProcessingTool,
      {
        ...this.endpointService.httpOptions,
        params: { projectId: projectId }
      }
    )
      .subscribe((processingTools: Processingtool[]) => {
        try {
          processingTools.forEach(element => {
            let processingTool: any = JSON.parse(element.processingtoolstr);
            this.addProcessingToolToMap(processingTool.infoRows, element.layername, processingTool.fileFormat, processingTool.config, processingTool.defaultConfig, element.id, false);

          });
        } finally {
          isSwitchProject ? this.uiBlock.stopBlock() : false;
        }
      },
        (error) => {
          console.error(error);
          isSwitchProject ? this.uiBlock.stopBlock() : false;
        })
  }
  public addFlightInspectionToMap(flightInspection: any, zoom: boolean = true) {
    let layerVisibility: LayerVisibility = this.userSettingsService.userSettings.flightInspectionsVisibility.find(layer => layer.id == "" + flightInspection.id);

    let layer: Layer[] = [
      {
        id: "" + flightInspection.id, name: flightInspection.config.layerName, image: 'saam.svg', visible: layerVisibility ? layerVisibility.visible : true,
        olLayer: new VectorLayerDMTR({
          source: new VectorSource(),
          styleSelected: new Style({
            image: new CircleStyle({
              radius: 1,
              fill: new Fill({ color: 'yellow' }),
            })
          })
        }),
      }
    ];
    let newLayer: TopLevelLayers = new TopLevelLayers(true, flightInspection.name, layer, this.mapService.getMap('map'), this.modalConfirmationService);
    // let layerVisibilities = this.userSettingsService.userSettings.layerVisibilities
    // .find(element => element[0] == "Flight Inspections")[1]
    // if(addVisibilityUserSettings){
    //   layerVisibilities
    //   .push({id: flightInspection.id, visible: true});
    //   this.userSettingsService.updateSettings();
    // }
    // else{
    //   newLayer.layers[0].visible = layerVisibilities.find(value=> value.id == flightInspection.id ).visible;
    //   newLayer.layers[0].olLayer.setVisible(newLayer.layers[0].visible);
    // }
    if (flightInspection.config.fileFormat == "CSV" || flightInspection.config.fileFormat == "EDS") {
      newLayer.flightInspection_attributes = cloneDeep(flightInspection.config.fieldsConfigurationTable.filter((elem) => elem.hasStyle && elem.checked));
      if (flightInspection.config.fileFormat == "EDS")
        newLayer.flightInspection_attributes.forEach(attribute => attribute.navaidID = flightInspection.config.navaid.split('-')[0])

    }
    else if (flightInspection.config.fileFormat == "Aerodata") {
      newLayer.flightInspection_attributes = cloneDeep(flightInspection.config.fieldsConfigurationTable.filter((elem) => elem.hasStyle && elem.checked));
      for (let i = 0; i < flightInspection.config.channels.length; i++) {
        if (flightInspection.config.channels[i].checked) {
          let channelAttributes = flightInspection.config['channel' + (i + 1)].filter((elem) => elem.hasStyle && elem.checked && !elem.key.endsWith('Frequency'));
          channelAttributes.forEach(channelAttribute => channelAttribute.navaidID = flightInspection.config.channels[i].channelName.split('-')[0]);
          newLayer.flightInspection_attributes.push(...channelAttributes);
        }
      }
    }
    //newLayer.index_selected = 0;
    newLayer.flightInspectionId = flightInspection.id;
    this.flightInspectionLayer.childLayers.push(newLayer)
    let source = newLayer.layers[0].olLayer.getSource();
    let features: Feature[] = [];
    flightInspection.infoRows.forEach((elem) => {
      //let value: number = elem.values[newLayer.flightInspection_attributes[newLayer.index_selected].name];
      let myStyle = new Style({
        image: new CircleStyle({
          radius: 1.5,
          fill: new Fill({ color: 'black' }),
        })
      })
      let feat = new Feature({
        geometry: new Point(olProj.fromLonLat([elem.longitude, elem.latitude], this.mapService.getMaps().getView().getProjection())),
        name: flightInspection.name,
        id: flightInspection.id,
        featureType: FeatureType.FlightInspection,
        values: elem.values,
        originalStyle: myStyle
      });
      feat.setStyle(myStyle);
      features.push(feat);
      source.addFeature(feat);

    });
    if (zoom) {

      let featureExtent = olExtent.createEmpty();
      features.forEach(feature => {
        olExtent.extend(featureExtent, feature.getGeometry().getExtent());
      });
      this.mapService.getMap('map').getView().fit(featureExtent);
    }
  }

  public addProcessingToolToMap(infoRows: WietzeToolRowInfo[], layerName: string, fileFormat: string, config: any, defaultConfig: any, id: number, zoom: boolean = true) {
    let layerVisibility: LayerVisibility = this.userSettingsService.userSettings.processingToolVisibility.find(layer => layer.id == "" + id);

    let layer: Layer[] = [
      {
        id: "" + id, name: layerName, image: 'saam.svg', visible: layerVisibility ? layerVisibility.visible : true,
        olLayer: new VectorLayerDMTR({
          source: new VectorSource(),
          styleSelected: new Style({
            image: new CircleStyle({
              radius: 1,
              fill: new Fill({ color: 'yellow' }),
            })
          })
        }),
      }
    ];
    let newLayer: TopLevelLayers = new TopLevelLayers(true, "Processing Tool", layer, this.mapService.getMap('map'), this.modalConfirmationService);
    // let layerVisibilities = this.userSettingsService.userSettings.layerVisibilities
    // .find(element => element[0] == "Processing Tool")[1]
    // if(addVisibilityUserSettings){
    //   layerVisibilities
    //   .push({id: id, visible: true});
    //   this.userSettingsService.updateSettings();
    // }
    // else{
    //   newLayer.layers[0].visible = layerVisibilities.find(value=> value.id == id ).visible;
    //   newLayer.layers[0].olLayer.setVisible(newLayer.layers[0].visible);
    // }


    if (fileFormat == "CSV" || fileFormat == "EDS 300") {
      newLayer.processingTool_attributes = config.fileFormatElements.filter((csvField) => { return csvField.style != null && csvField.style.length != 0 })
      if (fileFormat == "EDS 300") {
        newLayer.processingTool_attributes.push(...config.flags.filter((csvField) => { return csvField.style != null && csvField.style.length != 0 }));
        newLayer.processingTool_attributes.push(...config.sots.filter((csvField) => { return csvField.style != null && csvField.style.length != 0 }));
      }
    }
    else {
      newLayer.processingTool_attributes = config.fileFormatElements.filter((csvField) => { return csvField.style != null && csvField.style.length != 0 })
      const channelIndex = config.channels.findIndex(channel => channel.navaidId == config.currentChannel);
      newLayer.processingTool_attributes.push(...config.channels[channelIndex].columns.filter((csvField) => { return csvField.isWietzeToolRequired }))
    }
    newLayer.processingTool_attributes.push(...defaultConfig.fileFormatElements.filter((csvField) => { return csvField.style != null && csvField.style.length != 0 }))
    //newLayer.index_selected = 0;
    newLayer.flightInspectionId = id;
    this.processingToolLayer.childLayers.push(newLayer)
    let source = newLayer.layers[0].olLayer.getSource();
    let features: Feature[] = [];
    infoRows.forEach((elem) => {
      //let value: number = elem.values[newLayer.flightInspection_attributes[newLayer.index_selected].name];
      let myStyle = new Style({
        image: new CircleStyle({
          radius: 1.5,
          fill: new Fill({ color: 'black' }),
        })
      })
      let feat = new Feature({
        geometry: new Point(olProj.fromLonLat([elem.longitude, elem.latitude], this.mapService.getMaps().getView().getProjection())),
        name: layerName,
        id: id,
        featureType: FeatureType.ProcessingTool,
        values: elem.values,
        originalStyle: myStyle
      });
      feat.setStyle(myStyle);
      source.addFeature(feat);
      features.push(feat);



    })

    if (zoom) {

      let featureExtent = olExtent.createEmpty();
      features.forEach(feature => {
        olExtent.extend(featureExtent, feature.getGeometry().getExtent());
      });
      this.mapService.getMap('map').getView().fit(featureExtent);
    }

  }
  public getColorFromColorInterval(value: number, colorIntervals: any[]) {
    let isFlagAndEqualsValue: boolean = false
    if (colorIntervals == null) {
      return 'black';
    }
    let integerValue: number;
    if (value >= 0) {
      integerValue = Math.floor(value);
    }
    else {
      integerValue = Math.ceil(value);
    }

    for (let colorInterval of colorIntervals) {
      if (colorInterval.colorcode == "27" || colorInterval.colorcode == "28" || colorInterval.colorcode == "29") {
        if (value == colorInterval.minValue || value == colorInterval.maxValue) {
          isFlagAndEqualsValue = true;
        }
      }
      let isBiggerThanMin: boolean = colorInterval.isMinValueInfinite ? true : colorInterval.minValue <= integerValue;
      let isSmallerThanMax: boolean = colorInterval.isMaxValueInfinite ? true : integerValue < colorInterval.maxValue
      if ((isBiggerThanMin && isSmallerThanMax) || isFlagAndEqualsValue) {
        return colorInterval.color;
      }
    }
  }

  public getColorFromColorIntervalProcessingTool(value: number, colorIntervals: any[]) {
    let isFlagAndEqualsValue: boolean = false
    if (colorIntervals == null) {
      return 'black';
    }

    for (let colorInterval of colorIntervals) {
      if (colorInterval.colorcode == "27" || colorInterval.colorcode == "28" || colorInterval.colorcode == "29") {
        if (value == colorInterval.minValue || value == colorInterval.maxValue) {
          isFlagAndEqualsValue = true;
        }
      }
      let isBiggerThanMin: boolean = colorInterval.isMinValueInfinite ? true : colorInterval.minValue <= value;
      let isSmallerThanMax: boolean = colorInterval.isMaxValueInfinite ? true : value <= colorInterval.maxValue
      if ((isBiggerThanMin && isSmallerThanMax) || isFlagAndEqualsValue) {
        return colorInterval.color;
      }
    }
  }
  public changeFlightInspectionAttribute(layer: TopLevelLayers, i: number) {
    layer.index_selected = i;
    let flightInspectionFeatures: Feature[] = layer.layers[0].olLayer.getSource().getFeatures();
    flightInspectionFeatures.forEach((feature) => {
      let value: number = feature.getProperties().values[layer.flightInspection_attributes[i].name];
      let myStyle = new Style({
        image: new CircleStyle({
          radius: 1.5,
          fill: new Fill({ color: this.getColorFromColorInterval(value, layer.flightInspection_attributes[i].style) }),
        })
      })
      let feat = new Feature({
        geometry: feature.getProperties().geometry,
        name: feature.getProperties().name,
        id: feature.getProperties().id,
        featureType: FeatureType.FlightInspection,
        values: feature.getProperties().values,
        originalStyle: myStyle
      });
      layer.layers[0].olLayer.getSource().removeFeature(feature);
      feat.setStyle(myStyle);
      layer.layers[0].olLayer.getSource().addFeature(feat);
    })
  }
  public changeProcessingToolAttribute(layer: TopLevelLayers, i: number) {
    layer.index_selected = i;
    let processingToolFeatures: Feature[] = layer.layers[0].olLayer.getSource().getFeatures();
    processingToolFeatures.forEach((feature) => {
      let value: number = feature.getProperties().values[layer.processingTool_attributes[i].key];
      let myStyle = new Style({
        image: new CircleStyle({
          radius: 1.5,
          fill: new Fill({ color: this.getColorFromColorIntervalProcessingTool(value, layer.processingTool_attributes[i].style) }),
        })
      })
      let feat = new Feature({
        geometry: feature.getProperties().geometry,
        name: feature.getProperties().name,
        id: feature.getProperties().id,
        featureType: FeatureType.ProcessingTool,
        values: feature.getProperties().values,
        originalStyle: myStyle
      });
      layer.layers[0].olLayer.getSource().removeFeature(feature);
      feat.setStyle(myStyle);
      layer.layers[0].olLayer.getSource().addFeature(feat);
    })
  }

  public deleteFlightInspection() {
    let selectedLayers: TopLevelLayers[] = this.flightInspectionLayer.childLayers.filter((layer) => layer.layerSelected);
    if (selectedLayers.length == 0) {
      this.modalService.showMesssageModal("Delete Flight Inspection Error", "Please select flight inspection on map.")
      return;
    }
    let features: Feature[] = [];
    selectedLayers.forEach(layer => features.push(layer.layers[0].olLayer.getSource().getFeatures()[0]))

    const bsModalRef: BsModalRef = this.popupService.show(DynamicTable, {
      backdrop: 'static' // Prevent closing on backdrop click
    });
    bsModalRef.content.entity = "Flight Inspection";
    bsModalRef.content.type = "Delete";
    bsModalRef.content.selectAllActive = true;
    bsModalRef.content.data = features;
    bsModalRef.content.displayedColumns = this.utilsService.getDynamicTableColumns("Flight Inspection");
    bsModalRef.content.onClose.subscribe(result => {
      if (result.length > 0) {
        this.modalConfirmation.showMesssageConfirmationModal("Delete Flight Inspection", "Do you want to delete the selected Flight Inspection?", "Yes", "No",
          () => {
            let ids: number[] = [];
            this.uiBlock.startBlock("Deleting Flight Inspection Tool layers...");
            result.forEach(elem => {
              ids.push(elem.get("id"));
            });
            this.deleteFlightInspectionsBulk(ids).subscribe((results) => {
              result.forEach(feature => {
                let layer: TopLevelLayers = selectedLayers.find(layer => layer.flightInspectionId == feature.get("id"));
                let i = this.flightInspectionLayer.childLayers.findIndex(x => x.flightInspectionId == layer.flightInspectionId);
                layer.layers[0].olLayer.setVisible(false);
                this.flightInspectionLayer.childLayers.splice(i, 1);
                i = this.userSettingsService.userSettings.flightInspectionsVisibility.findIndex(layer => layer.id == feature.get("id"));
                this.userSettingsService.userSettings.flightInspectionsVisibility.splice(i, 1);
              });
              this.userSettingsService.updateSettings();
              this.modalService.showMesssageModal("Flight Inspection Tool", "Flight Inspection Tool layers deleted with success.");
              this.uiBlock.stopBlock();
            },
              (error) => {
                this.uiBlock.stopBlock();
                if (error && error.status == 401) {
                  this.modalService.showMesssageModal(
                    'Error Deleting',
                    'Default Project is not editable.'
                  )
                  return;
                }
                this.modalService.showMesssageModal("Flight Inspection Tool", "Error deleting Flight Inspection Tool Layers.");
              });
          });
      }
    })
  }

  public deleteProcessingTool() {
    let selectedLayers: TopLevelLayers[] = this.processingToolLayer.childLayers.filter((layer) => layer.layerSelected);
    if (selectedLayers.length == 0) {
      this.modalService.showMesssageModal("Delete Processing Tool Error", "Please select a processing tool on map.")
      return;
    }
    let features: Feature[] = [];
    selectedLayers.forEach(layer => features.push(layer.layers[0].olLayer.getSource().getFeatures()[0]))

    const bsModalRef: BsModalRef = this.popupService.show(DynamicTable, {
      backdrop: 'static' // Prevent closing on backdrop click
    });
    bsModalRef.content.entity = "Processing Tool";
    bsModalRef.content.type = "Delete";
    bsModalRef.content.selectAllActive = true;
    bsModalRef.content.data = features;
    bsModalRef.content.displayedColumns = this.utilsService.getDynamicTableColumns("Processing Tool");
    bsModalRef.content.onClose.subscribe(result => {
      if (result.length > 0) {
        this.modalConfirmation.showMesssageConfirmationModal("Delete Processing Tool", "Do you want to delete the selected Processing Tools?", "Yes", "No",
          () => {
            let ids: number[] = [];
            this.uiBlock.startBlock("Deleting Processing Tool layers...");
            result.forEach(elem => {
              ids.push(elem.get("id"));
            });
            this.deleteProcessingToolBulk(ids).subscribe((results) => {
              result.forEach(feature => {
                let layer: TopLevelLayers = selectedLayers.find(layer => layer.flightInspectionId == feature.get("id"));
                this.processingToolLayer.deleteLayer(layer);
                let i = this.userSettingsService.userSettings.processingToolVisibility.findIndex(layer => layer.id == feature.get("id"))
                this.userSettingsService.userSettings.processingToolVisibility.splice(i, 1);
              });
              this.userSettingsService.updateSettings();
              this.modalService.showMesssageModal("Processing Tool", "Processing Tool layers deleted with success.");
              this.uiBlock.stopBlock();
            },
              (error) => {
                this.uiBlock.stopBlock();
                if (error && error.status == 401) {
                  this.modalService.showMesssageModal(
                    'Error Deleting',
                    'Default Project is not editable.'
                  )
                  return;
                }
                this.modalService.showMesssageModal("Processing Tool", "Error deleting Processing Tool Layers.");
              });
          });
      }
    })
  }

  public deleteFlightInspectionsFromMap(): void {

    this.flightInspectionLayer.childLayers.forEach(function (childLayer: TopLevelLayers) {
      for (let layer of childLayer.layers) {
        layer.olLayer.getSource().clear();
      }
    });
    this.flightInspectionLayer.childLayers = [];
  }

  public deleteProcessingToolsFromMap(): void {

    this.processingToolLayer.childLayers.forEach(function (childLayer: TopLevelLayers) {
      for (let layer of childLayer.layers) {
        layer.olLayer.getSource().clear();
      }
    });
    this.processingToolLayer.childLayers = [];
  }
  public deleteUserLayers() {
    for (let layer of this.userLayers.childLayers[0].layers) {
      layer.olLayer.getSource().clear();
    }
    this.userLayers.childLayers[0].layers = [];
  }
  public addProcedureFeatureToMap(procedure: Feature): void {
    let sidSource = this.proceduresLayers.childLayers[0].layers
      .find((element) => element.id === 'sid')
      .olLayer.getSource();
    let enrouteSource = this.proceduresLayers.childLayers[0].layers
      .find((element) => element.id === 'enroute')
      .olLayer.getSource();
    let starSource = this.proceduresLayers.childLayers[0].layers
      .find((element) => element.id === 'star')
      .olLayer.getSource();
    let assessmentSource = this.proceduresLayers.childLayers[0].layers
      .find((element) => element.id === 'assessment')
      .olLayer.getSource();

    switch (procedure.getProperties().proceduretype) {
      case 'SID':
        sidSource.addFeature(procedure);
        break;
      case 'STAR':
        starSource.addFeature(procedure);
        break;
      case 'ENROUTE':
        enrouteSource.addFeature(procedure);
        break;
      case 'ASSESSMENT':
        assessmentSource.addFeature(procedure);
        break;
      default:
        break;
    }
  }

  public addCoordinatePointToMap(coordinatePoint: CoordinatePoint, procedureAssessment?: boolean) {
    let indexToFeatureMap: Map<number, Feature<Geometry>>;
    let layer: Layer;
    const published: boolean = !coordinatePoint.userdefined;
    switch (coordinatePoint.type) {
      case 'WAYPOINT':
        layer = this.coordinatePointsLayers.childLayers[0].layers
          .find((element) => element.id === 'waypoint')

        if (published) {
          indexToFeatureMap = this.waypointsPublishedIndexToFeature;
        } else {
          indexToFeatureMap = this.waypointsIndexToFeature;
        }

        break;
      case 'ARP_CIVIL':
        layer = this.coordinatePointsLayers.childLayers[0].layers
          .find((element) => element.id === 'arp_civil')

        if (published) {
          indexToFeatureMap = this.arpCivilPublishedIndexToFeature;
        } else {
          indexToFeatureMap = this.arpCivilIndexToFeature;
        }

        break;
      case 'ARP_MILITAR':
        layer = this.coordinatePointsLayers.childLayers[0].layers
          .find((element) => element.id === 'arp_militar')

        if (published) {
          indexToFeatureMap = this.arpMilitarPublishedIndexToFeature;
        } else {
          indexToFeatureMap = this.arpMilitarIndexToFeature;
        }

        break;
      case 'ARP_MIXED':
        layer = this.coordinatePointsLayers.childLayers[0].layers
          .find((element) => element.id === 'arp_mixed')

        if (published) {
          indexToFeatureMap = this.arpMixedPublishedIndexToFeature;
        } else {
          indexToFeatureMap = this.arpMixedIndexToFeature;
        }

        break;
      case 'RWY_THR':
        layer = this.coordinatePointsLayers.childLayers[0].layers
          .find((element) => element.id === 'rwy_thr')

        if (published) {
          indexToFeatureMap = this.rwyThrPublishedIndexToFeature;
        } else {
          indexToFeatureMap = this.rwyThrIndexToFeature;
        }

        break;
      case 'AIRSPACE_BOUNDARY_VERTEX':
        layer = this.coordinatePointsLayers.childLayers[0].layers
          .find((element) => element.id === 'airspace_vertex')

        if (published) {
          indexToFeatureMap = this.airspaceVertexPublishedIndexToFeature;
        } else {
          indexToFeatureMap = this.airspaceVertexIndexToFeature;
        }

        break;
      case 'FIX_POINT':
        layer = this.coordinatePointsLayers.childLayers[0].layers
          .find((element) => element.id === 'fix_point')

        if (published) {
          indexToFeatureMap = this.fixPointPublishedIndexToFeature;
        } else {
          indexToFeatureMap = this.fixPointIndexToFeature;
        }

        break;
      default:
        this.modalService.showMesssageModal("Error", "There was an error adding the Coordinate Point to the map.");
        return;
    }

    const vectorSource = layer.olLayer.getSource();
    if (procedureAssessment) {
      const marker = this.createCoordinatePointFeature(coordinatePoint, null, true);

      let layerStyle: Style = (layer.olLayer.getStyle()) as Style;
      let iconSelected: Icon = (layerStyle.getImage() as Icon);
      const color = this.getColorOfType('Coordinate Points', layer.id, marker.get("userdefined"));
      let style = new Style({
        image: new Icon({
          scale: layerStyle.getImage().getScale(),
          color: color ? color : "black",
          src: iconSelected.getSrc(),
        }),
      });
      marker.setStyle(style);
      vectorSource.addFeature(marker);
      return;
    }
    const publishedIndex = this.getPublishedIndexForMultiPointVectorSource(vectorSource, published);
    const coordinates = (vectorSource.getFeatures()[publishedIndex].getGeometry() as MultiPoint).getCoordinates();
    coordinates.push(olProj.fromLonLat([coordinatePoint.longitude, coordinatePoint.latitude], this.mapService.getMaps().getView().getProjection()));
    indexToFeatureMap.set(coordinates.length - 1, this.createCoordinatePointFeature(coordinatePoint));
    this.createAndAddMultiPointFeatureToLayer(coordinates, layer, published);
  }


  getPublishedIndexForMultiPointVectorSource(vectorSource: VectorSource, published: boolean): number {
    // if (vectorSource.getFeatures().length == 0) {
    //   return 0;
    // }
    return vectorSource.getFeatures().findIndex(f => {
      const geometry = f;
      return geometry && geometry.getGeometry().getType() === 'MultiPoint' && f.get(CoordinatePointModel.PUBLISHED_FEATURE_PROPERTY) == published;
    })

  }

  public fetchAndAddPartialNavaids(extent: [number, number, number, number], isSwitchProject: boolean = false): void {
    let self = this;
    // console.log(extent)
    isSwitchProject ? this.uiBlock.startBlock("Adding entities to map...") : false;
    this.getNavaidsPartial(extent).subscribe(
      (navaids) => {
        try {
          navaids.forEach((element) => {
            self.addNavaidToMap(element);
          })
          this.filterNavaids(this.navaidsFilterService.filters, true);
        } finally {
          isSwitchProject ? this.uiBlock.stopBlock() : false;
        }
      },
      () => {
        isSwitchProject ? this.uiBlock.stopBlock() : false;
      }
    );
  }

  public fetchAndAddNavaids(isSwitchProject: boolean = false): void {
    let self = this;
    isSwitchProject ? this.uiBlock.startBlock("Adding entities to map...") : false;
    this.getNavaids().subscribe((navaids) => {
      try {
        navaids.forEach((element) => {
          self.addNavaidToMap(element);
        })
        this.filterNavaids(this.navaidsFilterService.filters, true);
      } finally {
        isSwitchProject ? this.uiBlock.stopBlock() : false;
      }
    },
      () => {
        isSwitchProject ? this.uiBlock.stopBlock() : false;
      }
    );
  }
  getColorOfType(type, subtype, userdefined) {
    let colorObject: any = this.userSettingsService.getColorObject(type);
    let colorOfType: any[] = colorObject[subtype];
    if (subtype == 'all') {
      return colorOfType[0].color;
    }
    else {
      let color = colorOfType[userdefined ? 1 : 0].color;
      if (color == '') {
        color = colorObject.all[0].color;
      }
      return color;
    }
  }
  public addNavaidToMap(navaid: NavaidModel): void {
    let selected_feature: Feature[] = this.getSelectedFeatures().filter(feat => feat.get("featureType") == FeatureType.Navaid && feat.getProperties().id == navaid.id);

    let layer: Layer = this.navaidsLayers.childLayers[0].layers
      .find((element) => element.id === navaid.navaidtype.toLowerCase());
    if (!layer) return;

    let vectorSource = layer.olLayer.getSource();
    if (vectorSource.getFeatureById(navaid.id)) {
      return;
    }

    let DMEVectorSource = this.navaidsLayers.childLayers[0].layers
      .find((element) => element.id === 'dme')
      .olLayer.getSource();
    let VOR_DMEVectorSource = this.navaidsLayers.childLayers[0].layers
      .find((element) => element.id == 'vor_dme')
      .olLayer.getSource();
    let TACANVectorSource = this.navaidsLayers.childLayers[0].layers
      .find((element) => element.id == 'tacan')
      .olLayer.getSource();
    let VORTACVectorSource = this.navaidsLayers.childLayers[0].layers
      .find((element) => element.id == 'vortac')
      .olLayer.getSource();
    let DME_ILSVectorSource = this.navaidsLayers.childLayers[0].layers
      .find((element) => element.id == 'dme_ils')
      .olLayer.getSource();
    let VORVectorSource = this.navaidsLayers.childLayers[0].layers
      .find((element) => element.id == 'vor')
      .olLayer.getSource();
    let NDBVectorSource = this.navaidsLayers.childLayers[0].layers
      .find((element) => element.id == 'ndb')
      .olLayer.getSource();
    // let colorType : ColorOfType = this.configurationColorService.colorOftypes.find(
    //   (colorType:ColorOfType) =>
    //   {
    //       return colorType.type == "Navaids"
    //       && colorType.subtype == navaid.navaidtype
    //       && (navaid.userdefined? colorType.status == "User Defined": colorType.status == "Published")
    //     }
    // )
    // if(colorType.color == ''){
    // colorType =  this.configurationColorService.colorOftypes.find((colorType: ColorOfType) =>{
    //     return colorType.subtype == "All Navaids";
    //   })
    // }
    let color = this.getColorOfType('Navaids', navaid.navaidtype.toLowerCase(), navaid.userdefined);
    let marker = this.createNavaidFeature(navaid, color);

    switch (navaid.navaidtype) {
      case 'DME':
        DMEVectorSource.addFeature(marker);
        if (selected_feature.length > 0) {
          marker.setStyle(this.navaidsLayers.childLayers[0].layers
            .find((element) => element.id === 'dme')
            .olLayer.getStyleSelected());
          this.removeSelectedFeature(selected_feature[0]);
          this.addSelectedFeature(marker);
        }
        break;
      case 'VOR_DME':
        VOR_DMEVectorSource.addFeature(marker);
        if (selected_feature.length > 0) {
          marker.setStyle(this.navaidsLayers.childLayers[0].layers
            .find((element) => element.id === 'vor_dme')
            .olLayer.getStyleSelected());
          this.removeSelectedFeature(selected_feature[0]);
          this.addSelectedFeature(marker);
        }
        break;
      case 'TACAN':
        TACANVectorSource.addFeature(marker);
        if (selected_feature.length > 0) {
          marker.setStyle(this.navaidsLayers.childLayers[0].layers
            .find((element) => element.id === 'tacan')
            .olLayer.getStyleSelected());
          this.removeSelectedFeature(selected_feature[0]);
          this.addSelectedFeature(marker);
        }
        break;
      case 'VORTAC':
        VORTACVectorSource.addFeature(marker);
        if (selected_feature.length > 0) {
          marker.setStyle(this.navaidsLayers.childLayers[0].layers
            .find((element) => element.id === 'vortac')
            .olLayer.getStyleSelected());
          this.removeSelectedFeature(selected_feature[0]);
          this.addSelectedFeature(marker);
        }
        break;
      case 'DME_ILS':
        DME_ILSVectorSource.addFeature(marker);
        if (selected_feature.length > 0) {
          marker.setStyle(this.navaidsLayers.childLayers[0].layers
            .find((element) => element.id === 'dme_ils')
            .olLayer.getStyleSelected());
          this.removeSelectedFeature(selected_feature[0]);
          this.addSelectedFeature(marker);
        }
        break;
      case 'VOR':
        VORVectorSource.addFeature(marker);
        if (selected_feature.length > 0) {
          marker.setStyle(this.navaidsLayers.childLayers[0].layers
            .find((element) => element.id === 'vor')
            .olLayer.getStyleSelected());
          this.removeSelectedFeature(selected_feature[0]);
          this.addSelectedFeature(marker);
        }
        break;
      case 'NDB':
        NDBVectorSource.addFeature(marker);
        if (selected_feature.length > 0) {
          marker.setStyle(this.navaidsLayers.childLayers[0].layers
            .find((element) => element.id === 'ndb')
            .olLayer.getStyleSelected());
          this.removeSelectedFeature(selected_feature[0]);
          this.addSelectedFeature(marker);
        }
        break;
    }

    if (layer != null) {
      let layerStyle: Style = (layer.olLayer.getStyle()) as Style;
      let iconSelected: Icon = (layerStyle.getImage() as Icon);
      const style = function () {
        const zoom = this.mapService.getMap('map').getView().getZoom();
        let text = marker.get('navaidid');
        if (!this.showNavaidsIdOnMap || zoom < MapService.SHOW_TEXT_ON_MAP_ZOOM_LIMIT) {
          text = "";
        }
        const textStyle = NavaidTextStyle;
        textStyle.setText(text);
        return [
          new Style({
            image: new Icon({
              scale: layerStyle.getImage().getScale(),
              color: marker.getProperties().originalColor,
              src: iconSelected.getSrc(),
            }),
            text: textStyle
          })
        ];
      }.bind(this);
      layer.olLayer.getSource().removeFeature(marker);
      marker.setStyle(style);
      layer.olLayer.getSource().addFeature(marker);
    }

  }
  addSAAMAirSpaceToMap(saam: SAAMAirSpace) {
    //let regions= [];
    let saammFeatures: Feature[] = [];
    saam.SAAMRegionSet.forEach((region: SAAMRegion) => {
      //let regionPoints = [[45,8],[45,7],[46,7],[46,8],[45,8]];

      let regionPoints = [];
      region.regionVertexSet.forEach((vertex: SAAMVertex) => {
        regionPoints.push(olProj.fromLonLat([vertex.longitude, vertex.latitude], this.mapService.getMaps().getView().getProjection()))
      });
      let redCode: number = region.value1 / 16777216;
      let quotient: number = region.value1 % 16777216;
      let greenCode: number = quotient / 65536;
      let quotient1: number = quotient % 65536;
      let blueCode: number = quotient1 / 256;
      let fillColor = `rgba(${redCode},${greenCode},${blueCode},${quotient1 / 255})`
      let saamFeature: Feature = new Feature({
        id: saam.Id,
        name: saam.name,
        featureType: FeatureType.SAAMTraffic,
        geometry: new Polygon([regionPoints]),
        originalColor: fillColor
      });
      let style = new Style({
        fill: new Fill({ color: fillColor }),
        //fill: new Fill({color: 'red'}),
        stroke: new Stroke({ color: 'black', width: 1 })
      })
      saamFeature.setStyle(style);
      saammFeatures.push(saamFeature);
      //this.vectorSource.addFeature(saamFeature);
    });
    let source = this.saamTrafficDensityLayer.childLayers[0].layers[0]
      .olLayer.getSource();

    source.addFeatures(saammFeatures);

    this.saamTrafficDensityLayer.childLayers[0].layers[0].olLayer.setVisible(this.userSettingsService.userSettings.saamTrafficLayerSettings.saamLayerVisibility.SAAM_Traffic_Layer);
    this.saamTrafficDensityLayer.childLayers[0].layers[0].visible = this.userSettingsService.userSettings.saamTrafficLayerSettings.saamLayerVisibility.SAAM_Traffic_Layer;

  }
  public deleteFromLayers(layers: TopLevelLayers): void {
    layers.layers.forEach((element) => {
      element.olLayer.getSource().clear();
    });
  }

  public deleteFromParents(parentLayers: ParentLayers): void {
    parentLayers.childLayers.forEach((toplevelLayer) => {
      toplevelLayer.layers.forEach((element) => {
        element.olLayer.getSource().clear();
      });
    });
  }

  public createProcedureFeature(obj: ProcedureModel): Feature {
    let points = [];
    for (let index = 0; index < obj.procedureLegs.length; index++) {
      if (index == 0) {
        //first
        points.push([
          obj.procedureLegs[index].startPoint.coordPoint.longitude,
          obj.procedureLegs[index].startPoint.coordPoint.latitude,
        ]);
        if (!obj.procedureLegs[index].isstraightleg) {
          obj.procedureLegs[index].curvePoints.forEach(curvePoint => {
            points.push([curvePoint.longitude, curvePoint.latitude]);
          });
        }
        points.push([
          obj.procedureLegs[index].endPoint.coordPoint.longitude,
          obj.procedureLegs[index].endPoint.coordPoint.latitude,
        ]);
      } else if (index == obj.procedureLegs.length - 1) {
        //last
        if (!obj.procedureLegs[index].isstraightleg) {
          obj.procedureLegs[index].curvePoints.forEach(curvePoint => {
            points.push([curvePoint.longitude, curvePoint.latitude]);
          });
        }
        points.push([
          obj.procedureLegs[index].endPoint.coordPoint.longitude,
          obj.procedureLegs[index].endPoint.coordPoint.latitude,
        ]);
      } else {
        if (!obj.procedureLegs[index].isstraightleg) {
          obj.procedureLegs[index].curvePoints.forEach(curvePoint => {
            points.push([curvePoint.longitude, curvePoint.latitude]);
          });
        }
        points.push([
          obj.procedureLegs[index].endPoint.coordPoint.longitude,
          obj.procedureLegs[index].endPoint.coordPoint.latitude,
        ]);
      }

    }
    console.log();



    for (var i = 0; i < points.length; i++) {
      points[i] = olProj.transform(points[i], 'EPSG:4326', this.mapService.getMaps().getView().getProjection());
    }

    let feat = new Feature({
      geometry: new LineString(points),
      id: obj.id,
      airport: obj.airport,
      aircraftspeed: obj.aircraftspeed,
      freetext: obj.freetext,
      name: obj.name,
      procedureid: obj.procedureid,
      proceduretype: obj.proceduretype,
      referenceairportpk: obj.referenceAirportPk,
      rnavperformancetype: obj.rnavperformancetype,
      procedurelegs: obj.procedureLegs,
      navaids: obj.navaids,
      criticalNavaids: obj.criticalNavaids,
      mapstatus: obj.mapstatus,
      type: obj.proceduretype,
      selectedOnManage: false,
      featureType: 2,//procedure
      isSelected: false,
      iDNotEditable: obj.iDNotEditable,
      latLonNotEditable: obj.latLonNotEditable
    });
    feat.setId(obj.id);
    return feat;
  }

  private async createProcedureOofsetFeature(obj: ProcedureModel): Promise<Feature> {
    let points = [];

    let offsetLegs: ProcedureLegModel[] = [];

    for (let index = 0; index < obj.procedureLegs.length; index++) {

      const legToOffSet = obj.procedureLegs[index];

      let procOffset = new ProcedureLegModel();

      if (legToOffSet.offset != 0.0 && legToOffSet.direction != "NotSet") {
        //get angle
        const azimuthAngle = await this.getAzimuthAngle(legToOffSet.startPoint.coordPoint, legToOffSet.endPoint.coordPoint);

        //get offset for starpoint
        const startCPoffset = await this.getCoordinateOffset(legToOffSet.startPoint.coordPoint, legToOffSet.offset, azimuthAngle, legToOffSet.direction);

        //get offset for endpoint
        const endCPoffset = await this.getCoordinateOffset(legToOffSet.endPoint.coordPoint, legToOffSet.offset, azimuthAngle, legToOffSet.direction);


        procOffset.startPoint = cloneDeep(legToOffSet.startPoint);
        procOffset.startPoint.coordPoint = startCPoffset;
        procOffset.endPoint = cloneDeep(legToOffSet.endPoint);
        procOffset.endPoint.coordPoint = endCPoffset;
        if (offsetLegs.length > 0) {
          offsetLegs[offsetLegs.length - 1].endPoint = cloneDeep(legToOffSet.startPoint);
          offsetLegs[offsetLegs.length - 1].endPoint.coordPoint = startCPoffset;
        }


      } else {
        procOffset.startPoint = cloneDeep(legToOffSet.startPoint);
        procOffset.endPoint = cloneDeep(legToOffSet.endPoint);


      }
      if (!legToOffSet.isstraightleg && legToOffSet.fixPoint != null) {
        procOffset.isstraightleg = false;
        procOffset.fixPoint = cloneDeep(legToOffSet.fixPoint);
        procOffset.curvePoints = clone(legToOffSet.curvePoints);
      }

      offsetLegs.push(procOffset);

    }

    for (let index = 0; index < offsetLegs.length; index++) {
      // const shouldDraw = obj.procedureLegs[index].startPoint.coordPoint.coordpointid.includes('_offset') || obj.procedureLegs[index].endPoint.coordPoint.coordpointid.includes('_offset')
      // if ( !shouldDraw )
      //   continue;

      if (index == 0) {
        //first
        points.push([
          offsetLegs[index].startPoint.coordPoint.longitude,
          offsetLegs[index].startPoint.coordPoint.latitude,
        ]);
        if (!offsetLegs[index].isstraightleg) {
          offsetLegs[index].curvePoints.forEach(curvePoint => {
            points.push([curvePoint.longitude, curvePoint.latitude]);
          });
        }
        points.push([
          offsetLegs[index].endPoint.coordPoint.longitude,
          offsetLegs[index].endPoint.coordPoint.latitude,
        ]);
      } else if (index == offsetLegs.length - 1) {
        //last
        if (!offsetLegs[index].isstraightleg) {
          offsetLegs[index].curvePoints.forEach(curvePoint => {
            points.push([curvePoint.longitude, curvePoint.latitude]);
          });
        }
        points.push([
          offsetLegs[index].endPoint.coordPoint.longitude,
          offsetLegs[index].endPoint.coordPoint.latitude,
        ]);
      } else {
        if (!offsetLegs[index].isstraightleg) {
          offsetLegs[index].curvePoints.forEach(curvePoint => {
            points.push([curvePoint.longitude, curvePoint.latitude]);
          });
        }
        points.push([
          offsetLegs[index].endPoint.coordPoint.longitude,
          offsetLegs[index].endPoint.coordPoint.latitude,
        ]);
      }

    }

    for (var i = 0; i < points.length; i++) {
      points[i] = olProj.transform(points[i], 'EPSG:4326', this.mapService.getMaps().getView().getProjection());
    }

    let feat = new Feature({
      geometry: new LineString(points),
      id: obj.id,
      airport: obj.airport,
      aircraftspeed: obj.aircraftspeed,
      freetext: obj.freetext,
      name: obj.name,
      procedureid: obj.procedureid,
      proceduretype: "assessmentoffset",
      referenceairportpk: obj.referenceAirportPk,
      rnavperformancetype: obj.rnavperformancetype,
      procedurelegs: obj.procedureLegs,
      navaids: obj.navaids,
      criticalNavaids: obj.criticalNavaids,
      mapstatus: obj.mapstatus,
      type: "ASSESSMENToffset",
      selectedOnManage: false,
      featureType: 2,//procedure
      isSelected: false
    });

    return feat;
  }

  async getAzimuthAngle(startPoint, endPoint): Promise<number> {
    const requestAngle = {
      startPoint: startPoint,
      destPoint: endPoint
    };

    let angle = 0;


    const resp = await this.http
      .post(
        `${this.endpointService.endpointOffset}/getAzimuth`,
        requestAngle,
        this.endpointService.httpOptions
      ).toPromise();/*
        .subscribe(
          (data) => {
            console.log(data);
            if(!data){
              this.modalService.showMesssageModal('Azimuth Angle', 'Cannot calculate Azimuth angle.');
            }else {
              angle = Number(data);

            }
          },
          (error) => {
            this.modalService.showMesssageModal("Error", "Error calculating Azimuth angle.");
          }
        ).toPromisse(); */

    angle = Number(resp);
    return angle;
  }

  async getCoordinateOffset(coordinatePoint: CoordinatePointModel, offset: number, angle: number, direction: string): Promise<CoordinatePointModel> {
    const requestOffset = {
      pointToTransform: coordinatePoint,
      offsetValue: offset,
      angle: angle,
      direction: direction,
    };

    let coordinatePointOffset = cloneDeep(coordinatePoint);
    coordinatePointOffset.coordpointid += "_offset";

    const resp = await firstValueFrom(this.http
      .post<coordinatePointTransformationOffsetResult>(
        `${this.endpointService.endpointOffset}/transformCoordOffset`,
        requestOffset,
        this.endpointService.httpOptions
      ));
    /*
    .subscribe(
      (data: coordinatePointTransformationOffsetResult) => {
        console.log(data);
        if(!data){
          this.modalService.showMesssageModal('Coordinate Offset', 'Cannot calculate offset for this coordinate point.');
        }else {
          coordinatePointOffset.latitude = Number(data.latitude);
          coordinatePointOffset.latitude = Number(data.longetude);

        }
      },
      (error) => {
        this.modalService.showMesssageModal("Error", "Error calculating offiset.");
      }
    ); */

    coordinatePointOffset.latitude = Number((resp).latitude);
    coordinatePointOffset.longitude = Number((resp).longitude);

    return coordinatePointOffset;
  }

  private createAirSpaceBoundaryFeature(obj: AirSpaceBoundaryModel, color?: string): Feature {
    let points = [];

    if (!obj.airSpaceBoundaryCoordinatePoints || obj.airSpaceBoundaryCoordinatePoints.length < 1) {
      return new Feature();
    }

    let startPoint = obj.airSpaceBoundaryCoordinatePoints[0];

    points.push([
      startPoint.coordPoint.longitude,
      startPoint.coordPoint.latitude,
    ]);

    for (let index = 1; index < obj.airSpaceBoundaryCoordinatePoints.length; index++) {
      let currentPoint = obj.airSpaceBoundaryCoordinatePoints[index];

      points.push([
        currentPoint.coordPoint.longitude,
        currentPoint.coordPoint.latitude,
      ]);

      if (index === obj.airSpaceBoundaryCoordinatePoints.length - 1) {
        points.push([
          startPoint.coordPoint.longitude,
          startPoint.coordPoint.latitude,
        ]);
      }
    }


    for (var i = 0; i < points.length; i++) {
      points[i] = olProj.transform(points[i], 'EPSG:4326', this.mapService.getMaps().getView().getProjection());
    }

    let feat = new Feature({
      geometry: new LineString(points),
      id: obj.id,
      airspaceboundaryid: obj.airspaceboundaryid,
      uniqueid: obj.uniqueid,
      airSpaceBoundaryCoordinatePoints: obj.airSpaceBoundaryCoordinatePoints,
      airSpaceBoundaryLines: obj.airSpaceBoundaryLines,
      name: obj.name,
      navaids: obj.navaids,
      selectedOnManage: false,
      mapstatus: obj.mapstatus,
      originalColor: typeof (color) == "undefined" || color == "" || color == null ? 'red' : color,
      featureType: FeatureType.AirSpaceBoundary
    });
    feat.setId(obj.id);
    return feat;
  }

  private createTrajectoryFeature(obj: TrajectoryModel): Feature {
    let points = [];

    if (!obj.trajectoryPoints || obj.trajectoryPoints.length < 1) {
      return new Feature();
    }

    for (let index = 0; index < obj.trajectoryPoints.length; index++) {
      let currentPoint = obj.trajectoryPoints[index];

      points.push([
        currentPoint.longitude,
        currentPoint.latitude,
      ]);

    }

    for (var i = 0; i < points.length; i++) {
      points[i] = olProj.transform(points[i], 'EPSG:4326', this.mapService.getMaps().getView().getProjection());
    }

    let feat = new Feature({
      geometry: new LineString(points),
      id: obj.uniqueid,
      uniqueid: obj.uniqueid,
      trajectoryPoints: obj.trajectoryPoints,
      totalPoints: obj.trajectoryPoints.length,
      name: obj.name,
      procedureId: obj.procedureId,
      procedureName: obj.procedureName,
      procedureType: obj.procedureType,
      procedureRNAV: obj.procedureRnav,
      selectedOnManage: false,
      mapstatus: obj.mapstatus,
      featureType: FeatureType.Trajectory
    });
    feat.setId(obj.uniqueid);
    return feat;
  }


  public createNavaidFeature(obj: NavaidModel, originalColor?: string): Feature {
    let feat = new Feature({
      geometry: new Point(olProj.fromLonLat([obj.longitude, obj.latitude], this.mapService.getMaps().getView().getProjection())),
      antennatype: obj.antennatype,
      antheight: obj.antheight,
      arinc424fom: obj.arinc424fom,
      bias: obj.bias,
      cableloss: obj.cableloss,
      channel: obj.channel,
      cone: obj.cone,
      declaredeirp: obj.declaredeirp,
      dmetacanclass: obj.dmetacanclass,
      doc: obj.doc,
      dueforreplacement: obj.dueforreplacement,
      elevation: obj.elevation,
      equipmenttype: obj.equipmenttype,
      fligthinspectioninterval: obj.fligthinspectioninterval,
      icaocc: obj.icaocc,
      id: obj.id,
      infosrce: obj.infosrce,
      infoupdate: obj.infoupdate,
      lastinspection: obj.lastinspection,
      latitude: obj.latitude,
      longitude: obj.longitude,
      losthreshold: obj.losthreshold,
      manufacturer: obj.manufacturer,
      maxaltitude: obj.maxaltitude,
      maxload: obj.maxload,
      meetingpost1989sarps: obj.meetingpost1989sarps,
      model: obj.model,
      mtbo: obj.mtbo,
      name: obj.name,
      navaidid: obj.navaidid,
      navaidtype: obj.navaidtype,
      ndbfrequency: obj.ndbfrequency,
      notes: obj.notes,
      notupdate: obj.notupdate,
      offsetdist: obj.offsetdist,
      operationalsince: obj.operationalsince,
      operationalstatus: obj.operationalstatus,
      operator: obj.operator,
      plannedinspection: obj.plannedinspection,
      plannedremoval: obj.plannedremoval,
      quiescentsquitterrate: obj.quiescentsquitterrate,
      sectorizationtext: obj.sectorizationtext,
      sectorizations: obj.sectorizations,
      associatedProcedures: obj.associatedProcedures,
      associatedAirspaceBoundaries: obj.associatedAirspaceBoundaries,
      associatedProceduresCritical: obj.associatedProceduresCritical,
      actualScreeningAngle: obj.actualScreeningAngle,
      transmoutpower: obj.transmoutpower,
      updated: obj.updated,
      userdefined: obj.userdefined,
      usesectorization: obj.usesectorization,
      vordocmaxrange: obj.vordocmaxrange,
      vordueforreplace: obj.vordueforreplace,
      vorinpectioninterval: obj.vorinpectioninterval,
      vorlastinsp: obj.vorlastinsp,
      vorlatitude: obj.vorlatitude,
      vorlongitude: obj.vorlongitude,
      vormanufacturer: obj.vormanufacturer,
      vormodel: obj.vormodel,
      voroperationalsince: obj.voroperationalsince,
      voroperstatus: obj.voroperstatus,
      vorplannedinspection: obj.vorplannedinspection,
      vorplannedremoval: obj.vorplannedremoval,
      vortype: obj.vortype,
      originalColor: typeof (originalColor) == "undefined" || originalColor == "" || originalColor == null ? 'black' : originalColor,
      navaidFiles: obj.navaidFiles,
      featureType: FeatureType.Navaid,
      antennaModelName: obj.antennaModelName
    });
    feat.setId(obj.id);
    return feat;
  }

  setGeometryForCoordinatePointFeature(coordinatePointFeature: Feature) {
    coordinatePointFeature.setGeometry
      (
        new Point(olProj.fromLonLat([coordinatePointFeature.get("longitude"), coordinatePointFeature.get("latitude")], this.mapService.getMaps().getView().getProjection()))
      );
  }

  createCoordinatePointFeature(obj: CoordinatePoint, color?: string, withGeometry?: boolean): Feature {
    let feat = new Feature({

      geometry: withGeometry ? new Point(olProj.fromLonLat([obj.longitude, obj.latitude], this.mapService.getMaps().getView().getProjection())) : null,
      coordpointid: obj.coordpointid,
      id: obj.id,
      latitude: obj.latitude,
      longitude: obj.longitude,
      maxaltitude: obj.maxaltitude,
      minaltitude: obj.minaltitude,
      name: obj.name,
      nominalaltitude: obj.nominalaltitude,
      notupdate: obj.notupdate,
      type: obj.type,
      updated: obj.updated,
      userdefined: obj.userdefined,
      featureType: FeatureType.CoordinatePoint,
      configId: obj.configId,
      projectId: obj.projectId,
      uuid: obj.uuid ? obj.uuid : null,
      originalColor: typeof (color) == "undefined" || color == "" || color == null ? 'black' : color,
    });
    feat.setId(obj.id);
    return feat;
  }

  saveCoordinatePoint(coordinatePointPayload: CoordinatePoint): boolean {
    if (coordinatePointPayload.id == null) {
      this.http
        .post<any>(
          this.endpointService.apiUrlCoordinatePoints,
          coordinatePointPayload,
          this.endpointService.httpOptions
        )
        .subscribe(
          (data) => {
            if (data.coordPointDTO != null) {
              this.addCoordinatePointToMap(data.coordPointDTO as CoordinatePoint);
              this.fetchTotalCoordinatePointsCount();

              if (this.coordinatePointsFilterService.filters.some(f => f.active)) {
                this.filterCoordinatePoints(this.coordinatePointsFilterService.filters, true);
              }

              this.modalService.showMesssageModal('Coordinate Point', 'Coordinate Point created successfully.');
            } else {
              //TODO: Specify error if needed
              this.modalService.showMesssageModal('Error', 'Error creating coordinate point');
            }
            return data.errorList;
          },
          (error) => {
            if (error && error.status == 401) {
              this.modalService.showMesssageModal(
                'Error Saving',
                'Default Project is not editable.'
              )
              return;
            }
            this.modalService.showMesssageModal(
              'Error Saving',
              `Error saving the coordinate points.`
            );
          }
        );
      return true;
    } else {
      this.http
        .put(
          this.endpointService.apiUrlCoordinatePoints + '/' + coordinatePointPayload.id,
          coordinatePointPayload,
          this.endpointService.httpOptions
        )
        .subscribe(
          (data) => {
            const extent = this.mapService.getCurrentExtent();
            this.selectedCoordinatePoints.clear();
            this.deleteCoordinatePointsFromMap();
            //this.fetchAndAddCoordinatePoints(); // Get all OR
            if (this.coordinatePointsFilterService.filters.some(f => f.active)) {
              this.fetchAndAddCoordinatePoints();
            } else {
              this.fetchAndAddPartialCoordinatePoints(extent); // Get partial results by extent
            }
            this.deleteAllProceduresFromMap();
            this.getProcedures().subscribe(procedures => {
              procedures.forEach(procedure => {
                this.addProcedureToMap(procedure);
              })
            });
            this.modalService.showMesssageModal('Coordinate Point', 'Coordinate Point updated with success.');
            return data;
          },
          (error) => {
            if (error && error.status == 401) {
              this.modalService.showMesssageModal(
                'Error Updating',
                'Default Project is not editable.'
              )
              return;
            }
            this.modalService.showMesssageModal(
              'Error Updating',
              `Error updating the coordinate points.`
            );
          }
        );
      return true;
    }
  }

  deleteCoordinatePoint(id: string): Observable<boolean> {
    this.http
      .delete<boolean>(
        this.endpointService.apiUrlCoordinatePoints + '/' + id,
        this.endpointService.httpOptions
      )
      .subscribe(
        () => {
          const coordPointConfigIndex: number = this.configurationService.currentConfiguration.coordPoints.findIndex(p => p.id.toString() == id);
          if (coordPointConfigIndex != -1) {
            this.configurationService.currentConfiguration.coordPoints.splice(coordPointConfigIndex, 1);
          }
          return true;
        },
        (error) => {
          if (error && error.status == 401) {
            this.modalService.showMesssageModal(
              'Error Deleting',
              'Default Project is not editable.'
            )
            return;
          }
          this.modalService.showMesssageModal(
            'Error Deleting',
            `Error deleting the coordinate points.`
          );
        }
      );
    return of(false);
  }


  public reprojectMap(projection: string): void {
    const sourceProjection: string = this.mapService.getMaps().getView().getProjection().getCode();
    this.mapService.reprojectMap(projection);
    const extent = this.mapService.getCurrentExtent();

    this.deleteNavaidsFromMap();
    // ---------
    // Get all navaids after importing
    // this.getNavaids()
    // ---------
    // OR
    // ---------
    // Get partial navaids results by extent
    this.getNavaidsPartial(extent)
    // ---------
      .subscribe((navaids) =>
        navaids.forEach((element) => {
          this.addNavaidToMap(element);
        })
    );

    this.selectedCoordinatePoints.clear();
    this.deleteCoordinatePointsFromMap();
    //this.fetchAndAddCoordinatePoints(); // Get all OR
    this.fetchAndAddPartialCoordinatePoints(extent); // Get partial results by extent

    this.deleteProceduresFromMap();
    // this.fetchAndAddProcedures();  // Get all  OR
    this.fetchAndAddPartialProcedures(extent); // Get partial results by extent

    this.deleteAnnotationsFromMap();
    this.fetchAllAnnotations();
    this.reprojectUserLayers();

    this.reprojectGeoJsonStaticLayers();

    this.dbBoundaryLayer.childLayers[0].layers[0].olLayer.getSource()
      .getFeatures().forEach(feature =>
        feature.getGeometry().transform(sourceProjection, projection)
      );
  }

  reprojectGeoJsonStaticLayers() {
    for (const staticLayer of this.configurationService.currentConfiguration.layers) {
      if (staticLayer.type == "GeoJsonLayer" && staticLayer.enabled) {
        this.mapService.populateGeoJsonLayer(staticLayer);
      }
    }
  }


  //only for user layer features
  reprojectUserLayerFeatures(layer: Layer, userLayer: UserLayer) {
    layer.olLayer.getSource().clear();
    let features: Feature[];
    if (userLayer.type == UserLayerTypes.KML) {
      const kmlFormat = new KML();
      features = kmlFormat.readFeatures(userLayer.data, {
        featureProjection: this.rcsControl.activeRCS.isactive ? this.rcsControl.activeRCS.epsg : "EPSG:3857",
        dataProjection: 'CRS:84'
      })

    }
    else {
      features = new GeoJSON().readFeatures(JSON.parse(userLayer.data), {
        featureProjection: this.rcsControl.activeRCS.isactive ? this.rcsControl.activeRCS.epsg : "EPSG:3857",
        dataProjection: 'CRS:84'
      })
    }
    layer.olLayer.getSource().addFeatures(features);

  }

  reprojectUserLayers() {
    this.userLayers.childLayers[0].layers.forEach((layer: Layer) => {
      const userLayer: UserLayer = this.userSettingsService.userSettings.userLayers
        .find((userLayer: UserLayer) => JSON.stringify(userLayer.id) == layer.id);
      this.reprojectUserLayerFeatures(layer, userLayer);
    })
  }


  //TODO: DELETE THIS FUNC AND USE TRANSFORM FROM PROCEDURE SERVICE -> CIRCULAR DEPENDENCY TO SOLVE
  transformFeatureInProcedure(
    arg0: Feature<import('ol/geom/Geometry').default>
  ): ProcedureModel {
    let model: ProcedureModel = new ProcedureModel();
    model.id = arg0.get('id');
    model.procedureid = arg0.get('procedureid');
    model.name = arg0.get('name');
    model.proceduretype = arg0.get('proceduretype');
    model.referenceAirportPk = arg0.get('referenceairportpk');
    model.rnavperformancetype = arg0.get('rnavperformancetype');
    model.mapstatus = arg0.get('mapstatus');
    model.aircraftspeed = arg0.get('aircraftspeed');
    model.airport = arg0.get('airport');
    model.freetext = arg0.get('freetext');
    model.procedureLegs = arg0.get('procedurelegs');
    model.iDNotEditable = arg0.get('iDNotEditable');
    model.latLonNotEditable = arg0.get('latLonNotEditable');

    let coordPoints: ProcedureCoordinatePointModel[] = [];
    let i = 0;
    let coordPointSequenceNumber = 0;
    if (model.procedureLegs != null) {
      model.procedureLegs.forEach(leg => {
        if (!(coordPoints.filter(e => e.id == leg.startPoint.id).length > 0)) {
          //leg.startPoint.coordPoint.wtype = leg.startPoint.procedurecoordpointtype;
          leg.startPoint.coordPoint.altitude = leg.startPoint.altitude;
          if (leg.startPoint.coordPoint.published == undefined) {
            leg.startPoint.coordPoint.published = true;
          }
          leg.startPoint.sequencenumber = coordPointSequenceNumber++;
          coordPoints.push(leg.startPoint);
        }
        if (!(coordPoints.filter(e => e.id == leg.endPoint.id).length > 0)) {
          //leg.endPoint.coordPoint.wtype = leg.endPoint.procedurecoordpointtype;
          leg.endPoint.coordPoint.altitude = leg.endPoint.altitude;
          if (leg.endPoint.coordPoint.published == undefined) {
            leg.endPoint.coordPoint.published = true;
          }
          leg.endPoint.sequencenumber = coordPointSequenceNumber++;
          coordPoints.push(leg.endPoint);
        }
        i++;
      });
    }

    model.procedureCoordinatePoints = coordPoints;
    model.actualLegId = i - 1;


    // This actions are needed to apply the date conversion for each date field in each navaid
    let resultingNavaids: NavaidModel[] = [];
    let navaids: NavaidModel[] = arg0.get('navaids');
    let criticalNavaids: NavaidModel[] = arg0.get('criticalNavaids');
    if (navaids != undefined && criticalNavaids != undefined) {
      navaids = navaids.concat(criticalNavaids).sort((a, b) => a.navaidid.localeCompare(b.navaidid));
      navaids.forEach(nav => {
        let navaidPayload = this.getNavaidPayload(nav);
        navaidPayload.critical = nav.critical;
        resultingNavaids.push(navaidPayload);
      });
    } else {
      navaids = [];
    }


    model.navaids = resultingNavaids;

    return model;
  }

  transformFeatureInAirspaceBoundary(
    arg0: Feature<import('ol/geom/Geometry').default>,
  ): AirSpaceBoundaryModel {
    let model: AirSpaceBoundaryModel = new AirSpaceBoundaryModel();
    model.id = arg0.get('id');
    model.uniqueid = arg0.get('uniqueid');
    model.airspaceboundaryid = arg0.get('airspaceboundaryid');
    model.navaids = arg0.get('navaids');
    model.name = arg0.get('name');
    let airSpaceBoundaryCoordpointsAux = arg0.get('airSpaceBoundaryCoordinatePoints');
    airSpaceBoundaryCoordpointsAux.forEach(point => {
      point.coordPoint.published = true;
    })
    model.airSpaceBoundaryCoordinatePoints = airSpaceBoundaryCoordpointsAux;

    return model;
  }

  transformFeatureInTrajectory(
    arg0: Feature<import('ol/geom/Geometry').default>,
  ): TrajectoryModel {
    let model: TrajectoryModel = new TrajectoryModel();
    model.uniqueid = arg0.get('uniqueid');
    model.name = arg0.get('name');
    model.procedureId = arg0.get('procedureId');
    model.procedureName = arg0.get('procedureName');
    model.procedureRnav = arg0.get('procedureRnav');
    model.procedureType = arg0.get('procedureType');
    model.trajectoryPoints = arg0.get('trajectoryPoints');
    model.mapstatus = arg0.get('mapstatus');

    return model;
  }

  transformFeatureInFlightInspectionDataModel(
    arg0: Feature<import('ol/geom/Geometry').default>,
  ): FligthInspectionDataModel {
    let model: FligthInspectionDataModel = new FligthInspectionDataModel();
    model.altitude = arg0.get('values')["Altitude"] != undefined ? arg0.get('values')["Altitude"] : arg0.get('values')["altitude"];
    model.gs_latitude = arg0.get('values')["Ground Station Latitude"];
    model.gs_longitude = arg0.get('values')["Ground Station Longitude"];
    model.measured_power_level = arg0.get('values')["Measured Power Level"];
    model.dme1_flux_dens = arg0.get('values')["dme1FluxDens"];
    model.dme1_err_rng = arg0.get('values')["dme1ErrRng"];
    model.dme2_flux_dens = arg0.get('values')["dme2FluxDens"];
    model.dme2_err_rng = arg0.get('values')["dme2ErrRng"];
    model.tac1_freq = arg0.get('values')["tac1Frequency"];
    model.tac1_err_rng = arg0.get('values')["tacan1ErrRng"];
    model.peak_level = arg0.get('values')["PeakLevel"];

    return model;
  }


  transformFeatureInProcessingToolDataModel(
    arg0: Feature<import('ol/geom/Geometry').default>,
  ): FligthInspectionDataModel {
    let model: FligthInspectionDataModel = new FligthInspectionDataModel();
    model.altitude = arg0.get('values')["COM_4"] != undefined ? arg0.get('values')["COM_4"] : null;
    model.gs_latitude = arg0.get('values')["COM_2"] != undefined ? arg0.get('values')["COM_2"] : null;
    model.gs_longitude = arg0.get('values')["COM_3"] != undefined ? arg0.get('values')["COM_3"] : null;
    model.measured_power_level = arg0.get('values')["COM_6"] != undefined ? arg0.get('values')["COM_6"] : null;
    model.dme1_flux_dens = arg0.get('values')["AD_10"] != undefined ? arg0.get('values')["AD_10"] : null;
    model.dme1_err_rng = arg0.get('values')["AD_14"] != undefined ? arg0.get('values')["AD_14"] : null;
    model.dme2_flux_dens = arg0.get('values')["AD_15"] != undefined ? arg0.get('values')["AD_15"] : null;
    model.dme2_err_rng = arg0.get('values')["AD_19"] != undefined ? arg0.get('values')["AD_19"] : null;
    model.tac1_flux_dens = arg0.get('values')["AD_21"] != undefined ? arg0.get('values')["AD_21"] : null;
    model.tac1_err_rng = arg0.get('values')["AD_24"] != undefined ? arg0.get('values')["AD_24"] : null;
    model.tac2_flux_dens = arg0.get('values')["AD_26"] != undefined ? arg0.get('values')["AD_26"] : null;
    model.tac2_err_rng = arg0.get('values')["AD_29"] != undefined ? arg0.get('values')["AD_29"] : null;
    model.peak_level = arg0.get('values')["ED_6"] != undefined ? arg0.get('values')["ED_6"] : null;
    model.power_density_flag = arg0.get('values')["PP_4"] != undefined ? arg0.get('values')["PP_4"] : null;
    model.los_flag = arg0.get('values')["PP_3"] != undefined ? arg0.get('values')["PP_3"] : null;
    model.prediction_flag = arg0.get('values')["PP_5"] != undefined ? arg0.get('values')["PP_5"] : null;

    return model;
  }


  getNavaidPayload(navaid: NavaidModel) {
    let navaidPayload: NavaidModel = <NavaidModel><unknown>{
      "antennatype": navaid.antennatype,
      "antheight": navaid.antheight,
      "arinc424fom": navaid.arinc424fom,
      "bias": navaid.bias,
      "cableloss": navaid.cableloss,
      "channel": navaid.channel,
      "cone": navaid.cone,
      "critical": navaid.critical,
      "declaredeirp": navaid.declaredeirp,
      "dmetacanclass": navaid.dmetacanclass,
      "doc": navaid.doc,
      "dueforreplacement": navaid.dueforreplacement != null ? moment(navaid.dueforreplacement).format('yyyy-MM-DD') : null,
      "elevation": navaid.elevation,
      "equipmenttype": navaid.equipmenttype,
      "fligthinspectioninterval": navaid.fligthinspectioninterval,
      "icaocc": navaid.icaocc,
      "id": navaid.id,
      "infosrce": navaid.infosrce,
      "infoupdate": navaid.infoupdate != null ? moment(navaid.infoupdate).format('yyyy-MM-DD') : null,
      "lastinspection": navaid.lastinspection != null ? moment(navaid.lastinspection).format('yyyy-MM-DD') : null,
      "latitude": navaid.latitude,
      "longitude": navaid.longitude,
      "losthreshold": navaid.losthreshold,
      "manufacturer": navaid.manufacturer,
      "maxaltitude": navaid.maxaltitude,
      "maxload": navaid.maxload,
      "meetingpost1989sarps": navaid.meetingpost1989sarps,
      "model": navaid.model,
      "mtbo": navaid.mtbo,
      "name": navaid.name,
      "navaidid": navaid.navaidid,
      "navaidtype": navaid.navaidtype,
      "ndbfrequency": navaid.ndbfrequency,
      "notes": navaid.notes,
      "notupdate": navaid.notupdate,
      "offsetdist": navaid.offsetdist,
      "operationalsince": navaid.operationalsince != null ? moment(navaid.operationalsince).format('yyyy-MM-DD') : null,
      "operationalstatus": navaid.operationalstatus,
      "operator": navaid.operator,
      "plannedinspection": navaid.plannedinspection != null ? moment(navaid.plannedinspection).format('yyyy-MM-DD') : null,
      "plannedremoval": navaid.plannedremoval != null ? moment(navaid.plannedremoval).format('yyyy-MM-DD') : null,
      "quiescentsquitterrate": navaid.quiescentsquitterrate,
      "sectorizationtext": navaid.sectorizationtext,
      "transmoutpower": navaid.transmoutpower,
      "updated": navaid.updated,
      "userdefined": true,
      "usesectorization": true,
      "vordocmaxrange": navaid.vordocmaxrange,
      "vordueforreplace": navaid.vordueforreplace != null ? moment(navaid.vordueforreplace).format('yyyy-MM-DD') : null,
      "vorinpectioninterval": navaid.vorinpectioninterval,
      "vorlastinsp": navaid.vorlastinsp != null ? moment(navaid.vorlastinsp).format('yyyy-MM-DD') : null,
      "vorlatitude": navaid.latitude,
      "vorlongitude": navaid.longitude,
      "vormanufacturer": navaid.vormanufacturer,
      "vormodel": navaid.vormodel,
      "voroperationalsince": navaid.voroperationalsince != null ? moment(navaid.voroperationalsince).format('yyyy-MM-DD') : null,
      "voroperstatus": navaid.voroperstatus,
      "vorplannedinspection": navaid.vorplannedinspection != null ? moment(navaid.vorplannedinspection).format('yyyy-MM-DD') : null,
      "vorplannedremoval": navaid.vorplannedremoval != null ? moment(navaid.vorplannedremoval).format('yyyy-MM-DD') : null,
      "vortype": navaid.vortype,
      "sectorizations": navaid.sectorizations,
      "actualScreeningAngle": navaid.actualScreeningAngle,
      "inspectionRepPath": {},
      "antennaDiagramPath": {},
      "vorInspectionRepPaths": []

      //cable loss nor present
    }

    return navaidPayload;
  }

  fillCalculationsID() {
    let result = this.http.get<CalculationModel[]>(
      this.endpointService.previousCalculations,
      this.endpointService.httpOptions
    );

    let thisVar = this;
    result.subscribe((calculations) =>
      calculations.forEach(function (calculation) {
        if (
          thisVar
            .getCalculationsLayer()
            .childLayers.findIndex((x) => x.calcID == calculation.id) < 0
        ) {
          let index = thisVar
            .getCalculationsLayer()
            .childLayers.findIndex((x) => x.calcID == -1);
          if (index != -1) {
            thisVar.getCalculationsLayer().childLayers[
              index
            ].calcID = calculation.id;
          }
        }
      })
    );
  }
  loadSAAMTrafficLayer() {
    const saamtrafficstring = localStorage.getItem("SaamTrafficLayer");
    if (saamtrafficstring == null || saamtrafficstring == '{}') {
      return;
    }
    this.addSAAMAirSpaceToMap(JSON.parse(saamtrafficstring));
  }



  //#region GRIT

  /*
  *@params Coordinate
  *@return Elevation in meters
  */
  async gritGetTerrainElevation(coordLonLat: Coordinate) : Promise<number> {
    return new Promise<number>((resolve, error) => {
      this.calculateTerrainHeightAtPoint(coordLonLat).subscribe({
        next : (terrainInformation) => {
          if (terrainInformation == null) resolve(0);
          else resolve(Number(terrainInformation["terrainHeigth"]))
        },
        error : (error) => {
          resolve(-1);
        }
      })
    })
  }

  async getGritSelected<T extends GritModel<T>>(type: FeatureType, mode: GritDynamicTableMode = null): Promise<GritFeature<T>[]>{
    return new Promise<GritFeature<T>[]>( (resolve)  => {
      let selectedFeatures = this.getSelectedFeatures()
        .filter((feature:GritFeature<T>) =>{
          if(feature.featureType != type) return false;

          else if(Object.getOwnPropertyDescriptor(feature.entity,"projectId"))
            return feature.entity["projectId"] == this.projectService.activeProject.id

          else return true;
        }) as GritFeature<T>[];

      if(selectedFeatures.length == 1 || mode == null){
        return resolve(selectedFeatures);

      } else if(selectedFeatures.length > 1){
        const bsModalRef : BsModalRef = this.popupService.show(SelectFeaturesComponent);
        bsModalRef.content.features = selectedFeatures;
        bsModalRef.content.mode = mode

        return bsModalRef.content.onClose.subscribe((results: GritFeature<T>[]) => {
          if(results.length == 0){
            this.modalService.showMesssageModal("Warning", "Select at least one.");
            return resolve(null);
          }

          return resolve(results);
        })
      }else{
        this.modalService.showMesssageModal("Warning", "Select at least one.");
      }

      return resolve(null);
    });
  }

  getGritLayer(type: FeatureType) : ParentLayers{
    switch (type){
      case FeatureType.Device:
        return this.deviceLayer;
      case FeatureType.InterferenceTest:
        return this.interferenceTestLayer;
      case FeatureType.Radar:
        return this.radarLayer;
      default:
        return null;
    }
  }

  getGritFeatures<T extends GritModel<any>>(type: FeatureType): GritFeature<T>[]{
    let features : GritFeature<T>[] = []

    this.getGritLayer(type)?.childLayers.forEach(childLayer =>{
      childLayer.layers.forEach((layer, index) => {
        if(type == FeatureType.InterferenceTest && index == 0) return;

        features.push(...layer.olLayer.getSource().getFeatures() as GritFeature<T>[]);
      })
    })

    if(features.length > 0 && Object.getOwnPropertyDescriptor(features[0].entity,"interferenceTestId")){
      features = features.filter(feature => feature.entity["interferenceTestId"] == this.interferenceTestService.projectInterferenceTest.id)
    }

    return features;
  }

  private addGritModelToMap(layer: VectorLayerDMTR, model: GritModel<any>){
    let source = layer.getSource();
    let feature = model.createFeature(layer, this.mapService.getMaps().getView().getProjection())

    let existingFeature = source.getFeatureById(feature.getId()) as GritFeature<any>;
    if (existingFeature){
      existingFeature.setGeometry(feature.getGeometry());
      existingFeature.entity = feature.entity
    }
    else{
      source.addFeature(feature);
    }

    return;
  }

  public clearGritFeaturesFromLayer(type : FeatureType){
    switch (type){
      case FeatureType.Device:
        this.deviceLayer.childLayers[0].layers.forEach(layer => layer.olLayer.getSource().clear())
        break;
      case FeatureType.InterferenceTest:
        this.interferenceTestLayer.childLayers[0].layers.forEach(layer => layer.olLayer.getSource().clear())
        break;
      case FeatureType.Radar:
        this.radarLayer.childLayers[0].layers.forEach(layer => layer.olLayer.getSource().clear())
        break;
      default:
        return;
    }

    this.selectedFeatures = this.selectedFeatures.filter((feature: GritFeature<any>) => feature.featureType !== type);
  }

  public removeGritFeaturesFromMap(features: GritFeature<any>[]){
    features.forEach(feature => {
      feature.layer.getSource().removeFeature(feature);
      if(this.getSelectedFeatures().includes(feature)){
        this.removeSelectedFeature(feature);
      }
    })
  }

  //#region Device
  public addDevicesToMap(devices : InterferenceTestDeviceModel[]){
    let layer : VectorLayerDMTR = null;

    devices.forEach(itDevice => {
      if (itDevice.device.type.startsWith("Jammer")){
        layer = this.deviceLayer.childLayers[0].layers[0].olLayer;
      }
      else if(itDevice.device.type.startsWith("Spoofer")){
        layer = this.deviceLayer.childLayers[0].layers[1].olLayer;
      }
      else{
        return;
      }

      this.addGritModelToMap(layer, itDevice);
    });
  }

  public fetchAndAddDevices(): void {
    this.uiBlock.startBlock("Adding devices to map...");

    this.gritAPIService.itDeviceGetAll().then(
      (devices) => this.addDevicesToMap(devices),
      (error) => console.log(error)
    );

    this.uiBlock.stopBlock();
  }
  //endregion

  //#region Interference Test
  addInterferenceTestsToMap(interferenceTests : InterferenceTestModel[]){
    let layer : VectorLayerDMTR = null;
    let now = new Date().getTime();

    let filters = this.userSettingsService.userSettings.interferenceTestSettings.filters.map(filter => new GritFilter().fromDto(filter))
    interferenceTests = interferenceTests.filter(interferenceTest => {
      let result = true;
      for (let filter of filters){
        result &&= filter.apply(interferenceTest)
        if(!result) break;
      }
      return result
    })

    interferenceTests.forEach(interferenceTest => {
      switch (interferenceTest.state){
        case InterferenceTestModelStates.Approval:
          layer = this.interferenceTestLayer.childLayers[0].layers[1].olLayer;
          break

        case InterferenceTestModelStates.Approved:{
          if(interferenceTest.dateStart >= now){
            layer = this.interferenceTestLayer.childLayers[0].layers[2].olLayer;
          }else{
            layer = this.interferenceTestLayer.childLayers[0].layers[3].olLayer;
          }
          break;
        }

        default:
          return;
      }

      this.addGritModelToMap(layer, interferenceTest);
    })
  }

  addProjectInterferenceTestToMap(interferenceTest: InterferenceTestModel) : void {
    let layer = this.interferenceTestLayer.childLayers[0].layers[0].olLayer;

    this.addGritModelToMap(layer, interferenceTest);
  }

  getInterferenceTestFeature(id: number) : GritFeature<InterferenceTestModel>{
    for (let layer of this.interferenceTestLayer.childLayers[0].layers){
      let feature = layer.olLayer.getSource().getFeatureById(id);
      if (feature != null) return feature as GritFeature<InterferenceTestModel>;
    }

    return null;
  }

  clearOtherInterferenceTestFromMap() {
    this.interferenceTestLayer.childLayers[0].layers.forEach((layer, i) =>{
      if(i == 0) return;
      layer.olLayer.getSource().clear()
    })

    this.deviceLayer.childLayers[0].layers.forEach(layer =>{
      let source = layer.olLayer.getSource();
      let features = source.getFeatures().filter((feature: GritFeature<InterferenceTestDeviceModel>) =>{
        return feature.entity.interferenceTestId != this.interferenceTestService.projectInterferenceTest?.id;
      }) as GritFeature<DeviceModel>[];
      this.removeGritFeaturesFromMap(features)
    })

    let calculationLayers = this.calculationsLayers.childLayers.filter(layer => layer.calcID == -1);
    calculationLayers.forEach(layer => {
      let i = this.calculationsLayers.childLayers.indexOf(layer);
      if(i == -1) return;
      this.calculationsLayers.childLayers[i].removeFromMap();
      this.calculationsLayers.childLayers.splice(i, 1)
    })
  }

  fetchAndAddInterferenceTest(): void {
    this.uiBlock.startBlock("Adding interference tests to map...");

    this.gritAPIService.interferenceTestGetAll().then(
      (interferenceTests) => {
        this.addInterferenceTestsToMap(interferenceTests)
      },
      (error) => console.log(error)
    ).finally(() => this.uiBlock.stopBlock());
  }
  //endregion


  //#region Radar
  public addRadarsToMap(radars : RadarModel[]){
    let layer : VectorLayerDMTR = null;

    let filters = this.userSettingsService.userSettings.radarsSettings.filters.map(filter => new GritFilter().fromDto(filter))
    radars = radars.filter(radar => {
      let result = true;
      for (let filter of filters){
        result &&= filter.apply(radar)
        if(!result) break;
      }
      return result
    })

    radars.forEach(radar => {
      switch (this.gritUserService.isOriginator(radar.groupOriginator)){
        case false:
          layer = this.radarLayer.childLayers[0].layers[0].olLayer;
          break;
        case true:
          layer = this.radarLayer.childLayers[0].layers[1].olLayer;
          break;
      }

      this.addGritModelToMap(layer, radar);
    });
  }

  public fetchAndAddRadars(): void {
    this.uiBlock.startBlock("Adding radars to map...");

    this.gritAPIService.radarGetAll().then(
      (radars) => this.addRadarsToMap(radars),
      (error) => console.log(error)
    );

    this.uiBlock.stopBlock();
  }
  //endregion

  //endregion
}
